window.leotriplet = window.leotriplet || {};

leotriplet.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

leotriplet.Sections.prototype = _.assignIn({}, leotriplet.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');
    constructor = constructor || this.constructors[type];
    if (_.isUndefined(constructor)) {
      return;
    }
    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });
    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;
      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },


  _onSelect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});


leotriplet.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };
  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };
  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];
    if (!library) return;
    if (library.status === status.requested) return;
    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }
    library.status = status.requested;
    var tag;
    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }
    tag.id = library.tagId;
    library.element = tag;
    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();



/*---------------------------------------------------------------------------------*/
/*------------------------------------ Common Slider -------------------------------*/
/*---------------------------------------------------------------------------------*/

var slickCarousel = '.leotriplet-slick-slider';
	$(slickCarousel).each(function() {
		var $element = $(this),
			nav = $element.data('nav'),
			dots = $element.data('dots'),
			draggable = $element.data("draggable") ? false : true ,
			fade = $element.data("fade") ? true : false ,
			center = $element.data('center'),
			infinite = $element.data('infinite'),
			autoplay = $element.data('autoplay'),
			autoplaySpeed = $element.data('autoplayspeed'),
			slidesToScroll = $element.data("slidestoscroll"),
			column__xxl = $element.data("column-xxl"),
			column__xl = $element.data("column-xl"),
			column__lg = $element.data("column-lg"),
			column__md = $element.data("column-md"),
			column__sm = $element.data("column-sm"),
			column__xs = $element.data("column-xs"),
			asNavFor = $element.data("asnavfor") ? $element.data("asnavfor") : false ,
			rows = $element.data('rows');
		var config = {
			draggable: draggable,
			fade: fade,
			asNavFor: asNavFor,
			arrows: nav,
			slidesToShow: column__xxl,
			slidesToScroll: slidesToScroll,
			responsive: [
				{
					breakpoint: 1441,
					settings: {
						slidesToShow: column__xl,
						slidesToScroll: slidesToScroll,
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: column__lg,
						slidesToScroll: slidesToScroll,
					}
				},				
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: column__md,
						slidesToScroll: slidesToScroll,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: column__sm,
						slidesToScroll: slidesToScroll,
						vertical: false,
						verticalSwiping : false,
					}
				},
				{
					breakpoint: 480,			  
					settings: {
						slidesToShow: column__xs,
						slidesToScroll: slidesToScroll,
						vertical: false,
						verticalSwiping : false,
					}
				}
			]
		};
		(center === undefined || center == null || center != true) ? config.centerMode = false : config.centerMode = true;
		(dots === undefined || dots == null || dots != true) ? config.dots = false : config.dots = true;
		(infinite === undefined || infinite == null || infinite != true) ? config.infinite = false : config.infinite = true;
		if (autoplay) {
			config.autoplay = autoplay;
			config.autoplaySpeed = autoplaySpeed;
		}
		if (rows !== undefined && rows != null && rows != 1) {
			config.rows = rows;
			config.slidesPerRow = columnone;
			config.slidesToShow = 1,
			config.responsive = [
				{
					breakpoint: 1025,
					settings: {
						slidesPerRow: columntwo,
						slidesToShow: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesPerRow: columnthree,
						slidesToShow: 1
					}
				}
			]
		} else {
			config.rows = 0;
		}
		$element.slick(config);
	});


	$('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
		$('.leotriplet-slick-slider').slick('setPosition');
	})

	leotriplet.slick_mobile = function() {
		if ($(window).width() < 768) {
			$('.leotriplet-load-slick-mobile').each(function() {
				$(this).slick({
					infinite: false,
					slidesToShow: $(this).data('column-sm'),
					slidesToScroll: $(this).data('column-sm'),
					arrows : $(this).data('nav'),
					dots : $(this).data('dot'),
					autoplay: $(this).data('autoplay'),
					autoplaySpeed: 5000,
					responsive: [
						{
							breakpoint: 480,			  
							settings: {
								slidesToShow: $(this).data("column-xs"),
								slidesToScroll: $(this).data("column-xs")
							}
						}
					]
				});
			});
		}

        $('.leotriplet-testimonial-carousel .cr-block-list').each(function() {
            $(this).slick({
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows : $(this).data('nav'),
                dots : true,
                autoplay: $(this).data('autoplay'),
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 991,			  
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
	}



/*---------------------------------------------------------------------------------*/
/*------------------------------- Single Product Page -----------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.variables = {
  productPageLoad: false,
  productPageSticky: true,
  mediaTablet: 'screen and (max-width: 1023px)',
  mediaMobile: 'screen and (max-width: 767px)',
  isTablet: false,
  isMobile: false
};


leotriplet.Variants = (function() {
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.productSelectOption = options.productSelectOption;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
	 
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          }
        }
      );
      currentOptions = _.compact(currentOptions);
      return currentOptions;
    },

    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      if ($('[data-single-option-button]', this.$container).length) {
        this._updateVariantsButton();
        if (!variant || !variant.available) {
          this._updateVariantsButtonDisabed();
          return;
        }
      }

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) return;

      this._updateMasterSelect(variant);
      this._updateMedia(variant);
      this._updatePrice(variant);
			this._updateQuantity(variant);
			this._updateOption(variant);
			this._updatePricesticky(variant);
			this._updateSKU(variant);
			this._updateLabelvariant(variant);
			this.currentVariant = variant;
			this._updatePickUp(variant);
			this._updateBtnText(variant);
			this._updateDelivery(variant);
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateVariantsButtonDisabed: function() {
      for (var i = 2; i <= 3; i++) {
        if ($(this.productSelectOption + i, this.$container).length) {
          var isUpdate = false;
          $(this.productSelectOption + i + ' ' + this.singleOptionSelector, this.$container).each(function() {
            var $element = $(this);
            var type = $element.attr('type');
            if (type === 'radio' || type === 'checkbox') {
              if (this.checked && $element.hasClass('disabled')) {
                $element.prop('checked', false);
                isUpdate = true;
                return false;
              }
            }
          });
          $(this.productSelectOption + i + ' ' + this.singleOptionSelector, this.$container).each(function() {
            var $element = $(this);
            var type = $element.attr('type');
            if (isUpdate && (type === 'radio' || type === 'checkbox') && !$element.hasClass('disabled')) {
              $element.prop('checked', true);
              isUpdate = false;
              $element.trigger('change');
              return false;
            }
          });
        }
      }
    },

    _updateVariantsButton: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      for (var i = 2; i <= 3; i++) {
        if ($(this.productSelectOption + i, this.$container).length) {
          $(this.productSelectOption + i + ' ' + this.singleOptionSelector, this.$container).each(function() {
            var $self = $(this);
            var optionValue = $self.val();
            var foundIndex;
            if (i === 2) {
              foundIndex = _.findIndex(variants, function(variant) {
                return variant.option1 === selectedValues[0].value &&
                  variant.option2 === optionValue &&
                  variant.available === true;
              });
            } else if (i === 3) {
              foundIndex = _.findIndex(variants, function(variant) {
                return variant.option1 === selectedValues[0].value &&
                variant.option2 === selectedValues[1].value &&
                  variant.option3 === optionValue &&
                  variant.available === true;
              });
            }
            if (foundIndex !== -1) {
              $self.removeAttr('disabled', 'disabled').removeClass('disabled');
              $self.next('label').removeClass('disabled');
            } else {
              $self.attr('disabled', 'disabled').addClass('disabled');
              $self.next('label').addClass('disabled');
            }
          });
        }
      }
    },

    _updateMedia: function(variant) {
			var variantMedia = variant.featured_media || {};
			var currentVariantMedia = this.currentVariant.featured_media || {};
			var isMatchingPreviewImage = false;
			if (variantMedia.preview_image && currentVariantMedia.preview_image) {
				isMatchingPreviewImage = variantMedia.preview_image.src === currentVariantMedia.preview_image.src;
			}
			if (!variant.featured_media || isMatchingPreviewImage) return;
			this.$container.trigger({
				type: 'variantMediaChange',
				variant: variant
			});
		
    },

    _updatePrice: function(variant) {
		if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
		if (
			variant.price === this.currentVariant.price &&
			variant.compare_at_price === this.currentVariant.compare_at_price
		){
			return;
		}
		this.$container.trigger({
			type: 'variantPriceChange',
			variant: variant
		});
    },
	
	_updateQuantity: function(variant){
		if( $(".single-product .content-variant_inventory").length > 0 ){
			setTimeout(function(){ $( ".single-product .content-variant_inventory" ).load(window.location.href + ".content-variant_inventory .js-product-available" ); }, 10);
		}
	},
	
	_updateOption: function(){ 
		setTimeout(function(){ $( "#option-selector" ).load(window.location.href + " #option-selector" ); }, 10);
	},
	
	_updatePricesticky: function(){ 
		setTimeout(function(){ $( "#price-sticky" ).load(window.location.href + " #price-sticky" ); }, 10);
	},
	
    _updateSKU: function(variant) {
		if (variant.sku === this.currentVariant.sku) {
			return;
		}
		this.$container.trigger({
			type: 'variantSKUChange',
			variant: variant
		});
    },
	_updateLabelvariant: function(variant) {
		var $element = $('.single-product .single-product--form .variants-wrapper')
		$('.single_multi_slider').removeClass('active');
		$($element).each(function() {
			var $this = $(this);
			if( $("select",$this).length > 0 ){
				var value = $( "select",$this).find(':selected').val();
			}else{
				var value = $('input:checked',$this).attr('value');
			}
			$('.variants__label span',$this).html(value);
			$('.single_multi_slider.'+ value +'').addClass('active');
		});
    },
    _updateHistoryState: function(variant) {
		if (!history.replaceState || !variant) {
			return;
		}
		var newurl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			'?variant=' +
			variant.id;
		window.history.replaceState({path: newurl},'',newurl
		);
		if( $(".single-product #buy_more_form").length > 0 ){
			$('#buy_more_form input[name="items[][id]"]').attr('value',variant.id);
		}
    },
	
	_updatePickUp: function(variant) {
		if( $(".single-product .product-single__pick_up").length > 0 ){
			$('.single-product .product-single__pick_up').addClass('load-pick_up').css("height", $('.single-product .product-single__pick_up').height() + 'px');
			$(".single-product .product-single__pick_up").empty();
			leotriplet.pick_up(variant.id);
			setTimeout(function(){
				$('.single-product .product-single__pick_up').removeClass('load-pick_up').removeAttr('style');
			}, 1000);
		}
    },
	_updateBtnText: function(variant) {
		if( $(".single-product .single_product_info--buttons .btn--add-to-cart .btn__text").length > 0 ){
			setTimeout(function(){ $( ".single-product .single_product_info--buttons .btn--add-to-cart" ).load(window.location.href + " .btn__text" ); }, 10);
		}
		if( $(".sticky-cart-single").length > 0 ){
			setTimeout(function(){ $( ".sticky-cart-single .btn--add-to-cart" ).load(window.location.href + " .btn__text" ); }, 10);
		}
    },
	_updateDelivery: function(variant) {
		if( $(".single-product .estimated_delivery").length > 0 && $(".single-product .section-estimated_delivery[data-incoming]").length > 0 ){
			$('.single-product .section-estimated_delivery').addClass('load-delivery').css("height", $('.single-product .section-estimated_delivery').height() + 'px');
			setTimeout(function(){
				$( ".single-product .section-estimated_delivery" ).load(window.location.href + ".single-product .estimated_delivery" );				
			}, 10);
			setTimeout(function(){
				if( $(".single-product .time_hour").length > 0 ){
					leotriplet.time_estimated_delivery();
				}
			}, 1200);
			setTimeout(function(){
				if( $(".single-product .time_hour").length > 0 ){
					$('.single-product .section-estimated_delivery').removeClass('load-delivery').removeAttr('style');
				}
			}, 1400);
		}
    },
    _updateMasterSelect: function(variant) {
		$(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

leotriplet.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};
  var selectors = {
    productMediaGroup: '.product-gallery-images',
    productMediaGroupWrapper: '.single-product-gallery',
    xrButton: '[data-shopify-xr]',
    xrButtonSingle: '[data-shopify-xr-single]'
  };

  var classes = {
    viewInSpaceDisabled: 'product-single__view-in-space--disabled'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');
      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest(selectors.productMediaGroupWrapper)
          .find(selectors.xrButtonSingle);

        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      }
    ]);

    if (models.length < 1) return;
    window.Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    leotriplet.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function(event) {
        if (event.detail.shopifyXREnabled) {
          setupShopifyXr();
        } else {
          $(selectors.xrButton).addClass(classes.viewInSpaceDisabled);
        }
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];
        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);
        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    var $productMediaGroup = model.$container.closest(
      selectors.productMediaGroup
    );

    model.$element
      .on('shopify_model_viewer_ui_toggle_play', function() {
        leotriplet.updateSlickSwipe($productMediaGroup, false);
      })
      .on('shopify_model_viewer_ui_toggle_pause', function() {
        leotriplet.updateSlickSwipe($productMediaGroup, true);
      });

    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      model.modelViewerUi.play();
    });

    model.$container
      .on('mediaHidden', function() {
        xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

function onYouTubeIframeAPIReady() {
  leotriplet.ProductVideo.loadVideos(leotriplet.ProductVideo.hosts.youtube);
}

leotriplet.ProductVideo = (function() {
  var videos = {};
  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };
  var selectors = {
    productMediaWrapper: '.leotriplet-product-image',
    productMediaGroup: '.product-gallery-images',
  };
  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer.length) {
      return;
    }
    var videoElement = videoContainer.find('iframe, video')[0];
    var mediaId = videoContainer.data('mediaId');
    if (!videoElement) {
      return;
    }
    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };
    var video = videos[mediaId];
    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.1',
            onLoad: setupPlyrVideos
          }
        ]);
        leotriplet.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        leotriplet.LibraryLoader.load('youtubeSdk');
        break;
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }
    loadVideos(hosts.html5);
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }
    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );
    var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);
    switch (video.host) {
      case hosts.html5:
        video.player = new Shopify.Plyr(video.element, {
          loop: { active: enableLooping }
        });
        var $productMediaGroup = $(video.container).closest(
          selectors.productMediaGroup
        );
        video.player.on('seeking', function() {
          leotriplet.updateSlickSwipe($productMediaGroup, false);
        });
        video.player.on('seeked', function() {
          leotriplet.updateSlickSwipe($productMediaGroup, true);
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.data(attributes.videoId);
        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            }
          }
        });
        break;
    }

    productMediaWrapper.on('mediaHidden xrLaunch', function() {
      if (!video.player) return;
      if (video.host === hosts.html5) {
        video.player.pause();
      }
      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    });

    productMediaWrapper.on('mediaVisible', function() {
      if (!video.player) return;
      if (video.host === hosts.html5) {
        video.player.play();
      }
      if (video.host === hosts.youtube && video.player.playVideo) {
        video.player.playVideo();
      }
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }
    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.nativeVideo) continue;
        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();



leotriplet.Product = (function() {
	function Product(container) {
		var $window = $(window);
		var $container = (this.$container = $(container));
		var sectionId = $container.attr('data-section-id');
		this.settings = {
			productPageLoad: false,
			preloadImage: false,
			enableHistoryState: $container.data('enable-history-state'),
			namespace: '.productSection',
			sectionId: sectionId
		};
		this.selectors = {
			productMediaGroup: '.product-gallery-images',
			productMediaGroupItem: '.leotriplet-product-gallery-item',
			productMediaWrapper: '.leotriplet-product-image',
			productMediaTypeModel: '[data-product-media-type-model]',
			productMediaTypeVideo: '[data-product-media-type-video]',
			productThumbnails: '.product-gallery-thumbnails',
			buyTogether: '.buy-together-products',
			productThumbnail: '[data-product-thumbnail]',
			productImageZoom: '[data-mfp-src]',
			meta: '.product-single__meta',
			productWrapper: '.product-single',
			productSelectOption: '.single-product--select-option--',
			originalSelectorId: '.js-product-select',
			singleOptionSelector: '.leotriplet-select-variant',
			slickDots: '[data-slick-dots]',
			slickNext: '[data-slick-next]',
			slickPrevious: '[data-slick-previous]',
			variantColor: '[data-color]',
		};
		this.classes = {
			hide: 'd-none',
			priceContainerUnitAvailable: 'price-container--unit-available',
			productInventoryInStock: 'product-available__text--instock',
			productInventoryOutStock: 'product-available__text--outstock',
		};
		this.slickMediaSettings = {
		  slide: this.selectors.productMediaGroupItem,
		  rows: 0,
		  accessibility: true,
		  arrows: true,
		  appendDots: this.selectors.slickDots,
		  prevArrow: this.selectors.slickPrevious,
		  nextArrow: this.selectors.slickNext,
		  dots: true,
		 
		  infinite: $(this.selectors.productMediaGroup).data('infinite') ? true : false,
		  draggable: $(this.selectors.productMediaGroup).data('draggable') ? true : false,
		  adaptiveHeight: true,
		  fade: $(this.selectors.productMediaGroup).data('fade') ? true : false,
		  customPaging: function(slick, index) {
			var slideA11yString = leotriplet.strings.productSlideLabel
			  .replace('[slide_number]', index + 1)
			  .replace('[slide_max]', slick.slideCount);

			var mediaA11yString = $(
			  '[data-slick-index="' + index + '"]',
			  this.$container
			).data('slick-media-label');

			var ariaCurrent = index === 0 ? ' aria-current="true"' : '';
			return (
			  '<a href="javascript:void(0)' +
			  '" aria-label="' +
			  slideA11yString +
			  ' ' +
			  mediaA11yString +
			  '" aria-controls="slick-slide0' +
			  index +
			  '"' +
			  ariaCurrent +
			  '></a>'
			);
		  }.bind(this)
		};
		if (!$('#ProductJson-' + sectionId).html()) {
		  return;
		}
		this.productSingleObject = JSON.parse(
		  document.getElementById('ProductJson-' + sectionId).innerHTML
		);

		this.zoomType = $container.data('image-zoom-type');
		this.isStackedLayout = $container.data('stacked-layout');
		this.isNothumLayout = $container.data('nothum');
		this.focusableElements = [
		  'iframe',
		  'input',
		  'button',
		  'video',
		  '[tabindex="0"]'
		].join(',');

		this.slickThumbsSettings = {
			slidesToShow: $(this.selectors.productThumbnails).data('columns'),
			slidesToScroll: 1,
			rows: 0,
			accessibility: true,
			arrows: true,
			dots: true,
			infinite: false,
			focusOnSelect: true,
			adaptiveHeight: true,
			rtl: ($('body').hasClass("rtl") && !$(this.selectors.productThumbnails).data('vertical')) ? true : false ,
			vertical: $(this.selectors.productThumbnails).data('vertical') ? true : false,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 4,
						vertical: false,
					}
				},
			]
		};

		if (!this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container)) {
			this.slickMediaSettings.asNavFor = this.selectors.productThumbnails + '-' + sectionId;
			this.slickThumbsSettings.asNavFor = this.selectors.productMediaGroup + '-' + sectionId;
		}else{
			if ($(window).width() < 991 && $(this.selectors.productWrapper).data('thumbnail_layout') == 'sticky_layout') {
				this.slickMediaSettings.asNavFor = this.selectors.productThumbnails + '-' + sectionId;
				this.slickThumbsSettings.asNavFor = this.selectors.productMediaGroup + '-' + sectionId;
			}
		}
		this.view_gallery_product();
		this.initBreakpoints();
		this.initProductVariant();
		this.initModelViewerLibraries();
		this.initShopifyXrLaunch();
		this.initProductVideo();
		this.sticky_layout1();
		this.leotriplet_media_360();
		this.single_product_tab_info();
		
		
		var $element = $(".product-single");
		var _data = $element.data();
		$('.product-single__video img').css("width",$(".product-single__thumbnail img").width());
		$('.product-single__video img').css("height",($(".product-single__thumbnail img").height() - 2.5));
		$window
		  .on('load' + this.settings.namespace, leotriplet.initStickyProductMeta)
		  .on(
			'resize' + this.settings.namespace,
			leotriplet.debounce(this.initStickyProductMeta, 150).bind(this)
		  );
	}
  Product.prototype = _.assignIn({}, Product.prototype, {
  initBreakpoints: function() {
		var self = this;
		if (!self.isStackedLayout) {
			self.createMediaCarousel();
			self.createThumbnailCarousel();
		} else {
			if ($(window).width() < 991) {
				self.createMediaCarousel();
				self.createThumbnailCarousel();
			}else{
				enquire.register(leotriplet.variables.mediaMobile, {
					match: function() {
						self.createMediaCarousel();
					},
					unmatch: function() {
						self.destroyMediaCarousel();
					}
				});
			}
		}
  },
  initProductVariant: function() {
		var options = {
			$container: this.$container,
			enableHistoryState: this.settings.enableHistoryState || false,
			productSelectOption: this. selectors.productSelectOption,
			singleOptionSelector: this.selectors.singleOptionSelector,
			originalSelectorId: this.selectors.originalSelectorId + '--' + this.settings.sectionId,
			product: this.productSingleObject
		};
		var count = $(this.selectors.productThumbnails, this.$container).data('columns');
		this.variants = new leotriplet.Variants(options);
		var featured_media = this.variants.currentVariant.featured_media;
		if(!$('.single-product-gallery').hasClass('no-variants') && !$('.single-product-gallery >.row').hasClass('single_multi_slider') && featured_media ){
			this.showVariantMedia(this.variants.currentVariant,true);
		}
		this.$container.on('variantChange' + this.settings.namespace,this.productPage.bind(this));
		this.$container.on('variantMediaChange' + this.settings.namespace,this.showVariantMedia.bind(this));
		if(this.variants.product.media.length <= count){
			$(this.selectors.productThumbnails, this.$container).addClass('no-transform');
		}
  },
  initModelViewerLibraries: function() {
      if (!this.$container.data('has-model')) return;
      var $modelViewerElements = $(
        this.selectors.productMediaTypeModel,
        this.$container
      );
      leotriplet.ProductModel.init($modelViewerElements, this.settings.sectionId);
  },
	initShopifyXrLaunch: function() {
      $(document).on(
        'shopify_xr_launch',
        function() {
          var $currentMedia = $(
            this.selectors.productMediaWrapper +
              ':not(.' +
              this.classes.hide +
              ')',
            this.$container
          );
          $currentMedia.trigger('xrLaunch');
        }.bind(this)
      );
  },
  initProductVideo: function() {
      var sectionId = this.settings.sectionId;

      $(this.selectors.productMediaTypeVideo, this.$container).each(function() {
        var $videoContainer = $(this);
        leotriplet.ProductVideo.init($videoContainer, sectionId);
      });
  },
  trapCarouselFocus: function($slider, removeFocusTrap) {
      if (!$slider) return;

      $slider
        .find('.slick-slide:not(.slick-active)')
        .find(this.focusableElements)
        .attr('tabindex', removeFocusTrap ? '0' : '-1');

      $slider
        .find('.slick-active')
        .find(this.focusableElements)
        .attr('tabindex', '0');
  },
	updateCarouselDotsA11y: function(nextSlide) {
      var $dotLinks = $(this.selectors.slickDots).find('a');
      $dotLinks
        .removeAttr('aria-current')
        .eq(nextSlide)
        .attr('aria-current', 'true');
  },
	view_gallery_product: function() {
		$element = $(".single-product");
		$(".leotriplet-img-wrapper.img-wrapper-image",$element).bind("click", function(e) {
			e.preventDefault();
			var groups = $(this).closest('.product-gallery-images');
			var items = [];
			var gallery = [];
			var $j = 0;
			var $i = 0;
			$('.leotriplet-product-gallery-item',groups).each(function(){
				$("img",$(this)).data( "number", $j );
				if($("img",$(this)).data("image") == true){
					var $href = $("img",$(this)).attr("src");
					if($href){
						gallery[$j] = {"href":$href};
						$j++;
					}
				}
			});
			if(gallery){
				$.each( gallery, function( key, value ){
					if( value ){
						items[$i] = {"src":value.href,w: $(".mfp-image",$element).width() * 3,h: $(".mfp-image",$element).height() * 3};
						$i++;
					}
				});
				var pswpElement = document.querySelectorAll('.pswp')[0];
				var options = {
					index: $("img",$(this)).data("number"),
					closeOnScroll: false,
					history: false,
					shareEl: false,
				};
				var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
				gallery.init();
			}
		});
  },
  translateCarouselDots: function(totalSlides, nextSlide, dotStyle) {
      if (totalSlides <= dotStyle.max) {
        return;
      }
      var calculatedTranslateDistance = 0;
      var maxTranslateDistance = (totalSlides - dotStyle.max) * dotStyle.width;
      if (nextSlide >= dotStyle.max - 1) {
        calculatedTranslateDistance =
          (nextSlide + 2 - dotStyle.max) * dotStyle.width;
        calculatedTranslateDistance =
          maxTranslateDistance < calculatedTranslateDistance
            ? maxTranslateDistance
            : calculatedTranslateDistance;
      }
      $(this.selectors.slickDots)
        .find('ul')
        .css('transform', 'translateX(-' + calculatedTranslateDistance + 'px)');
  },
  triggerMediaChangeEvent: function(mediaId) {
      var $otherMedia = $(this.selectors.productMediaWrapper, this.$container);
      $otherMedia.trigger('mediaHidden');

      var $newMedia = $(
        this.selectors.productMediaWrapper,
        this.$container
      ).filter('[data-media-id="' + mediaId + '"]');
      $newMedia.trigger('mediaVisible');
  },
  showVariantMedia: function(evt,check) {
		if(check){
			var variant = evt;
		}else{
			var variant = evt.variant;
		}
      var variantMediaId =
        this.settings.sectionId + '-' + variant.featured_media.id;
      var $newMedia = $(
        this.selectors.productMediaWrapper +
          '[data-media-id="' +
          variantMediaId +
          '"]'
      );
      this.triggerMediaChangeEvent(variantMediaId);

      var mediaIndex;

      if (!leotriplet.variables.isMobile && this.isStackedLayout) {
        mediaIndex = $newMedia.closest('.slick-slide').index();
        if (mediaIndex !== 0 || leotriplet.variables.productPageLoad) {
          if (leotriplet.variables.productPageSticky) {
            $('html, body').animate(
              {
                scrollTop: $newMedia.offset().top
              },
              250
            );
          } else {
            var currentScroll = $(document).scrollTop();
            $newMedia
              .closest(
                $(this.selectors.productMediaGroupItem, this.$container)
              )
              .prependTo(
                $(this.selectors.productMediaGroup, this.$container)
              );
            $(document).scrollTop(currentScroll);
          }
        }
      } else {
        mediaIndex = $newMedia.closest('.slick-slide').data('slick-index');
        if (_.isUndefined(mediaIndex)) {
          return;
        }
        if (mediaIndex !== 0 || leotriplet.variables.productPageLoad) {
          $(this.selectors.productMediaGroup, this.$container).slick(
            'slickGoTo',
            mediaIndex
          );
        }
      }

      if (!leotriplet.variables.productPageLoad) {
        leotriplet.variables.productPageLoad = true;
      }
  },
  setFeaturedMedia: function() {
      var mediaId = $(this.selectors.productMediaGroup, this.$container)
        .find('.slick-slide.slick-current.slick-active ' + this.selectors.productMediaWrapper)
        .attr('data-media-id');
      this.triggerMediaChangeEvent(mediaId);
  },
  createMediaCarousel: function() {
		if ( $(this.selectors.productMediaGroupItem).length < 2 || !$(this.selectors.productMediaGroup, this.$container) || this.isCarouselActive ) {
			return; }
		this.isCarouselActive = true;
		var dotStyle = {
			max: 9,
			width: 20
		};
		var focusTrapped = false;
		$(this.selectors.productMediaGroupItem, this.$container).on(
			'focusin',
			function() {
				if (focusTrapped) {
					return;
				}
				this.trapCarouselFocus($(this.selectors.productMediaGroup));
				focusTrapped = true;
			}.bind(this)
		);
		if( $('.single_multi_slider').length > 0 ){
			var sectionId = this.settings.sectionId;
			var $config = this.slickMediaSettings;
			if (!this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container)) {
				var asNavFor = true ;
			}
			$('.single_multi_slider').each(function(index){
				$config['nextArrow'] = $(("[data-slick-next]"),$(this));
				$config['prevArrow'] = $(("[data-slick-previous]"),$(this));
				if (asNavFor) {
					$config['asNavFor'] = '.product-gallery-thumbnails' + '-' + sectionId + '-' + (index+1);
				}
				$('.product-gallery-images', $(this)).slick($config);
			});
		}else{
			$(this.selectors.productMediaGroup, this.$container).slick(this.slickMediaSettings).on('beforeChange',function(event, slick, currentSlide, nextSlide) {
				this.updateCarouselDotsA11y(nextSlide);
				this.translateCarouselDots(slick.slideCount, nextSlide, dotStyle);
			}.bind(this))
		}
  },
  destroyMediaCarousel: function() {
		if ( !$(this.selectors.productMediaGroup, this.$container).length ||
			!this.isCarouselActive ) {
			return;
		}
		this.trapCarouselFocus(
			$(this.selectors.productMediaGroup, this.$container),
			true
		);
		$(this.selectors.productMediaGroup, this.$container).slick('unslick');
		this.isCarouselActive = false;
  },
  createThumbnailCarousel: function() {
		if (
			$(this.selectors.productMediaGroupItem).length < 2 ||
			!$(this.selectors.productMediaGroup, this.$container)
		){
			return;
		}
		if( $('.single_multi_slider').length > 0 ){
			var sectionId = this.settings.sectionId;
			var $configThumb = this.slickThumbsSettings;
			if (!this.isStackedLayout && !this.isNothumLayout && $(this.selectors.productMediaGroup, this.$container) && $(this.selectors.productThumbnails, this.$container)) {
				var asNavFor = true ;
			}
			$('.single_multi_slider').each(function(index){
				if(asNavFor){
					$configThumb.asNavFor = '.product-gallery-images' + '-' + sectionId + '-' + (index+1);
				}
				$('.product-gallery-thumbnails',$(this)).slick($configThumb);
			});
		}else{
			$(this.selectors.productThumbnails, this.$container).slick(this.slickThumbsSettings);
		}
  },
	productPage: function(evt) {
		var moneyFormat = leotriplet.strings.moneyFormat;
		var variant = evt.variant;
		var translations = leotriplet.strings;
		var selectors = {
			addToCart: '.btn--add-to-cart',
			addToCartText: '.btn--add-to-cart .btn__text',
			quantityElements: '.quantity-selector',
			shopifyPaymentButton: '.shopify-payment-button',
			priceContainer: '[data-price-container]',
			productPrice: '.single_product--price',
			priceA11y: '.single-product-price-tk',
			comparePrice: '.single-product-compare-price',
			comparePriceA11y: '.single-product-compare-price-tk',
			comparePriceWrapper: '.single-product-price--info',
			productAvailable: '.js-product-available',
			productAvailableText: '.js-product-available-text',
			unitPrice: '[data-unit-price]',
			unitPriceBaseUnit: '[data-unit-price-base-unit]',
			SKU: '.product-variant--SKU'
		};


      if (variant) {
        $(selectors.priceContainer, this.$container).removeClass(this.classes.hide);
        $(selectors.productAvailable, this.$container).removeClass(this.classes.hide);
        $(selectors.productPrice, this.$container).attr('aria-hidden', 'false');
        $(selectors.priceA11y, this.$container).attr('aria-hidden', 'false');

        if (variant.available) {
          $(selectors.addToCart, this.$container)
            .removeClass('disabled')
            .prop('disabled', false);
          $(selectors.addToCartText, this.$container).html(translations.addToCart);
          $(selectors.productAvailableText)
            .removeClass(this.classes.productInventoryOutStock)
            .addClass(this.classes.productInventoryInStock)
            .html(leotriplet.strings.inStock);
          $(selectors.quantityElements, this.$container).removeClass(this.classes.hide);
          $(selectors.shopifyPaymentButton, this.$container).removeClass(this.classes.hide);
        } else {
          $(selectors.addToCart, this.$container)
            .addClass('disabled')
            .prop('disabled', true);
          $(selectors.addToCartText, this.$container).html(translations.soldOut);
          $(selectors.productAvailableText)
            .removeClass(this.classes.productInventoryInStock)
            .addClass(this.classes.productInventoryOutStock)
            .html(leotriplet.strings.outStock);
          $(selectors.quantityElements, this.$container).addClass(this.classes.hide);
          $(selectors.shopifyPaymentButton, this.$container).addClass(this.classes.hide);
        }

        $(selectors.productPrice, this.$container)
          .html(leotriplet.Currency.formatMoney(variant.price, moneyFormat))
          .removeClass(this.classes.hide);
        if (variant.compare_at_price > variant.price) {
          $(selectors.comparePrice, this.$container).html(
            leotriplet.Currency.formatMoney(variant.compare_at_price, moneyFormat)
          );
          $(selectors.comparePriceWrapper, this.$container).removeClass(this.classes.hide);
          $(selectors.productPrice, this.$container).addClass('on-sale');
          $(selectors.comparePriceWrapper, this.$container).attr('aria-hidden', 'false');
          $(selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'false');
        } else {
          $(selectors.comparePriceWrapper, this.$container)
            .addClass(this.classes.hide)
            .attr('aria-hidden', 'true');
          $(selectors.productPrice, this.$container).removeClass('on-sale');
          $(selectors.comparePrice, this.$container).html('');
          $(selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'true');
        }

        if (variant.unit_price) {
          var $unitPrice = $(selectors.unitPrice, this.$container);
          var $unitPriceBaseUnit = $(
            selectors.unitPriceBaseUnit,
            this.$container
          );
          $unitPrice.html(leotriplet.Currency.formatMoney(variant.unit_price, moneyFormat));
          $unitPriceBaseUnit.html(this.getBaseUnit(variant));
          $(selectors.priceContainer, this.$container).addClass(this.classes.priceContainerUnitAvailable);
        }
        $(selectors.SKU).html(variant.sku != '' ? variant.sku : 'N/A');
      } else {
        $(selectors.addToCart, this.$container)
          .addClass('disabled')
          .prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(translations.unavailable);
        $(selectors.quantityElements, this.$container).addClass(this.classes.hide);
        $(selectors.shopifyPaymentButton, this.$container).addClass(this.classes.hide);
        $(selectors.priceContainer, this.$container).addClass(this.classes.hide);
        $(selectors.productAvailable, this.$container).addClass(this.classes.hide);
        $(selectors.productPrice, this.$container).attr('aria-hidden', 'true');
        $(selectors.priceA11y, this.$container).attr('aria-hidden', 'true');
        $(selectors.comparePriceWrapper, this.$container).attr('aria-hidden', 'true');
        $(selectors.comparePriceA11y, this.$container).attr('aria-hidden', 'true');
      }
  },
	onUnload: function() {
      this.$container.off(this.settings.namespace);
      leotriplet.ProductModel.removeSectionModels(this.settings.sectionId);
      leotriplet.ProductVideo.removeSectionVideos(this.settings.sectionId);
      if (this.isStackedLayout) {
				if ($(window).width() > 991) {
					this.destroyMediaCarousel();
				}
      }
    },
	sticky_layout1: function() {
		if ($(window).width() > 992 && $('.single-product.sticky_layout').length > 0) {
			var $element = $('.single-product.sticky_layout');
			var eventElemArray = [];
			var _count = 0;
			var _countFix = 0;
			var $image_array = $('.product-gallery-images .leotriplet-product-gallery-item',$element);
			$('.product-gallery-thumbnails a',$element).on( "click", function() {
				var $thumb = $(this).data('media-id'),
					$image = $('.product-gallery-images .leotriplet-product-image[data-media-id='+ $thumb +']',$element);
				$( 'html, body' ).animate({ scrollTop: $image.offset().top }, '300' );
				$image.css({ 'padding-top': '15px' });
				$(this).addClass('slick-current');
			});
			$(window).on('load scroll resize',function(){
				eventElemArray = [];
				_count = 0;
				$image_array.each(function(i,pager){
					eventElemArray.push( $(pager).offset().top );
				});
				for(var _i = 0;_i < eventElemArray.length; _i++){
					if( $(window).scrollTop() + ($(window).height() * 0.5) > eventElemArray[_i] ){
						_count++;
					}
				}
				if(_count !== _countFix){
					_countFix = _count;
					$('.product-gallery-thumbnails .product-gallery-thumbnails--group',$element).removeClass('slick-current');
					$('.product-gallery-thumbnails .product-gallery-thumbnails--group',$element).eq(_count-1).addClass('slick-current');
				}
			});
			

			var $content = $('.single-product-gallery',$element);
			var thumb_left = $('.product-gallery-thumbnails',$element).offset.left;
			var thumb_width = $('.product-gallery-thumbnails',$element).width() + 'px';
			var thumb_ToTop = $('.product-gallery-thumbnails',$element).offset().top;
			if( $content.height() > $('.product-gallery-thumbnails',$element).height() ){
				$(window).scroll(function() {
					var windowToTop = $(window).scrollTop();
					var thumb_height = $('.product-gallery-thumbnails',$element).height() + 'px';
					var stopsticky = ( $content.height() + $content.offset().top ) - windowToTop;
					if (windowToTop + 10 > thumb_ToTop) {
						$('.product-gallery-thumbnails',$element).css({
							'position': 'fixed',
							'top': '15px',
							'left': thumb_left,
							'width': thumb_width,
							'height': thumb_height
						});
					} else {
						$('.product-gallery-thumbnails',$element).removeAttr('style');
						$('.product-gallery-images .leotriplet-product-image',$element).removeAttr('style');
					}
					if(stopsticky < $('.product-gallery-thumbnails',$element).height()) {
						$('.product-gallery-thumbnails',$element).css({
							'position': 'absolute',
							'top': ($content.height() - $('.product-gallery-thumbnails',$element).height()) + 'px',
							'left': thumb_left,
							'width': thumb_width,
							'height': thumb_height
						});
					}
				});
			}
		
		}
	},
	leotriplet_media_360: function() {
		if ($('.single-product .leotriplet-360-image').length > 0) {
			$('.single-product .leotriplet-360-image').TreeSixtyImageRotate({
				totalFrames: $('.single-product .leotriplet-360-image').data("count"),
				endFrame: $('.single-product .leotriplet-360-image').data("count")
			}).initTreeSixty();
		}
	},
	single_product_tab_info: function() {
		if ($('.product--template .single_product-tab-info').length > 0) {
			var $parent = $('.product--template .single_product-tab-info');
			if ($(window).width() > 991) {
				$('.single-product-tabs--link').first().addClass('active');
				$('.product-tab-content .tab-pane').first().addClass('show');
				$('.single-product-tabs--link',$parent).on('click', function() {
					var id = $(this).data('id');
					$('.single-product-tabs--link',$parent).removeClass('active');
					$('.product-tab-content .tab-pane',$parent).removeClass('show');
					$(this).addClass('active');
					$('#'+id+'',$parent).addClass('show');
				});
			}else{
				$('.product-tab-content .tab-pane',$parent).removeClass('show');
				$('.single-product-tabs--link',$parent).on('click', function() {
					var id = $(this).data('id');
					$('.product-tab-content .tab-pane',$parent).slideUp();
					$('body,html').animate({
						scrollTop: $(".product-tab-content").offset().top - 50
					}, 600);
					if($(this).hasClass('active')){
						$('#'+id+'',$parent).slideUp();
						$('.single-product-tabs--link',$parent).removeClass('active');
					}else{
						$('#'+id+'',$parent).slideDown();
						$('.single-product-tabs--link',$parent).removeClass('active');
						$(this).addClass('active');
					}
				});
			}
		}
	}
	
});
return Product;
})();




/*---------------------------------------------------------------------------------*/
/*------------------------------------ Search Toggle -------------------------------*/
/*---------------------------------------------------------------------------------*/


$(".header-search-toggle").on( "click", function() {
    if($(".toggle-search").hasClass('active')){
        $(".toggle-search").removeClass('active');
        $("body").removeClass('active_search');	
    }else{
        $(".toggle-search").addClass('active');
        $("body").addClass('active_search');	
    }
});
$("[data-close-search-toggle]").on( "click", function() {
    if($(".toggle-search").hasClass('active')){
        $(".toggle-search").removeClass('active');
        $("body").removeClass('active_search');
    }else{
        $(".toggle-search").addClass('active');		
        $("body").addClass('active_search');
    }
});

/*---------------------------------------------------------------------------------*/
/*------------------------------------ Currency -------------------------------*/
/*---------------------------------------------------------------------------------*/ 


leotriplet.Currency = (function() {
  var moneyFormat = '$';
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  };
})();


/*---------------------------------------------------------------------------------*/
/*--------------------------------- Ajax Search Result ----------------------------*/
/*---------------------------------------------------------------------------------*/


class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this))
    }
  }
  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }
  onFormReset(event) {
    
    event.preventDefault();
    
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define('search-form', SearchForm);




/*---------------------------------------------------------------------------------*/
/*------------------------- Footer Mobile Accordition -----------------------------*/
/*---------------------------------------------------------------------------------*/


if ($('.main-footer').hasClass('accordion')) {
  $('.accordion .footer-column').each(function() {
    var toggle = $('.footer-col-content',$(this));
    $('.title-footer',$(this)).on('click', function() {
			if ($(window).width() < 767) {
				var $parent = $(this).closest('.footer-column');
				$parent.toggleClass('active');
				toggle.slideToggle();
			}
    });
  });
}


/*---------------------------------------------------------------------------------*/
/*------------------------------------ Home Slider -------------------------------*/
/*---------------------------------------------------------------------------------*/


var img_slideshow = '.js-img-slideshow',
    autoplay = $(img_slideshow).data('autoplay'),
    autoplayInterval = $(img_slideshow).data('autoplayinterval'),
    autoplayNavigation = $(img_slideshow).data('navigation'),
    autoplayPagination = $(img_slideshow).data('pagination');
var config = {
    rows: 0,
    arrows: autoplayNavigation,
    autoplay: autoplay,
    autoplaySpeed: autoplayInterval
};
  (autoplayInterval === undefined || autoplayInterval == null) ? true : config.autoplaySpeed = autoplayInterval;
  (autoplayPagination === undefined || autoplayPagination == null || autoplayPagination != true) ? config.dots = false : config.dots = true;

  $(img_slideshow).slick(config);




/*---------------------------------------------------------------------------------*/
/*------------------------------------ QuickView ----------------------------------*/
/*---------------------------------------------------------------------------------*/


	leotriplet.QuickView = (function() {
		var selectors = {
			body: 'body',
			quickView: '[data-quickview]',
			quickViewTemplate: '#template-quickview',
			quickViewBtn: '.leotriplet-qv-btn',
			quickViewReview: '[data-quickview-review]',
			quickViewReview: '[data-quickview-review]',
			quickViewContainer: '[data-quickview-container]',
			quickViewClose: '[data-quickview-close]',
			quickViewImages: '[data-quickview-images]',
			quickviewVariant: '.leotriplet-quickview-option-selector',
			originalSelectorId: '[data-quickview-variant]',
			quickViewQty: '[data-quickview-quantity]',
			quickViewSKU: '[data-quickview-sku]',
			quickViewavailableInStock: '.product-available--instock',
			quickViewavailableOutStock: '.product-available--outstock',
			quickViewProductDetailsURL: '.js-qv-product-details',
			quickViewProductPrice: '.js-qv-product-price',
			quickViewProductPriceCompare: '.js-qv-product-price-compare',
			quickViewavailable: '.product-available'
		};
		function QuickView(container) {
			this.$container = $(container);
			this.cache = {};
			this.productVariants = [];
			this.currentVariant = {};
			this.cacheSelectors();
			this.initializeEvents();
		}
		QuickView.prototype = _.assignIn({}, QuickView.prototype, {
			cacheSelectors: function() {
				this.cache = {
					$body: $('body'),
					$quickViewContainer: this.$container.find(selectors.quickViewContainer)
				};
			},
	
			initializeEvents: function() {
				var $this = this;
				$(selectors.body).on('click', selectors.quickViewBtn, function(e) {
					e.preventDefault();
					var productHandle = $(this).data('handle');
					$(this).addClass('load-quickview');
					$.getJSON('/products/' + productHandle + '.js', function(product) {
						if (product.available) {
						$this.firstAvailableVariant(product.variants, $this);
						} else {
							$this.currentVariant = product.variants[0];
						}
						$(selectors.quickViewBtn).removeClass('load-quickview');
						$this.buildQuickView(product);
						$this.buildMetafields(product);
						$this.renderReview();
						$this.createImageCarousel();
						$('[data-quickview]').addClass('show');
						setTimeout(function(){
							$('[data-quickview]').addClass('show-content');
							$('body').addClass('show-quickView');
						}, 300);
						setTimeout(function(){
							$('[data-quickview]').addClass('transition');
						}, 600);
						var $element = $('.quickview .quickview--variants .variants-wrapper')
						$($element).each(function() {
							var $this = $(this);
							if( $("select",$this).length > 0 ){
								var value = $( "select",$this).find(':selected').val();
							}else{
								var value = $('input:checked',$this).attr('value');
							}
							$('.variants__label span',$this).html(value);
						});
					});
				});
				$(selectors.body).on('click', selectors.quickViewClose, function(e) {
					e.preventDefault();
					$('[data-quickview]').removeClass('transition');
					setTimeout(function(){
						$('[data-quickview]').removeClass('show-content');
						$('body').removeClass('show-quickView');
					}, 400);
					setTimeout(function(){
						$('[data-quickview]').removeClass('show');
					}, 700);
				});
				$(selectors.quickViewContainer).on('change', selectors.quickviewVariant, function(e) {
					$this.onVariantChange();
				});
			},
	
			firstAvailableVariant: function(variants, global) {
				global.productVariants = variants;
				for (var i = 0; i < variants.length; i++) {
					var variant = variants[i];
					if (variant.available) {
						global.currentVariant = variant;
						break;
					}
				}
			},
			buildQuickView: function(product) {
				var moneyFormat = leotriplet.strings.moneyFormat;
				var currentVariant = this.currentVariant;
				var source = $(selectors.quickViewTemplate).html();
				var template = Handlebars.compile(source);
				var images = '';
				var price = '';
				var external='';
				var qvObject = {
					id: product.id
				};
				if (typeof product.media !== 'undefined') {
					images += '<div class="quickview-images__list slick-carousel" data-quickview-images>'
					for (var i = 0; i < product.media.length; i++) {
						var media = product.media[i];
						if (media.media_type === 'image') {
							images += '<div class="slick-carousel__item"><div class="quickview-images__item" data-media-id=' +
								media.id + '><img class="img-fluid" alt="' +
								product.title + '" src="' +
								media.src + '" /></div></div>';
						}
					}
					images += '</div>'
				}
				qvObject.variantID = currentVariant.id;
				qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== '' ? currentVariant.sku : 'N/A';
				qvObject.images = images;
				qvObject.title = product.title;
				qvObject.url = product.url;
				qvObject.vendor = product.vendor;
				price += '<div class="price-container">';
				var productCompareClass = product.compare_at_price !== null ? '' : 'd-none';
				price += '<div class="js-qv-product-price-compare product-single__price--compare-at ' + productCompareClass + '">' + leotriplet.Currency.formatMoney(product.compare_at_price, moneyFormat) + '</div>';
				price += '<div class="js-qv-product-price product-single__price">' + leotriplet.Currency.formatMoney(product.price, moneyFormat) + '</div>';
				price += '</div>';
				qvObject.price = price;
				qvObject.vendor = product.vendor;
				qvObject.type = product.type;
				qvObject.variants = this.buildVariant(product);
				$(selectors.quickViewContainer).html(template(qvObject));
				
				this.updateMedia(currentVariant);
				this.updateSKU(currentVariant);
				this.updateProductavailable(currentVariant);
				this.updateDetailsLink(currentVariant);
				$('#form-simple-addtocart .btn--add-to-cart').on('click',function(e){
					e.preventDefault();
					$(this).removeClass('added');
					$(this).addClass('active');
					let addToCartForm = document.querySelector('#form-simple-addtocart');
					let formData = new FormData(addToCartForm);
					var params = {
						type: 'POST',
						url: '/cart/add.js',
						data: formData,
						processData: false,
						contentType: false,
						dataType: 'json',
						success: function(line_item) {
							$('#form-simple-addtocart .btn--add-to-cart').removeClass('active');
							$('#form-simple-addtocart .btn--add-to-cart').addClass('added');
							setTimeout(function() {
								$('#form-simple-addtocart .btn--add-to-cart').removeClass('added');
							}, 2000);
							ajaxCart.load();
							$('body').addClass('open-cart-drawer');
							$('.cart-js-drawer--close').on('click', function() {
								$('body').removeClass('open-cart-drawer');
							});
						},
						error: function(XMLHttpRequest, textStatus) {
							if (typeof errorCallback === 'function') {
								errorCallback(XMLHttpRequest, textStatus);
							} else {
								ShopifyAPI.onError(XMLHttpRequest, textStatus);
							}
						}
					};
					jQuery.ajax(params);
				});
				if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
			},
			convertToSlug: function(str) {
				return str.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
			},
			buildMetafields: function(product) {
				var this_button = $('.leotriplet-qv-btn[data-handle='+product.handle+']');
				var parent_button = this_button.closest('.product-grid');
				var html = '';
				if(parent_button.data('external')){
					var value = parent_button.data('external');
					$('.quickview-product__buttons').remove();
					html += '<a href="'+ value +'">'+ leotriplet.strings.external +'</a>';
					$(".product-quickview__buttons_external").html(html);
				}
				if(parent_button.data('short_description')){
					var value = parent_button.data('short_description');
					$(".quickview-product .product-quickview__description").html(value);
				}
				if(parent_button.data('countdowns')){
					var countdowns = parent_button.data('countdowns');
					$('.quickview .countdown-quickview').removeClass('hidden');
					html += '<div class="countdown" data-countdown="'+ countdowns +'"></div>';
					$(".countdown-quickview .content").html(html);
					var $this = $('.quickview-product .countdown-quickview .countdown'),
						finalDate = $this.data('countdown'),
						date_final = new Date(finalDate),
						seconds_final = date_final.getTime(),
						date = Date.now(),
						text_day = 'd',
						text_hour = 'h',
						time_min = 'm',
						text_sec = 's';
					if(seconds_final > date){
						$this.countdown(finalDate, function(event) {
							var strTime = '<div class="countdown__item"><span>%D</span><span>' + text_day + '</span></div>' +
							'<div class="countdown__item"><span>%H</span><span>' + text_hour + '</span></div>' +
							'<div class="countdown__item"><span>%M</span><span>' + time_min + '</span></div>' +
							'<div class="countdown__item"><span>%S</span><span>' + text_sec + '</span></div>';
							$this.html(event.strftime(strTime));
						})
						.on('finish.countdown', function() {
							$this.html(leotriplet.strings.countdownFinish);
						});
					}else{
						$('.quickview-product .countdown-quickview').remove();
					}
				}
				if(parent_button.data('is_group_product')){
					if(parent_button.data('group_product')){
						var value = parent_button.data('group_product');
						const group_handle = value.split(',');
						$('.quickview-product .quickview--variants').remove();
						$('.quickview-product .price-container').remove();
						$('#form-simple-addtocart').remove();
						html += '<form method="post" id="group_table_product" action="/cart/add"  enctype="multipart/form-data" novalidate="novalidate"><input type="hidden" name="form_type" value="product"><div class="group_table"></div><div class="product-group__add-to-cart single_product_info--buttons"><button type="submit" class="add-group-to-cart"><span>'+ leotriplet.strings.add_to_cart +'</span></button></div></form>';
						$(".group-quickview").html(html);
						var group = '';
						for (const handle of group_handle) {
							$.getJSON('/products/' + handle + '.js', function(product) {
								console.log(product);
								group+= '<div data-product_id="'+ product.id +'" class="item-product-group">';
									group+= '<div class="product-content">';
										group+= '<div class="product-thumb">';
											group+= '<a href="/product/'+ product.handle +'"><img class="featured-banner__img" src="'+ product.featured_image +'" alt="'+ product.featured_image.alt +'" /></a>';
										group += '</div>';
										group += '<div class="product-info">';
											group += '<h3 class="product-title"><a href="/product/'+ product.handle +'">'+ product.title +'</a></h3>';
											if( product.variants.length > 1){
												group+= '<select name="items[][id]" class="js-product-btp--'+ product.id +' product-single__variants">'
												for (var i = 0; i < product.variants.length; i++) {
													group+= '<option data-price="'+ product.variants[i].price +'" value="'+ product.variants[i].id +'"> '+ product.variants[i].title +' - '+ leotriplet.Currency.formatMoney(product.variants[i].price) +' </option>';
												}
												group+= '</select>';
											}else{
												group += '<div class="product-price">'+ leotriplet.Currency.formatMoney(product.variants[0].price) +'</div><input name="items[][id]" type="hidden" value="'+ product.variants[0].id +'">';
											}
										group += '</div>';
									group += '</div>';
									group+= '<div class="quantity-content">';
										group += '<button type="button" class="quantity-update leotriplet-qty-adjust leotriplet-qty-adjust-minus"><i class="feather-minus"></i></button>';
										group += '<input type="text" name="items[][quantity]" class="quantity-number-input leotriplet-qty__number" value="1" min="0" aria-label="quantity" pattern="[0-9]*">';
										group += '<button type="button" class="quantity-update leotriplet-qty-adjust leotriplet-qty-adjust-plus"><i class="feather-plus"></i></button>';
									group += '</div>';
								group += '</div>';
								$(".group-quickview .group_table").html(group);
							});
						}
						$('#group_table_product .add-group-to-cart').on('click',function(e){
							e.preventDefault();
							$(this).removeClass('added');
							$(this).addClass('active');
							let addToCartForm = document.querySelector('#group_table_product');
							let formData = new FormData(addToCartForm);
							var params = {
								type: 'POST',
								url: '/cart/add.js',
								data: formData,
								processData: false,
								contentType: false,
								dataType: 'json',
								success: function(line_item) {
									$('#group_table_product .add-group-to-cart').removeClass('active');
									$('#group_table_product .add-group-to-cart').addClass('added');
									setTimeout(function() {
										$('#group_table_product .add-group-to-cart').removeClass('added');
									}, 3000);
									ajaxCart.load();
								},
								error: function(XMLHttpRequest, textStatus) {
									if (typeof errorCallback === 'function') {
										errorCallback(XMLHttpRequest, textStatus);
									} else {
										ShopifyAPI.onError(XMLHttpRequest, textStatus);
									}
								}
							};
							jQuery.ajax(params);
						});
					}else{
						$('.quickview-product .quickview--variants').remove();
						$('.quickview-product .price-container').remove();
						$('#form-simple-addtocart').remove();
						html += '<div class="view-gruop-product"><a class="view-gruop-product-btn" href="'+product.url+'"><span>'+ leotriplet.strings.view_group +'</span></a></div>';
						$(".group-quickview").html(html);
					}
				}
			},		
			buildVariant: function(product) {
				var result = '';
				var currentVariant = this.currentVariant;
				if (product.options[0].name !== 'Title') {
					var options = product.options;
					for (var i = 0; i < options.length; i ++) {
						var option = options[i];
						var optionIndex = i + 1;
						var type = 'label';
						var size = leotriplet.settings.size_option;
						if (leotriplet.settings.filter_name_1 === option.name) {
							type = leotriplet.settings.select_filter_1;
						}else if (leotriplet.settings.filter_name_2 === option.name) {
							type = leotriplet.settings.select_filter_2;
						}else if (leotriplet.settings.filter_name_3 === option.name) {
							type = leotriplet.settings.select_filter_3;
						}
						result += '<div class="variants-wrapper product-form--item '+ type +'" data-quickview-variant-option="' + optionIndex + '">';
						result += '<label class="variants__label">' + option.name + ': <span></span></label>';
						result += '<div class="variants__options">';
						if (leotriplet.settings.quickViewVariantType === 'select') {
							result += '<select class="leotriplet-quickview-option-selector productForm--input" data-id="qvOptionSelector-' + optionIndex + '" data-index="option' + optionIndex + '">';
							for (var j = 0; j < option.values.length; j ++) {
								var value = option.values[j];
								result += '<option value="' + _.escape(value) + '" ';
								result += currentVariant.options[i] === value ? 'selected="selected"' : '';
								result += '>' + value + '</option>';
							}
							result += '</select>';
						} else if (leotriplet.settings.quickViewVariantType === 'radio') {
							for (var j = 0; j < option.values.length; j ++) {
								var value = option.values[j];
								var isDisable = true;
								var colorAttribute = '';
								
								for (var k = 0; k < this.productVariants.length; k ++) {
									var variantCondition = this.productVariants[k];
									if (variantCondition.available) {
										if (i == 0 && variantCondition.option1 === value) {
											isDisable = false;
											break;
										} else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
											isDisable = false;
											break;
										} else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
											isDisable = false;
											break;
										}
									}
								}
								
								result += '<div class="variant-option">';
								result += '<input type="radio" data-single-option-button';
								result += currentVariant.options[i] === value ? ' checked ' : ' ';
								if (isDisable) {
									result += 'disabled="disabled"';
								}
								result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
								result += 'class="leotriplet-quickview-option-selector';
								if (isDisable) {
									result += ' disabled';
								}
								result += '" id="quickview-product-option-' + i + '-' + value.toLowerCase() + '">';
								result += '<label class="' + value + '" data-toggle="tooltip" title="' + value + '" for="quickview-product-option-' + i + '-' + value.toLowerCase() + '" ' + colorAttribute;
								if (isDisable) {
									result += ' class="disabled"';
								}
								result += '>' + value + '<span class="d-none"></span></label>';
								result += '</div>';
							}
						}
						result += '</div>';
						result += '</div>';
					}
				}
				return result;
			},
			createImageCarousel: function() {
				$(selectors.quickView).find(selectors.quickViewImages).slick({
					infinite: false,
					rows: 0,
					fade:true
					
				});
			},
			renderReview: function() {
				if (window.SPR && leotriplet.settings.enableReview) {
					if ($(selectors.quickView).find(selectors.quickViewReview).length) {
						return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
					};
				}
			},
			getCurrentOptions: function() {
				var currentOptions = _.map(
					$(selectors.quickviewVariant, selectors.quickViewContainer), function(element) {
						var $element = $(element);
						var type = $element.attr('type');
						var currentOption = {};
						if (type === 'radio' || type === 'checkbox') {
							if ($element[0].checked) {
								currentOption.value = $element.val();
								currentOption.index = $element.data('index');
								return currentOption;
							} else {
								return false;
							}
						} else {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');
							return currentOption;
						}
					}
				);
				currentOptions = _.compact(currentOptions);
				return currentOptions;
			},
			getVariantFromOptions: function() {
				var selectedValues = this.getCurrentOptions();
				var variants = this.productVariants;
				var found = _.find(variants, function(variant) {
					return selectedValues.every(function(values) {
						return _.isEqual(variant[values.index], values.value);
					});
				});
				return found;
			},
			updateVariantsButton: function () {
				var selectedValues = this.getCurrentOptions();
				var variants = this.productVariants;
				for (var i = 2; i <= 3; i++) {
					if ($('[data-quickview-variant-option="' + i + '"]', selectors.quickViewContainer).length) {
						$('[data-quickview-variant-option="' + i + '"] ' + selectors.quickviewVariant, selectors.quickViewContainer).each(function() {
							var $self = $(this);
							var optionValue = $self.val();
							var foundIndex;
							if (i === 2) {
								foundIndex = _.findIndex(variants, function(variant) {
									return variant.option1 === selectedValues[0].value &&
									variant.option2 === optionValue &&
									variant.available === true;
								});
							} else if (i === 3) {
								foundIndex = _.findIndex(variants, function(variant) {
									return variant.option1 === selectedValues[0].value &&
									variant.option2 === selectedValues[1].value &&
									variant.option3 === optionValue &&
									variant.available === true;
								});
							}
							if (foundIndex !== -1) {
								$self.removeAttr('disabled', 'disabled').removeClass('disabled');
								$self.next('label').removeClass('disabled');
							} else {
								$self.attr('disabled', 'disabled').addClass('disabled');
								$self.next('label').addClass('disabled');
							}
						});
					}
				}
			},
			updateVariantsButtonDisabed: function() {
				for (var i = 2; i <= 3; i++) {
					if ($('[data-quickview-variant-option="' + i + '"]', selectors.quickViewContainer).length) {
						var isUpdate = false;
						$('[data-quickview-variant-option="' + i + '"] ' + selectors.quickviewVariant, selectors.quickViewContainer).each(function() {
							var $element = $(this);
							var type = $element.attr('type');
							if (type === 'radio' || type === 'checkbox') {
								if (this.checked && $element.hasClass('disabled')) {
									$element.prop('checked', false);
									isUpdate = true;
									return false;
								}
							}
						});
						$('[data-quickview-variant-option="' + i + '"] ' + selectors.quickviewVariant, selectors.quickViewContainer).each(function() {
							var $element = $(this);
							var type = $element.attr('type');
							if (isUpdate && (type === 'radio' || type === 'checkbox') && !$element.hasClass('disabled')) {
								$element.prop('checked', true);
								isUpdate = false;
								$element.trigger('change');
								return false;
							}
						});
					}
				}
			},
			updateProductavailable: function(variant) {
				var classActive = 'product-available--active';
				var translations = leotriplet.strings;
				$(selectors.quickViewavailable, selectors.quickViewContainer).removeClass(classActive);
				if (variant) {
					if (variant.available) {
						$(selectors.quickViewQty, selectors.quickViewContainer).removeClass('d-none');
						$(selectors.quickViewavailableInStock, selectors.quickViewContainer).addClass(classActive);
					} else {
						$(selectors.quickViewQty, selectors.quickViewContainer).addClass('d-none');
						$(selectors.quickViewavailableOutStock, selectors.quickViewContainer).addClass(classActive);
					}
					
					if (variant.available) {
						$(selectors.quickViewContainer).find('.btn--add-to-cart')
							.removeClass('disabled')
							.prop('disabled', false);
						$(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.addToCart);
					} else {
						$(selectors.quickViewContainer).find('.btn--add-to-cart')
							.addClass('disabled')
							.prop('disabled', true);
						$(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.soldOut);
					}
				} else {
					$(selectors.quickViewQty, selectors.quickViewContainer).addClass('d-none');
					$(selectors.quickViewContainer).find('.btn--add-to-cart')
						.addClass('disabled')
						.prop('disabled', true);
					$(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.unavailable);
				}
			},
			updateMasterSelect: function(variant) {
				if (variant) {
					$(selectors.originalSelectorId, selectors.quickViewContainer).val(variant.id);
				}
			},
			updateMedia: function(variant) {
				$(selectors.quickViewImages,selectors.quickView).on('init', function(event, slick){
					if (variant && variant.featured_media && variant.featured_media.id) {
						$(selectors.quickViewImages, selectors.quickViewContainer).find('.quickview-images__item').each(function() {
							var imageID = $(this).data('media-id');
							if (variant.featured_media.id == imageID) {
								var slickIndex = $(this).closest('.slick-carousel__item').data('slick-index');
								setTimeout(function(){
									if (slickIndex !== undefined && slickIndex !== null) {
										$(selectors.quickViewImages, selectors.quickViewContainer).slick('slickGoTo', slickIndex);
									}
								}, 100);
							}
						});
					}
				});
				if (variant && variant.featured_media && variant.featured_media.id) {
					$(selectors.quickViewImages, selectors.quickViewContainer).find('.quickview-images__item').each(function() {
						var imageID = $(this).data('media-id');
						if (variant.featured_media.id == imageID) {
							var slickIndex = $(this).closest('.slick-carousel__item').data('slick-index');
							if (slickIndex !== undefined && slickIndex !== null) {
								$(selectors.quickViewImages, selectors.quickViewContainer).slick('slickGoTo', slickIndex);
							}
						}
					});
				}
			},
	
			updatePrice: function(variant) {
				var moneyFormat = leotriplet.strings.moneyFormat;
				if (!variant) {
					$(selectors.quickViewProductPrice, selectors.quickViewContainer).addClass('d-none');
					$(selectors.quickViewProductPriceCompare, selectors.quickViewContainer).addClass('d-none');
				} else {
					$(selectors.quickViewProductPrice, selectors.quickViewContainer).removeClass('d-none');
					$(selectors.quickViewProductPriceCompare, selectors.quickViewContainer).removeClass('d-none');
					$(selectors.quickViewProductPrice, selectors.quickViewContainer).html(
						leotriplet.Currency.formatMoney(variant.price, moneyFormat)
					);
					if (variant.compare_at_price > variant.price) {
						$(selectors.quickViewProductPriceCompare, selectors.quickViewContainer).html(
							leotriplet.Currency.formatMoney(variant.compare_at_price, moneyFormat)
						).removeClass('d-none');
						$(selectors.quickViewProductPrice, selectors.quickViewContainer).addClass('on-sale');
					} else {
						$(selectors.quickViewProductPriceCompare, selectors.quickViewContainer).addClass('d-none');
						$(selectors.quickViewProductPrice, selectors.quickViewContainer).removeClass('on-sale');
					}
				}
				if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
			},
	
			updateSKU: function(variant) {
				var sku = variant && variant.sku !== null && variant.sku !== '' ? variant.sku : 'N/A';
				$(selectors.quickViewSKU, selectors.quickViewContainer).html(sku);
			},
	
			updateProductAvailable: function(variant) {
				var classActive = 'product-available--active';
				var translations = leotriplet.strings;
				$(selectors.quickViewavailable, selectors.quickViewContainer).removeClass(classActive);
				if (variant) {
					if (variant.available) {
						$(selectors.quickViewQty, selectors.quickViewContainer).removeClass('d-none');
						$(selectors.quickViewavailableInStock, selectors.quickViewContainer).addClass(classActive);
					} else {
						$(selectors.quickViewQty, selectors.quickViewContainer).addClass('d-none');
						$(selectors.quickViewavailableOutStock, selectors.quickViewContainer).addClass(classActive);
					}
					
					if (variant.available) {
						$(selectors.quickViewContainer).find('.btn--add-to-cart')
							.removeClass('disabled')
							.prop('disabled', false);
						$(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.addToCart);
					} else {
						$(selectors.quickViewContainer).find('.btn--add-to-cart')
							.addClass('disabled')
							.prop('disabled', true);
						$(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.soldOut);
					}
				} else {
					$(selectors.quickViewQty, selectors.quickViewContainer).addClass('d-none');
					$(selectors.quickViewContainer).find('.btn--add-to-cart')
						.addClass('disabled')
						.prop('disabled', true);
					$(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.unavailable);
				}
			},
	
			updateDetailsLink: function(variant) {
				if (variant) {
					var productURL = $(selectors.quickViewProductDetailsURL, selectors.quickViewContainer).data('url') + '?variant=' + variant.id;
					$(selectors.quickViewProductDetailsURL, selectors.quickViewContainer).removeClass('d-none').attr('href', productURL);
				} else {
					$(selectors.quickViewProductDetailsURL, selectors.quickViewContainer).addClass('d-none');
				}
			},
	
			onVariantChange: function() {
				var variant = this.getVariantFromOptions();
				if ($('[data-single-option-button]', selectors.quickViewContainer).length) {
					this.updateVariantsButton();
					if (!variant || !variant.available) {
						this.updateVariantsButtonDisabed();
						return;
					}
				}
				var $element = $('.quickview .quickview--variants .variants-wrapper')
				$($element).each(function() {
					var $this = $(this);
					if( $("select",$this).length > 0 ){
						var value = $( "select",$this).find(':selected').val();
					}else{
						var value = $('input:checked',$this).attr('value');
					}
					$('.variants__label span',$this).html(value);
				});
				this.updateMasterSelect(variant);
				this.updateMedia(variant);
				this.updatePrice(variant);
				this.updateSKU(variant);
				this.updateProductAvailable(variant);
				this.updateDetailsLink(variant);
				this.currentVariant = variant;
			}
		});
		return QuickView;
	})();


/*---------------------------------------------------------------------------------*/
/*----------------------------- Zoom Product Grid Image ---------------------------*/
/*---------------------------------------------------------------------------------*/


	leotriplet.zoom_thumb = function() {
		if($(".product-grid .product-grid__image-wrapper").hasClass("zoom")){
			$('.product-grid .product-grid-card__image').zoom();
		}
	}

/*---------------------------------------------------------------------------------*/
/*------------------------------------ Instafeed Section --------------------------*/
/*---------------------------------------------------------------------------------*/


	$(".hotspot_card--btn").on( "click", function() {
		var $button = $(this);
		var $block = $(this).closest('.hotspot_card');
		var $id = $(this).data("target")
		var $popup = $("#" + $id);
		var blockOffset = $block.offset();
		var buttonOffset = $button.offset();
		var blockWidth = $block.outerWidth();
		var blockHeight = $block.outerHeight();
		var popupWidth = $popup.outerWidth();
		var popupHeight = $popup.outerHeight();
			$('.hotspot-product-grid').not($popup).removeClass("active").hide();
			$('.hotspot_card--btn').not($button).removeClass("active");
				if ($button.hasClass("active")) {
            $button.removeClass("active");
            $popup.removeClass("active").hide();
        } else {
            $button.addClass("active");
						$('body').addClass("active_instaproduct");
            $popup.addClass("active").show();
						$popup.removeClass("toparrow bottomarrow");

						var leftPos = buttonOffset.left - popupWidth / 2;
							if (leftPos < 0) {
									leftPos = 0;
							} else if (leftPos + popupWidth > $(document).width()) {
									leftPos = $(document).width() - popupWidth;
							}
							var topPos = buttonOffset.top + 30;
							var classNew = "toparrow";
							var docScrollTop = $(document).scrollTop();
							var windowHeight = $(window).height();
							if (topPos + popupHeight > docScrollTop + windowHeight) {
									topPos = buttonOffset.top - popupHeight;
									classNew = "bottomarrow";
							}
							if (topPos < docScrollTop) {
									topPos = docScrollTop;
							}
							$popup.css({
									'left': leftPos + 'px',
									'top': topPos + 'px'
							}).addClass(classNew);
        }
	});
	$(window).on("click.Bst", function(event){
		var $box = $('.hotspot-product-grid .product-grid');
		var $box2 = $('.hotspot_card--point');
		if ( $box.has(event.target).length == 0 && !$box.is(event.target) && $box2.has(event.target).length == 0 && !$box2.is(event.target) ) {
			if($('.hotspot-product-grid').hasClass("active")){
				$('.hotspot-product-grid').removeClass("active").removeAttr('style');
				$('body').removeClass("active_instaproduct");
				$('.hotspot_card--btn').removeClass("active");
			}
		}
	});


/*---------------------------------------------------------------------------------*/
/*------------------------------------ Wishlist -------------------------------*/
/*---------------------------------------------------------------------------------*/

	const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
	const LOCAL_STORAGE_DELIMITER = ',';
	const BUTTON_ACTIVE_CLASS = 'active';
	const GRID_LOADED_CLASS = 'loaded';
	
	const selectors = {
		button: '.button-wishlist >button',
		grid: '[grid-wishlist]',
		productCard: '.product-content-card',
	};
		document.addEventListener('DOMContentLoaded', () => {
		initButtons();
		initGrid();
		const wishlist = getWishlist();
		$('[data-count-wishlist] .count').html(wishlist.length);
	});	
	document.addEventListener('shopify-wishlist:updated', (event) => {
		initGrid();
	});
	const fetchProductCardHTML = (handle) => {
		const productTileTemplateUrl = `/products/${handle}?view=wishlist`;
		return fetch(productTileTemplateUrl)
		.then((res) => res.text())
		.then((res) => {
			const text = res;
			const parser = new DOMParser();
			const htmlDocument = parser.parseFromString(text, 'text/html');
			const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
			return productCard.outerHTML;
		})
		.catch((err) => console.error(`[Shopify Content] Failed to load content for handle: ${handle}`, err));
	};	
	const setupGrid = async (grid) => {
		const wishlist = getWishlist();
		const requests = wishlist.map(fetchProductCardHTML);
		const responses = await Promise.all(requests);
		const wishlistProductCards = responses.join('');
		grid.innerHTML = wishlistProductCards;
		grid.classList.add(GRID_LOADED_CLASS);
		initButtons();
		leotriplet.click_atribute_image();
		$('.wishlist--product-grid').removeClass('loading_wishlist');
	
		if( wishlist.length > 0 ){
			$('.wishlist_empty').addClass('hidden');
		}else{
			$('.wishlist_empty').removeClass('hidden');
		}
		if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
		ajaxCart.init();
		const event = new CustomEvent('shopify-wishlist:init-product-grid', {
			detail: { wishlist: wishlist }
		});
		document.dispatchEvent(event);
	};
		const setupButtons = (buttons) => {
		buttons.forEach((button) => {
			const productHandle = button.dataset.productHandle || false;
			if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
			if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
			
			button.addEventListener('click', () => {
				const timeWishlist = setTimeout(loadWishlist, 1000);
				updateWishlist(productHandle);
				button.classList.add('wishlist_loading');
				function loadWishlist() {
					button.classList.remove('wishlist_loading');
					button.classList.toggle(BUTTON_ACTIVE_CLASS);
					if($(button).hasClass('active')){
						var $parent = button.closest('.button-wishlist');
						$parent.setAttribute('data-title',window.strings.remove_wishlist);
					}else{
						var $parent = button.closest('.button-wishlist');
						$parent.setAttribute('data-title',window.strings.wishlist);
					}
				}
			});
		});
	};
		const initGrid = () => {
		const grid = document.querySelector(selectors.grid) || false;
		if (grid) setupGrid(grid);
	};
		const initButtons = ($element) => {
		if($element){
			const parentElement = document.querySelector($element);
			let buttons = parentElement.querySelectorAll(selectors.button) || [];
			if (buttons.length) setupButtons(buttons);
			else return;
		}else{
			const buttons = document.querySelectorAll(selectors.button) || [];
			if (buttons.length) setupButtons(buttons);
			else return;
		}
		const event = new CustomEvent('shopify-wishlist:init-buttons', {
			detail: { wishlist: getWishlist() }
		});
		document.dispatchEvent(event);
		$(selectors.button).each(function(event){
			if($(this).hasClass('active')){
				var $parent = $(this).closest('.button-wishlist');
				$parent.attr('data-title',window.strings.remove_wishlist);
			}else{
				var $parent = $(this).closest('.button-wishlist');
				$parent.attr('data-title',window.strings.wishlist);
			}
		});
	};
		const getWishlist = () => {
		const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
		if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
		return [];
	};
		const setWishlist = (array) => {
		const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
		if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
		else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
	
		const event = new CustomEvent('shopify-wishlist:updated', {
			detail: { wishlist: array }
		});
		document.dispatchEvent(event);
	
		return wishlist;
	};
		const updateWishlist = (handle) => {
		const wishlist = getWishlist();
		const indexInWishlist = wishlist.indexOf(handle);
		if (indexInWishlist === -1) 
			wishlist.push(handle);
		else 
			wishlist.splice(indexInWishlist, 1);
		$('[data-count-wishlist] .count').html(wishlist.length);
		return setWishlist(wishlist);
	};
		const wishlistContains = (handle) => {
		const wishlist = getWishlist();
		return wishlist.includes(handle);
	};
		const resetWishlist = () => {
		return setWishlist([]);
	};
	

/*---------------------------------------------------------------------------------*/
/*------------------------------- Variation Swaches -------------------------------*/
/*---------------------------------------------------------------------------------*/

	leotriplet.click_atribute_image = function(){
		var moneyFormat = leotriplet.strings.moneyFormat;
		$('.variants-swatch').each(function() {
			var $element = $(this);	
			$(".swatch-items",$element).on( "click", function() {
				var $this = $(this);
				if(!$(this).hasClass("active")){
					var $parent = $(this).closest(".swatch-content");
					$(".swatch-items",$parent).removeClass("active");
					$(this).addClass("active");
					var variants_value = leotriplet.get_variant_value($element);
					var productHandle = $element.data('handle');
					$.getJSON('/products/' + productHandle + '.js', function(product) {
						if(product.variants){
							leotriplet.updateVariantsButton($element,product);
							$.each( product.variants, function( index, variant ){
								if (variant.available) {
									if(variant.title == variants_value){
										var $current =  $this.closest(".product-grid");
										$(".product-group-price[data-handle="+productHandle+"] .variant-price",$current).html(leotriplet.Currency.formatMoney(variant.price, moneyFormat));
										$(".product-grid__form[data-handle="+productHandle+"] input[name='id']",$current).val(variant.id);
										if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
										if(variant.featured_media){
											prodImg = variant.featured_media.preview_image.src.replace(/(\.[^.]*)$/, '_600x$1').replace('http:', '');
											if($('.product-grid__image-wrapper',$current).hasClass('slider')){
												$('.product-grid-card__image',$current).slick('slickGoTo',0);
											}
											if($('.product-grid__image-wrapper',$current).hasClass('zoom')){
												$(".product-grid-card__image img",$current).last().attr("src", prodImg);
											}
											$(".product-grid-card__image img.variant",$current).attr("src", prodImg);
											$(".product-grid-card__image img.variant",$current).attr("srcset", prodImg);
				
										}
									}
								}
							});
						}
					});
				}
			});
		});
	}
	leotriplet.get_variant_value = function($element){
		var variant1,variant2,variant3;
		$('.swatch-content-1',$element).each(function(index) {
			var value = $(".swatch-items.active label",$(this)).data("variant");
			if(value === null){
				value = "null";
			}
			variant1 = value;
		});
		$('.swatch-content-2',$element).each(function(index) {
			var value = $(".swatch-items.active label",$(this)).data("variant");
			if(value === null){
				value = "null";
			}
			variant2 = value;
		});
		$('.swatch-content-3',$element).each(function(index) {
			var value = $(".swatch-items.active label",$(this)).data("variant");
			if(value === null){
				value = "null";
			}
			variant3 = value;
		});
		if(variant1 && variant2 && variant3){
			var variants_value = variant1 + ' / ' + variant2 + ' / ' + variant3;
		}else if(variant1 && variant2){
			var variants_value = variant1 + ' / ' + variant2;
		}else if(variant1){
			var variants_value = variant1;
		}
		return variants_value;
	}
	leotriplet.updateVariantsButton = function($element,$product) {
		var selectedValues = leotriplet.getCurrentOptions($element);
		var variants = $product.variants;
		for (var i = 2; i <= 3; i++) {
		if ($(".swatch-content-"+i+"",$element).length) {
			var $container = $(".swatch-content-"+i+"",$element);
			$("label", $container).each(function() {
				var $self = $(this);
				var optionValue = $self.data("variant");
				var foundIndex;
				if (i === 2) {
					foundIndex = _.findIndex(variants, function(variant) {
					return variant.option1 === selectedValues[0].value &&
						variant.option2 === optionValue &&
						variant.available === true;
					});
					
				} else if (i === 3) {
					foundIndex = _.findIndex(variants, function(variant) {
					return variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value &&
						variant.option3 === optionValue &&
						variant.available === true;
					});
				}
				if (foundIndex !== -1) {
					$self.closest(".swatch-items").removeClass('disabled');
				} else {
					$self.closest(".swatch-items").addClass('disabled');
				}
			});	
		}
		}
	}
	leotriplet.getCurrentOptions =  function($element) {
		var currentOptions = [];
		for (var i = 1; i <= 3; i++) {
			if ($(".swatch-content-"+i+"",$element).length) {
				var currentOption = {};
				currentOption.index = $(".swatch-content-"+i+" .swatch-items.active label",$element).data("index");
				var $variant = $(".swatch-content-"+i+" .swatch-items.active label",$element).data("variant");
				if($variant === null){
					$variant = "null";
				}		
				currentOption.value = $variant;
				currentOptions[i] = currentOption;
			}
		}
		return _.compact(currentOptions);
	}
	
	
/*---------------------------------------------------------------------------------*/
/*------------------------------- Custom Quantity btn ------------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.customNumberInput = function() {
  
		var $body = $('body'),
    qtyAdjust = '.quantity-update',
    qtyNumber = '.quantity-number-input';

  var validateQty;

  $body.on('click', qtyAdjust, function() {
    var $el = $(this),
      $qtySelector = $el.siblings(qtyNumber),
      qty = parseInt($qtySelector.val().replace(/\D/g, ''));

    qty = validateQty(qty);

    if ($el.hasClass('leotriplet-qty-plus')) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
      if (qty <= 0 && $qtySelector.attr('min') == '1') qty = 1;
    }

    $qtySelector.val(qty);
  });

  $body.on('focus', qtyAdjust, function() {
    var $el = $(this);
    setTimeout(function() {
      $el.select();
    }, 50);
  });

  validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      
    } else {
      qty = 1;
    }
    return qty;
  };
}



/*---------------------------------------------------------------------------------*/
/*------------------------------- Cart Ajax ------------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.getCookie = function(cname) {
	var name = cname + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookieArray = decodedCookie.split(';');
	for(var i = 0; i < cookieArray.length; i++) {
		var cookieItem = cookieArray[i];
		while (cookieItem.charAt(0) === ' ') {
			cookieItem = cookieItem.substring(1);
		}
		if (cookieItem.indexOf(name) === 0) {
			return cookieItem.substring(name.length, cookieItem.length);
		}
	}
	return '';
};
if (typeof ShopifyAPI === 'undefined') {
	ShopifyAPI = {};
}

ShopifyAPI.onError = function(XMLHttpRequest) {
	var data = eval('(' + XMLHttpRequest.responseText + ')');
	if (data.message) {
		alert(data.message + '(' + data.status + '): ' + data.description);
	}
};

ShopifyAPI.onCartUpdate = function() {
	
};

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
	var formData = new FormData(form);
	var params = {
		type: 'POST',
		url: '/cart/add.js',
		data: formData,
		processData: false,
		contentType: false,
		dataType: 'json',
		success: function(line_item) {
			if (typeof callback === 'function') {
				callback(line_item, form);
			} else {
				ShopifyAPI.onItemAdded(line_item, form);
			}
		},
		error: function(XMLHttpRequest, textStatus) {
			if (typeof errorCallback === 'function') {
				errorCallback(XMLHttpRequest, textStatus);
			} else {
				ShopifyAPI.onError(XMLHttpRequest, textStatus);
			}
		}
	};
	jQuery.ajax(params);
};
ShopifyAPI.getCart = function(callback, added) {
  jQuery.getJSON('/cart.js', function(cart) {
    if (typeof callback === 'function') {
      callback(cart, added);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};
ShopifyAPI.changeItem = function(line, quantity, callback,modal) {
	var params = {
		type: 'POST',
		url: '/cart/change.js',
		data: 'quantity=' + quantity + '&line=' + line,
		dataType: 'json',
		success: function(cart) {
			if (typeof callback === 'function') {
				callback(cart);
			} else {
				ShopifyAPI.onCartUpdate(cart);
			}
			if(modal){
				var moneyFormat = '$';
				if (leotriplet.strings.moneyFormat !== undefined) {
					settings.moneyFormat = leotriplet.strings.moneyFormat;
				}
				var id = $('#form-modal-addtocart input[data-modal-variant]').val();
				for (var j in cart.items) {
					if( id == cart.items[j].variant_id ){
						leotriplet = cart.items[j].final_line_price;
						leotriplet_discount = cart.items[j].original_line_price;
					}
				}
				$("#form-modal-addtocart .modalcart_line_price .price").html(
					leotriplet.Currency.formatMoney(price)
				);
				if(cart.items[j].discounts.length > 0){
					$('#form-modal-addtocart .modalcart_line_price .price_discount').html(
						leotriplet.Currency.formatMoney(price_discount)
					);
					for (var i in cart.items[j].discounts) {
						$('.cart-js-modal .discount').text(cart.items[j].discounts[i].title);
					}
				}else{
					$('#form-modal-addtocart .modalcart_line_price .price_discount').empty();
					$('.cart-js-modal .discount').empty();
				}
				$('#form-modal-addtocart .cart-modal_middle').removeClass('load_modal');
			}
		},
		error: function(XMLHttpRequest, textStatus) {
			ShopifyAPI.onError(XMLHttpRequest, textStatus);
		}
	};
	jQuery.ajax(params);
};
var ajaxCart = (function(module, $) {
  'use strict';

  
  var init, loadCart;

  
  var settings, isUpdating, $body;

  
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer;

  
  var initializeEvents,
    updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartModalAdded,
		cartModalupdate,
		updateModalRecommendations,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function(options) {
    
    settings = {
      formSelector: '[data-product-form]',
      cartContainer: '[data-cart-container]',
      addToCartSelector: 'button[type="submit"]',
      cartCountSelector: '[data-cart-count]',
      cartCostSelector: '[data-cart-cost]',
      cartRemoveSelector: '[data-cart-remove]',
      headerCartSelector: '.header-cart--link',
      cartModalSelector: '.cart-js-modal',
      cartModalCloseSelector: '.cart-js-modal-close',
      moneyFormat: '$',
      disableAjaxCart: false,
      cartTemplate: '#ajaxcart-template',
      cartModalHeaderTemplate: '#header-ajaxcart-template'
    };

    if (leotriplet.strings.moneyFormat !== undefined) {
      settings.moneyFormat = leotriplet.strings.moneyFormat;
    }

    
    $.extend(settings, options);

    
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    $body = $('body');
    isUpdating = false;
    initializeEvents();
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }
    adjustCart();
  };

	initializeEvents = function() {
		$body.on('click', settings.cartModalCloseSelector, function() {
			$('.cart-js-modal .cart-modal__inner').removeClass('show');
			setTimeout(function() {
				$(settings.cartModalSelector).fadeOut(400, function() {
					$(this).remove();
				});
			}, 400);
		});
		$body.on('click', settings.headerCartSelector, function(e) {
			if (leotriplet.settings.cartType == 'modal' && $(window).width() > 767 && !$('body').hasClass('cart--template')) {
				e.preventDefault();
				return;
			}
		});
		$body.on('click', settings.cartRemoveSelector, function(e) {
			if (isUpdating) {
				return;
			}
			var $el = $(this),
				line = $el.data('line');
			if (line) {
				$('.ajaxcart_product[data-line="' + line + '"]').addClass('cart--is_loading');
				isUpdating = true;
				setTimeout(function() {
					ShopifyAPI.changeItem(line, 0, adjustCartCallback);
				}, 250);
			}
			
		});
		$body.on('change', '.cart-note--input', function() {
			var newNote = $(this).val();
			$(".ajaxcart_footer_features .save-ajaxcart_footer_note").on( "click", function() {
				ShopifyAPI.updateCartNote(newNote, function() {});
			});
		});
		$body.on('change', '.discount_code_input', function() {
			var newDiscount = $(this).val();
			$(".ajaxcart_footer_features .save-discount_code_input").on( "click", function() {
				leotriplet.setCookie('leotriplet_discount', newDiscount, 1);
			});
		});	
	
	};

	loadCart = function() {
		if($('.cart-js-drawer').length > 0 || $('.ajaxcart--header').length > 0 ) {
			$body.addClass('ajaxcart--is_loading');
		}
		ShopifyAPI.getCart(cartUpdateCallback);
	};

	updateCountPrice = function(cart) {
		if ($('[data-cart-count]')) {
			$('[data-cart-count]').html(cart.item_count);
		}
		
			if ($cartCostSelector) {
				$cartCostSelector.html(
					leotriplet.Currency.formatMoney(cart.total_price, settings.moneyFormat)
				);
			}
			$(".cart-modal-totalprice span").html(
				leotriplet.Currency.formatMoney(cart.total_price, settings.moneyFormat)
			);
			$(".cart-modal-totalcount span.count").html(cart.item_count);
		
	};

	formOverride = function() {
		$body.on('submit', settings.formSelector, function(evt) {
			evt.preventDefault();
			$('.btn--add-to-cart',$(this)).attr('disabled', 'disabled');
			
			$('.btn--add-to-cart',$(this)).removeClass('is-added').addClass('is-adding');
			$('.ajaxcart-toast').toast('hide');
			ShopifyAPI.addItemFromForm(evt.target,itemAddedCallback,itemErrorCallback);
		});
	};

	itemAddedCallback = function(lineItem) {
		$('form .btn--add-to-cart').removeAttr('disabled');
		
		$('form .btn--add-to-cart').removeClass('is-adding').addClass('is-added');
		if (leotriplet.settings.cartType == 'modal') {
			cartModalAdded(lineItem);
		}
		ShopifyAPI.getCart(cartUpdateCallback, true);

	};

	itemErrorCallback = function(XMLHttpRequest) {
		var data = eval('(' + XMLHttpRequest.responseText + ')');
		$addToCart.removeAttr('disabled').find('.spinner-border').remove();
		$addToCart.removeClass('is-adding is-added');
		if (data.message) {
			if (data.status === 422) {
				var $toast = $('.ajaxcart-toast');
				$toast.find('.toast-body').html(data.description);
				$toast.toast('show');
			}
		}
	};

	cartModalAdded = function(lineItem) {
		var data = {},
			image = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif',
			source = $(settings.cartModalHeaderTemplate).html(),
			template = Handlebars.compile(source);
		if (lineItem.image != null) {
			image = lineItem.image;
		}
		updateModalRecommendations(lineItem);
		data = {
			name: lineItem.product_title,
			image: image,
			discount: lineItem.discounts,
			variant_id: lineItem.variant_id,
			variant:lineItem.variant_title,
			options: lineItem.options_with_values,
			price_discount:leotriplet.Currency.formatMoney(lineItem.original_line_price, settings.moneyFormat),
			final_line_price: leotriplet.Currency.formatMoney(lineItem.final_line_price, settings.moneyFormat),
			final_price: leotriplet.Currency.formatMoney(lineItem.final_price, settings.moneyFormat),
			quantity : lineItem.quantity
		}
		$body.append(template(data));

		$('#form-modal-addtocart .modalcart_line_price .price').html(leotriplet.Currency.formatMoney(lineItem.final_line_price, settings.moneyFormat));
		
		if(data.variant != null) {
			for (var j in data.options) {
				$('.cart-js-modal .variant').append('<span>'+data.options[j].name+' : '+data.options[j].value+'</span>');
			}
		}
		if(data.discount.length > 0) {
			for (var j in data.discount) {
				$('.cart-js-modal .discount').text(data.discount[j].title);
			}
			$('#form-modal-addtocart .modalcart_line_price .price_discount').html(leotriplet.Currency.formatMoney(lineItem.original_line_price, settings.moneyFormat));
		}else{
			$('.cart-js-modal .discount').empty();
			$('#form-modal-addtocart .modalcart_line_price .price_discount').empty();
		}
		$('.js-cart-modal').fadeIn(400);
		setTimeout(function(){
			$('.cart-js-modal .cart-modal__inner').addClass('show');
		},400);
	};
	cartModalupdate = function(cart) {
		$('#form-modal-addtocart .modalcart__quantity input').change(function(){
			$('#form-modal-addtocart .cart-modal_middle').addClass('load_modal');
			var id = $('#form-modal-addtocart input[data-modal-variant]').val();
			var qty = $('#form-modal-addtocart .modalcart__quantity input').val();
			var modal = true;
			for (var j in cart.items) {
				if( id == cart.items[j].variant_id ){
					var line = parseInt(j) + 1;
				}
			}
			ShopifyAPI.changeItem(line, qty, adjustCartCallback,modal);
		});
		$('#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust').on('click',function(){
			$('#form-modal-addtocart .cart-modal_middle').addClass('load_modal');
			var id = $('#form-modal-addtocart input[data-modal-variant]').val();
			var modal = true;
			for (var j in cart.items) {
				if( id == cart.items[j].variant_id ){
					var line = parseInt(j) + 1;
					var lineItem = cart.items[j];
				}
			}
			setTimeout(function(){
				var qty = $('#form-modal-addtocart .modalcart__quantity input').val();
				ShopifyAPI.changeItem(line, qty, adjustCartCallback,modal);
			},500);
		});
	},
	updateModalRecommendations = function(lineItem) {
		var baseUrl = routes.product_recommendations_url;
		var productId = lineItem.product_id;
		var relatedSectionUrl = baseUrl + '?section_id=related-products&product_id=' + productId +'&limit=6';
		$.get(relatedSectionUrl).then(function(section) {
			var recommendationsMarkup = $(section).html();
			$(".cart-modal-recommendations").html(recommendationsMarkup);
			var $element = $(".leotriplet-related-products",$(".cart-modal-recommendations"));
			leotriplet.elementslickCarousel( $element );
			if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }			
		});
	};

	cartUpdateCallback = function(cart, added) {
		updateCountPrice(cart);
		
			buildCart(cart,fire_work);
			cartModalupdate(cart);
			if (added) {
				$body.trigger('drawer.open');
			}
		
	};

	buildCart = function(cart) {
			$cartContainer.empty();
		

			
			if (cart.item_count === 0) {
              $cartContainer.append(
                  '<p class="cart-empty-message">' +
                      leotriplet.strings.cartEmpty +
                  '</p>\n' +
                  '<p class="cookie-message d-none">' +
                      leotriplet.strings.cartCookies +
                  '</p>\n' +
                  '<a href="/collections/all" class="continue-shop-btn">Start Shopping</a>'
              );
          
              cartCallback(cart);
              $('.cart-js-drawer .drawer__title .count').text('0');
              $('.shipping-bar-cart').addClass('hidden');
              return;
          }

			var items = [],
				item = {},
				data = {},
				source = $(settings.cartTemplate).html();

			var template = Handlebars.compile(source);

			$.each(cart.items, function(index, cartItem) {
				var prodImg;
				var unitPrice = null;
				if (cartItem.image !== null) {
					prodImg = cartItem.image
						.replace(/(\.[^.]*)$/, '_small$1')
						.replace('http:', '');
				} else {
					prodImg =
						'//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
				}

				if (cartItem.properties !== null) {
					$.each(cartItem.properties, function(key, value) {
						if (key.charAt(0) === '_' || !value) {
							delete cartItem.properties[key];
						}
					});
				}

				if (cartItem.properties !== null) {
					$.each(cartItem.properties, function(key, value) {
						if (key.charAt(0) === '_' || !value) {
							delete cartItem.properties[key];
						}
					});
				}

				if (cartItem.line_level_discount_allocations.length !== 0) {
					for (var discount in cartItem.line_level_discount_allocations) {
						var amount =
							cartItem.line_level_discount_allocations[discount].amount;

						cartItem.line_level_discount_allocations[
							discount
						].formattedAmount = leotriplet.Currency.formatMoney(
							amount,
							settings.moneyFormat
						);
					}
				}

				if (cart.cart_level_discount_applications.length !== 0) {
					for (var cartDiscount in cart.cart_level_discount_applications) {
						var cartAmount =
							cart.cart_level_discount_applications[cartDiscount]
								.total_allocated_amount;

						cart.cart_level_discount_applications[
							cartDiscount
						].formattedAmount = leotriplet.Currency.formatMoney(
							cartAmount,
							settings.moneyFormat
						);
					}
				}

				if (cartItem.unit_price_measurement) {
					unitPrice = {
						addRefererenceValue:
							cartItem.unit_price_measurement.reference_value !== 1,
							price: leotriplet.Currency.formatMoney(
							cartItem.unit_price,
							settings.moneyFormat
						),
						reference_value: cartItem.unit_price_measurement.reference_value,
						reference_unit: cartItem.unit_price_measurement.reference_unit
					};
				}

				
				item = {
					key: cartItem.key,
					line: index + 1, 
					url: cartItem.url,
					img: prodImg,
					name: cartItem.product_title,
					variation: cartItem.variant_title === null ? false : true,
					variant: cartItem.variant,
					options: cartItem.options_with_values,
					variant_id: cartItem.variant_id,
							properties: cartItem.properties,
							itemAdd: cartItem.quantity + 1,
							itemMinus: cartItem.quantity - 1,
							itemQty: cartItem.quantity,
					handle:cartItem.handle,
					price: leotriplet.Currency.formatMoney(
						cartItem.original_line_price,
						settings.moneyFormat
					),
					discountedPrice: leotriplet.Currency.formatMoney(
						cartItem.final_line_price,
						settings.moneyFormat
					),
					discounts: cartItem.line_level_discount_allocations,
					discountsApplied:cartItem.line_level_discount_allocations.length === 0 ? false : true,
					vendor: cartItem.vendor,
					unitPrice: unitPrice
				};
				items.push(item);
			});

			
			data = {
			items: items,
			note: cart.note,
			totalPrice: leotriplet.Currency.formatMoney(
				cart.total_price,
				settings.moneyFormat
			),
			cartDiscounts: cart.cart_level_discount_applications,
			cartDiscountsApplied:cart.cart_level_discount_applications.length === 0 ? false : true
			};
			$cartContainer.append(template(data));
			cartCallback(cart);
		if( data.note ) {
			$(".cart-table .cart-note--input textarea").val(data.note);
		}
		var discount_code = leotriplet.getCookie('leotriplet_discount');
		if( discount_code ) {
			$(".cart-table .discount_code_input").val(discount_code);
			$(".cart-js-drawer .discount_code_input").val(discount_code);
		}
		$('.cart-js-drawer .drawer__title .count').text(cart.item_count);

		

		
		
		$('.pre_order-cart >span').each(function(){
			var id = $(this).data('handle');
			for (var i in data.items) {
				if(data.items[i].variant_id == id) {
					$('.ajaxcart__product[data-line="'+data.items[i].line+'"] .pre_order').removeClass('hide');
				}
			}
		});
		
		if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
	};
  cartCallback = function(cart) {
    $body.removeClass('ajaxcart--is_loading');

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

    $body.trigger('drawer.footer');
  };
  adjustCart = function() {
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      qty = validateQty(qty);

      if (line) {
        updateQuantity(line, qty);
      }
    });

    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      var $row = $('.ajaxcart_product[data-line="' + line + '"]').addClass('cart--is_loading');
      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }
  };
  adjustCartCallback = function(cart) {
    updateCountPrice(cart);
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
      isUpdating = false;
    }, 150);
  };
  validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      
    } else {
      qty = 1;
    }
    return qty;
  };
  module = {
    init: init,
    load: loadCart
  };
  return module;
})(ajaxCart || {}, jQuery);

leotriplet.drawerCart = (function(module) {
  var $body, $drawer, drawerCloseSelector, headerCartSelector, drawerIsOpen;

  var init, drawerOpen, drawerClose, drawerFooter;

  var classes = {
    open: 'open-cart-drawer'
  };

  init = function() {
    $body = $('body');
    $drawer = $('.cart-js-drawer');
    drawerCloseSelector = '.cart-js-drawer--close';
    headerCartSelector = '.header-cart--link';
    drawerIsOpen = false;

    $body.on('drawer.open', function(evt) {
      drawerOpen(evt);
    });

    $body.on('drawer.close', function(evt) {
      drawerClose(evt);
    });

    $body.on('drawer.footer', function() {
      drawerFooter();
    });

    $body.on('click', headerCartSelector, function(evt) {
		if( !$('body').hasClass('cart--template') ){
			evt.preventDefault();
			$body.trigger('drawer.open', evt);
		}
    });

    $body.on('click', drawerCloseSelector, function(evt) {
      evt.preventDefault();
      $body.trigger('drawer.close', evt);
    });
  };

  drawerOpen = function(evt) {
    if (drawerIsOpen) {
      if (evt) {
        evt.preventDefault();
      }
      return;
    }

    if (evt) {
      evt.preventDefault();
    }

    $body.addClass(classes.open);
    drawerIsOpen = true;
  };

  drawerClose = function(evt) {
    if (!drawerIsOpen) {
      return;
    }

    if (evt.keyCode !== 27) {
      evt.preventDefault();
    }

    $body.removeClass(classes.open);
    drawerIsOpen = false;
  };

  drawerFooter = function() {
    if (!$drawer.hasClass('drawer--has-fixed-footer')) {
      return;
    }

    var $cartFooter = $('.cartdrawer_footer').removeAttr('style');
    var $cartInner = $('.ajaxcart_inner').removeAttr('style');
    var cartFooterHeight = $cartFooter.outerHeight();
    $cartInner.css('bottom', cartFooterHeight);
    $cartFooter.css('height', cartFooterHeight);
		$(".ajaxcart_footer_features .order_note_btn").on( "click", function() {
			if($('.ajaxcart_footer_features .ajaxcart_footer_note').hasClass('active')){
				$('.ajaxcart_footer_features .ajaxcart_footer_note').removeClass('active');	
			}else{
				$('.ajaxcart_footer_features .ajaxcart_footer_note').addClass('active');		
			}
		});
		$(".ajaxcart_footer_features .cart_discount_btn").on( "click", function() {
			if($('.ajaxcart_footer_features .discount_code').hasClass('active')){
				$('.ajaxcart_footer_features .discount_code').removeClass('active');	
			}else{
				$('.ajaxcart_footer_features .discount_code').addClass('active');		
			}
		});
		$(".ajaxcart_footer_features .close-ajaxcart_footer_features").on( "click", function() {
			if($('.ajaxcart_footer_features .ajaxcart_footer_content >div').hasClass('active')){
				$('.ajaxcart_footer_features .ajaxcart_footer_content >div').removeClass('active');
			}
		});
		$(".ajaxcart_footer_features .save").on( "click", function() {
			if($('.ajaxcart_footer_features .ajaxcart_footer_content >div').hasClass('active')){
				$('.ajaxcart_footer_features .ajaxcart_footer_content >div').removeClass('active');
			}
		});
  };

  module = {
    init: init
  }
  return module;
})();
leotriplet.cartInit = function() {
  var $body = $('body');
  
  
  
  if (leotriplet.settings.cartType == 'modal' || leotriplet.settings.cartType == 'drawer') {
    ajaxCart.init();
    ajaxCart.load();

    if (leotriplet.settings.cartType == 'drawer') {
      leotriplet.drawerCart.init();
    }
  }
};


/*---------------------------------------------------------------------------------*/
/*-------------------------------------- Cart Page --------------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.update_variant_cartpage = (function() {
	var selectors = {
		body: 'body',
		EditVariant: '[data-edit_variant-cart]',
		EditVariantTemplate: '#variants_edit-template',
		EditVariantBtn: '.cart-product-edit_variant',
		EditVariantContainer: '[data-edit_variant-cart-container]',
		EditVariantClose: '[data-edit_variant-cart-close]',
		EditVariantImages: '[data-edit_variant-images]',
		EditVariantVariant: '.js-edit_variant-option-selector',
		originalSelectorId: '[data-edit_variant-variant]',
		EditVariantProductPrice: '.js-edit_variant-product-price',
		EditVariantProductPriceCompare: '.js-edit_variant-product-price-compare',
		EditVariantQty: '[data-edit_variant-quantity]',
		EditVariantavailable: '.product-available',
		EditVariantavailableInStock: '.product-available--instock',
		EditVariantavailableOutStock: '.product-available--outstock',
		EditVariantDetailsURL: '.js-qv-product-details'
	};
	function EditVariant(container) {
		this.$container = $(container);
		this.cache = {};
		this.productVariants = [];
		this.currentVariant = {};
		this.cacheSelectors();
		this.initializeEvents();
	}
	EditVariant.prototype = _.assignIn({}, EditVariant.prototype, {
		cacheSelectors: function() {
			this.cache = {
				$body: $('body'),
				$EditVariantContainer: this.$container.find(selectors.EditVariantContainer)
			};
		},

		initializeEvents: function() {
			var $this = this;
			$(selectors.body).on('click', selectors.EditVariantBtn, function(e) {
				e.preventDefault();
				var productHandle = $(this).data('handle');
				var qty = $(this).data('value');
				var line = $(this).data('line');
				var id_variant = $(this).data('id_variant');
				var $parent = $(this).closest('.content-edit_variant-popup');
				$(this).addClass('load-edit_variant');
				$('.image-popup',$parent).addClass('imagepopup_active');
				$('body').addClass('edit_variant_overlay');
				$.getJSON('/products/' + productHandle + '.js', function(product) {
					if (product.available) {
					$this.firstAvailableVariant(product.variants, $this);
					} else {
						$this.currentVariant = product.variants[0];
					}
					$(selectors.EditVariantBtn).removeClass('load-edit_variant');
					$this.buildEditVariant(product,qty,line,id_variant);
					var $element = $('.edit_variant-cart-container .content_product_detail .variants-wrapper')
					$($element).each(function() {
						var $this = $(this);
						var value = $('input:checked',$this).attr('value');
						$('.variants__label span',$this).html(value);
					});
					$(selectors.EditVariantContainer).on('change', selectors.EditVariantVariant, function(e) {
						$this.onVariantChange(id_variant);
					});
					if ($(window).width() < 767) {
						$(selectors.EditVariant).addClass('is-visible');
					}else{
						$(selectors.EditVariant).addClass('transform');
						setTimeout(function() { 
							$(selectors.EditVariant).addClass('is-visible');
						},300);
					}
				});
			});
			$(selectors.body).on('click', selectors.EditVariantClose, function(e) {
				if ($(window).width() < 767) {
					$(selectors.EditVariant).removeClass('is-visible');
					$('body').removeClass('edit_variant_overlay');
					setTimeout(function() {
						$('[data-edit_variant-cart-container]').empty();
					},300);
				}else{
					$(selectors.EditVariant).removeClass('is-visible');
					setTimeout(function() { 
						$(selectors.EditVariant).removeClass('transform');
					},500);
					setTimeout(function() { 
						$('body').removeClass('edit_variant_overlay');
						$('[data-edit_variant-cart-container]').empty();
					},700);
				}
			});
			$(selectors.body).on('click', function(e) {
				if( $(e.target).is('body.edit_variant_overlay')) {
					if ($(window).width() < 767) {
						$(selectors.EditVariant).removeClass('is-visible');
						$('body').removeClass('edit_variant_overlay');
						setTimeout(function() {
							$('[data-edit_variant-cart-container]').empty();
						},300);
					}else{
						$(selectors.EditVariant).removeClass('is-visible');
						setTimeout(function() { 
							$(selectors.EditVariant).removeClass('transform');
						},500);
						setTimeout(function() { 
							$('body').removeClass('edit_variant_overlay');
							$('[data-edit_variant-cart-container]').empty();
						},700);
					}
				}
			});
		},

		firstAvailableVariant: function(variants, global) {
			global.productVariants = variants;
			for (var i = 0; i < variants.length; i++) {
				var variant = variants[i];
				if (variant.available) {
					global.currentVariant = variant;
					break;
				}
			}
		},
		buildEditVariant: function(product,qty,line,id_variant) {
			var moneyFormat = leotriplet.strings.moneyFormat;
			var currentVariant = this.currentVariant;
			for (var key in product.variants) {
				if (id_variant == product.variants[key].id) {
					var currentVariant = product.variants[key];
				}
			}
			var source = $(selectors.EditVariantTemplate).html();
			var template = Handlebars.compile(source);
			var images = '';
			var price = '';
			var external='';
			var qvObject = {
				id: product.id
			};
			if (typeof product.media !== 'undefined') {
				images += '<div class="edit_variant-images__list slick-carousel" data-edit_variant-images>'
				for (var i = 0; i < product.media.length; i++) {
					var media = product.media[i];
					if (media.media_type === 'image') {
						if ( i == 0 ) {
							images += '<div class="slick-carousel__item show"><div class="edit_variant-images__item" data-media-id=' +
								media.id + '><img class="img-fluid" alt="' +
								product.title + '" src="' +
								media.src + '" /></div></div>';
						}else{
							images += '<div class="slick-carousel__item"><div class="edit_variant-images__item" data-media-id=' +
								media.id + '><img class="img-fluid" alt="' +
								product.title + '" src="' +
								media.src + '" /></div></div>';
						}
					}
				}
				images += '</div>'
			}			
			qvObject.variantID = currentVariant.id;
			qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== '' ? currentVariant.sku : 'N/A';
			qvObject.images = images;
			qvObject.title = product.title;
			qvObject.qty = qty;
			qvObject.line = line;
			qvObject.url = product.url;
			price += '<div class="price-container">';
			var productCompareClass = currentVariant.compare_at_price !== null ? '' : 'd-none';
			price += '<div class="js-edit_variant-product-price-compare product-single__price--compare-at ' + productCompareClass + '">' + leotriplet.Currency.formatMoney(currentVariant.compare_at_price, moneyFormat) + '</div>';
			price += '<div class="js-edit_variant-product-price product-single__price">' + leotriplet.Currency.formatMoney(currentVariant.price, moneyFormat) + '</div>';
			price += '</div">';
			qvObject.price = price;
			qvObject.variants = this.buildVariant(product,id_variant);
			$(selectors.EditVariantContainer).html(template(qvObject));
			
			this.updateMedia(currentVariant);
			this.updateDetailsLink(currentVariant);
			$('#form-edit_variants-addtocart .btn--add-to-cart').on('click',function(e){
				e.preventDefault();
				var $parent = $(this).closest('.edit-product_variants');
				$(this).removeClass('added');
				$(this).addClass('active');
				let addToCartForm = document.querySelector('#form-edit_variants-addtocart');
				let formData = new FormData(addToCartForm);
				var params = {
					type: 'POST',
					url: '/cart/add.js',
					data: formData,
					processData: false,
					contentType: false,
					dataType: 'json',
					success: function(cart) {
						var line = $parent.data('line') + 1;
						$('#form-edit_variants-addtocart .btn--add-to-cart').removeClass('active');
						$('#form-edit_variants-addtocart .btn--add-to-cart').addClass('added');
						setTimeout(function() {
							$('#form-edit_variants-addtocart .btn--add-to-cart').removeClass('added');
						}, 2000);
						ShopifyAPI.changeItem(line, 0);
						setTimeout(function() {
							if ($(window).width() < 767) {
								$(selectors.EditVariant).removeClass('is-visible');
								$('body').removeClass('edit_variant_overlay');
								setTimeout(function() {
									$('[data-edit_variant-cart-container]').empty();
								},300);
							}else{
								$(selectors.EditVariant).removeClass('is-visible');
								setTimeout(function() { 
									$(selectors.EditVariant).removeClass('transform');
								},500);
								setTimeout(function() {
									$('body').removeClass('edit_variant_overlay');
									$('[data-edit_variant-cart-container]').empty();
								},700);
							}
						}, 500);
						setTimeout(function(){
							ajaxCart.load();
						}, 1000);
						if( $('body').hasClass('cart--template') ){
							setTimeout(function(){
								ajaxCartPage.load();
							}, 1000);
						}
					},
					error: function(XMLHttpRequest, textStatus) {
						if (typeof errorCallback === 'function') {
							errorCallback(XMLHttpRequest, textStatus);
						} else {
							ShopifyAPI.onError(XMLHttpRequest, textStatus);
						}
					}
				};
				jQuery.ajax(params);
			});
			if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
		},
		convertToSlug: function(str) {
			return str.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
		},
		buildVariant: function(product,id_variant) {
			var result = '';
			var currentVariant = this.currentVariant;
			for (var key in product.variants) {
				if (id_variant == product.variants[key].id) {
					var currentVariant = product.variants[key];
				}
			}
			if (product.options[0].name !== 'Title') {
				var options = product.options;
				for (var i = 0; i < options.length; i ++) {
					var option = options[i];
					var optionIndex = i + 1;
					var type = 'label';
					if (leotriplet.settings.filter_name_1 === option.name) {
						type = leotriplet.settings.select_filter_1;
					}else if (leotriplet.settings.filter_name_2 === option.name) {
						type = leotriplet.settings.select_filter_2;
					}else if (leotriplet.settings.filter_name_3 === option.name) {
						type = leotriplet.settings.select_filter_3;
					}
					result += '<div class="variants-wrapper product-form--item '+ type +'" data-edit_variants-variant-option="' + optionIndex + '">';
					result += '<label class="variants__label">' + option.name + ': <span></span></label>';
					result += '<div class="variants__options">';
					for (var j = 0; j < option.values.length; j ++) {
						var value = option.values[j];
						var isDisable = true;
						var colorAttribute = '';
						
						for (var k = 0; k < this.productVariants.length; k ++) {
							var variantCondition = this.productVariants[k];
							if (variantCondition.available) {
								if (i == 0 && variantCondition.option1 === value) {
									isDisable = false;
									break;
								} else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
									isDisable = false;
									break;
								} else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
									isDisable = false;
									break;
								}
							}
						}
						
						result += '<div class="variant-option">';
						result += '<input type="radio" data-single-option-button';
						result += currentVariant.options[i] === value ? ' checked ' : ' ';
						if (isDisable) {
							result += 'disabled="disabled"';
						}
						result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
						result += 'class="js-edit_variant-option-selector';
						if (isDisable) {
							result += ' disabled';
						}
						result += '" id="edit_variants-product-option-' + i + '-' + value.toLowerCase() + '">';
						result += '<label class="' + value + '" data-toggle="tooltip" title="' + value + '" for="edit_variants-product-option-' + i + '-' + value.toLowerCase() + '" ' + colorAttribute;
						if (isDisable) {
							result += ' class="disabled"';
						}
						result += '>' + value + '<span class="tool-tip">' + value + '</span></label>';
						result += '</div>';
					}
					result += '</div>';
					result += '</div>';
				}
			}
			return result;
		},
		createImageCarousel: function(product) {
			if(product.media.length > 1){
				$(selectors.EditVariant).find(selectors.EditVariantImages).slick({
					infinite: false,
					rows: 0,
					fade: true,
					//rtl : leotriplet.rtl_slick()
				});
			}
		},
		getCurrentOptions: function() {
			var currentOptions = _.map(
				$(selectors.EditVariantVariant, selectors.EditVariantContainer), function(element) {
					var $element = $(element);
					var type = $element.attr('type');
					var currentOption = {};
					if (type === 'radio' || type === 'checkbox') {
						if ($element[0].checked) {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');
							return currentOption;
						} else {
							return false;
						}
					} else {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');
						return currentOption;
					}
				}
			);
			currentOptions = _.compact(currentOptions);
			return currentOptions;
		},
		getVariantFromOptions: function() {
			var selectedValues = this.getCurrentOptions();
			var variants = this.productVariants;
			var found = _.find(variants, function(variant) {
				return selectedValues.every(function(values) {
					return _.isEqual(variant[values.index], values.value);
				});
			});
			return found;
		},
		updateVariantsButton: function () {
			var selectedValues = this.getCurrentOptions();
			var variants = this.productVariants;
			for (var i = 2; i <= 3; i++) {
				if ($('[data-edit_variants-variant-option="' + i + '"]', selectors.EditVariantContainer).length) {
					$('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function() {
						var $self = $(this);
						var optionValue = $self.val();
						var foundIndex;
						if (i === 2) {
							foundIndex = _.findIndex(variants, function(variant) {
								return variant.option1 === selectedValues[0].value &&
								variant.option2 === optionValue &&
								variant.available === true;
							});
						} else if (i === 3) {
							foundIndex = _.findIndex(variants, function(variant) {
								return variant.option1 === selectedValues[0].value &&
								variant.option2 === selectedValues[1].value &&
								variant.option3 === optionValue &&
								variant.available === true;
							});
						}
						if (foundIndex !== -1) {
							$self.removeAttr('disabled', 'disabled').removeClass('disabled');
							$self.next('label').removeClass('disabled');
						} else {
							$self.attr('disabled', 'disabled').addClass('disabled');
							$self.next('label').addClass('disabled');
						}
					});
				}
			}
		},
		updateVariantsButtonDisabed: function() {
			for (var i = 2; i <= 3; i++) {
				if ($('[data-edit_variants-variant-option="' + i + '"]', selectors.EditVariantContainer).length) {
					var isUpdate = false;
					$('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function() {
						var $element = $(this);
						var type = $element.attr('type');
						if (type === 'radio' || type === 'checkbox') {
							if (this.checked && $element.hasClass('disabled')) {
								$element.prop('checked', false);
								isUpdate = true;
								return false;
							}
						}
					});
					$('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function() {
						var $element = $(this);
						var type = $element.attr('type');
						if (isUpdate && (type === 'radio' || type === 'checkbox') && !$element.hasClass('disabled')) {
							$element.prop('checked', true);
							isUpdate = false;
							$element.trigger('change');
							return false;
						}
					});
				}
			}
		},
		updateMasterSelect: function(variant) {
			if (variant) {
				$(selectors.originalSelectorId, selectors.EditVariantContainer).val(variant.id);
			}
		},
		updateLabelvariant: function(variant) {
			var $element = $('.edit_variant-cart-container .content_product_detail .variants-wrapper')
			$($element).each(function() {
				var $this = $(this);
				var value = $('input:checked',$this).attr('value');
				$('.variants__label span',$this).html(value);
			});
		},
		updateMedia: function(variant) {
			if (variant && variant.featured_media && variant.featured_media.id) {
				$('.slick-carousel__item',selectors.EditVariantContainer).removeClass('show');
				$(selectors.EditVariantImages, selectors.EditVariantContainer).find('.edit_variant-images__item').each(function() {
					var imageID = $(this).data('media-id');
					if (variant.featured_media.id == imageID) {
						$(this).closest('.slick-carousel__item').addClass('show');
						var slickIndex = $(this).closest('.slick-carousel__item').data('slick-index');
						if (slickIndex !== undefined && slickIndex !== null) {
							$(selectors.EditVariantImages, selectors.EditVariantContainer).slick('slickGoTo', slickIndex);
						}
					}
				});
			}
		},

		updatePrice: function(variant) {
			var moneyFormat = leotriplet.strings.moneyFormat;
			if (!variant) {
				$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).addClass('d-none');
				$(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).addClass('d-none');
			} else {
				$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).removeClass('d-none');
				$(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).removeClass('d-none');
				$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).html(
					leotriplet.Currency.formatMoney(variant.price, moneyFormat)
				);
				if (variant.compare_at_price > variant.price) {
					$(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).html(
						leotriplet.Currency.formatMoney(variant.compare_at_price, moneyFormat)
					).removeClass('d-none');
					$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).addClass('on-sale');
				} else {
					$(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).addClass('d-none');
					$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).removeClass('on-sale');
				}
			}
			if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
		},

		updateProductavailable: function(variant) {
			var classActive = 'product-available--active';
			var translations = leotriplet.strings;
			$(selectors.EditVariantavailable, selectors.EditVariantContainer).removeClass(classActive);
			if (variant) {
				if (variant.available) {
					$(selectors.EditVariantQty, selectors.EditVariantContainer).removeClass('d-none');
					$(selectors.EditVariantavailableInStock, selectors.EditVariantContainer).addClass(classActive);
				} else {
					$(selectors.EditVariantQty, selectors.EditVariantContainer).addClass('d-none');
					$(selectors.EditVariantavailableOutStock, selectors.EditVariantContainer).addClass(classActive);
				}
				
				if (variant.available) {
					$(selectors.EditVariantContainer).find('.btn--add-to-cart')
						.removeClass('disabled')
						.prop('disabled', false);
					$(selectors.EditVariantContainer).find('.btn--add-to-cart .btn__text').html(translations.addToCart);
				} else {
					$(selectors.EditVariantContainer).find('.btn--add-to-cart')
						.addClass('disabled')
						.prop('disabled', true);
					$(selectors.EditVariantContainer).find('.btn--add-to-cart .btn__text').html(translations.soldOut);
				}
			} else {
				$(selectors.EditVariantQty, selectors.EditVariantContainer).addClass('d-none');
				$(selectors.EditVariantContainer).find('.btn--add-to-cart')
					.addClass('disabled')
					.prop('disabled', true);
				$(selectors.EditVariantContainer).find('.btn--add-to-cart .btn__text').html(translations.unavailable);
			}
		},

		updateDetailsLink: function(variant) {
			if (variant) {
				var productURL = $(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).data('url') + '?variant=' + variant.id;
				$(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).removeClass('d-none').attr('href', productURL);
			} else {
				$(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).addClass('d-none');
			}
		},

		onVariantChange: function(id_variant) {
			var variant = this.getVariantFromOptions();
			if ($('[data-single-option-button]', selectors.EditVariantContainer).length) {
				this.updateVariantsButton();
				if (!variant || !variant.available) {
					this.updateVariantsButtonDisabed();
					return;
				}
			}
			setTimeout(function(){
				if (variant.id != id_variant){
					$('.btn--add-to-cart',selectors.EditVariantContainer).prop('disabled', false);
				}else{
					$('.btn--add-to-cart',selectors.EditVariantContainer).prop('disabled', true);
				}
			}, 100);
			this.updateMasterSelect(variant);
			this.updateLabelvariant(variant);
			this.updateMedia(variant);
			this.updatePrice(variant);
			this.updateProductavailable(variant);
			this.updateDetailsLink(variant);
			this.currentVariant = variant;
		}
	});
	return EditVariant;
})();
var ajaxCartPage = (function(module, $) {
	'use strict';
	
	var init, loadCart;
	
	var settings, isUpdating, $body;
	
	var $formContainer,
		$cartCountSelector,
		$cartCostSelector,
		$cartContainer;
	
	var initializeEvents,
		updateCountPrice,
		itemAddedCallback,
		itemErrorCallback,
		cartUpdateCallback,
		buildCart,
		cartCallback,
		adjustCart,
		adjustCartCallback,
		validateQty;

	init = function(options) {
		
		settings = {
			cartContainer: '[data-cart-page-container]',
			cartCostSelector: '.cart-total__subtotal-price',
			cartRemoveSelector: '.cart-product-data--btn-remove',
			moneyFormat: '$',
			disableAjaxCart: false,
			cartTemplate: '#cart-form-template'
		};

		if (leotriplet.strings.moneyFormat !== undefined) {
			settings.moneyFormat = leotriplet.strings.moneyFormat;
		}

		
		$.extend(settings, options);

		
		$cartContainer = $(settings.cartContainer);
		$cartCostSelector = $(settings.cartCostSelector);

		$body = $('body');
		isUpdating = false;
		initializeEvents();
		adjustCart();
	};

	initializeEvents = function() {
		$body.on('click', settings.cartRemoveSelector, function(e) {
			e.preventDefault();
			if (isUpdating) {
				return;
			}
			var $el = $(this),
				line = $el.data('line');
			if (line) {
				$('.cart-item[data-line="' + line + '"]').addClass('cart--is_loading');
				isUpdating = true;
				setTimeout(function() {
					ShopifyAPI.changeItem(line, 0, adjustCartCallback);
				}, 250);
			}
		});
	};

	loadCart = function() {
		ShopifyAPI.getCart(cartUpdateCallback);
	};
	updateCountPrice = function(cart) {
		if ($cartCostSelector) {
			$cartCostSelector.html(
				leotriplet.Currency.formatMoney(cart.total_price, settings.moneyFormat)
			);
		}
	};
	cartUpdateCallback = function(cart, added) {
		updateCountPrice(cart);
		buildCart(cart);
		if(cart.item_count > 0) {
			$('.cart-page .cart_page-content').removeClass('hidden');
			$('.cart-page .cart-page__header').removeClass('hidden');
			$('.cart-page .cart-page-empty').addClass('hidden');
		}else{
			$('.cart-page .cart_page-content').addClass('hidden');
			$('.cart-page .cart-page__header').addClass('hidden');
			$('.cart-page .cart-page-empty').removeClass('hidden');
		}
	};

	buildCart = function(cart,edit_variant) {
		$cartContainer.empty();
		
          if (cart.item_count === 0) {
              $cartContainer.append(
                  '<p class="cart-empty-message">' +
                  leotriplet.strings.cartEmpty +
                  '</p>\n' +
                  '<p class="cookie-message">' +
                  leotriplet.strings.cartCookies +
                  '</p>\n' + 
                  '<a href="https://devangi-fashions.myshopify.com/collections/all" class="countinue-shop-btn"></a>'
              );
              
              cartCallback(cart);
              $('.cart-js-drawer .drawer__title .count').text('0');
              $('.shipping-bar-cart').addClass('hidden');
              return;
          }
		var items = [],
			item = {},
			data = {},
			source = $(settings.cartTemplate).html();
		var template = Handlebars.compile(source);
		$.each(cart.items, function(index, cartItem) {
			var prodImg;
			var unitPrice = null;
			if (cartItem.image !== null) {
				prodImg = cartItem.image.replace(/(\.[^.]*)$/, '_100x$1').replace('http:', '');
			} else {
				prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
			}
			if (cartItem.properties !== null) {
				$.each(cartItem.properties, function(key, value) {
					if (key.charAt(0) === '_' || !value) {
						delete cartItem.properties[key];
					}
				});
			}
			if (cartItem.properties !== null) {
				$.each(cartItem.properties, function(key, value) {
					if (key.charAt(0) === '_' || !value) {
						delete cartItem.properties[key];
					}
				});
			}
			if (cartItem.line_level_discount_allocations.length !== 0) {
				for (var discount in cartItem.line_level_discount_allocations) {
					var amount =  cartItem.line_level_discount_allocations[discount].amount;
					cartItem.line_level_discount_allocations[
						discount
					].formattedAmount = leotriplet.Currency.formatMoney(
						amount,
						settings.moneyFormat
					);
				}
			}
			if (cart.cart_level_discount_applications.length !== 0) {
				for (var cartDiscount in cart.cart_level_discount_applications) {
					var cartAmount =  cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
					cart.cart_level_discount_applications[cartDiscount].formattedAmount = leotriplet.Currency.formatMoney(
						cartAmount,
						settings.moneyFormat
					);
				}
			}
			if (cartItem.unit_price_measurement) {
				unitPrice = {
					addRefererenceValue:
					cartItem.unit_price_measurement.reference_value !== 1,
					price: leotriplet.Currency.formatMoney(cartItem.unit_price,settings.moneyFormat),
					reference_value: cartItem.unit_price_measurement.reference_value,
					reference_unit: cartItem.unit_price_measurement.reference_unit
				};
			}
		  
			item = {
				key: cartItem.key,
				line: index + 1, 
				url: cartItem.url,
				img: prodImg,
				name: cartItem.product_title,
				variation: cartItem.variant_title,
				variant: cartItem.variant_title === null ? false : true,
				options:cartItem.options_with_values,
				variant_id: cartItem.variant_id,
				price: leotriplet.Currency.formatMoney(
					cartItem.price,
					settings.moneyFormat
				),
				discountprice: leotriplet.Currency.formatMoney(
					cartItem.original_line_price,
					settings.moneyFormat
				),
				finalPrice: leotriplet.Currency.formatMoney(
					cartItem.final_line_price,
					settings.moneyFormat
				),
				handle:cartItem.handle,
				properties: cartItem.properties,
				itemAdd: cartItem.quantity + 1,
				itemMinus: cartItem.quantity - 1,
				itemQty: cartItem.quantity,
				discounts: cartItem.line_level_discount_allocations,
				discountsApplied:cartItem.line_level_discount_allocations.length === 0 ? false : true,
				vendor: cartItem.vendor,
				unitPrice: unitPrice
			};
			items.push(item);
		});
		
		data = {
			items: items,
			note: cart.note,
			totalPrice: leotriplet.Currency.formatMoney(
				cart.total_price,
				settings.moneyFormat
			),
			cartDiscounts: cart.cart_level_discount_applications,
			cartDiscountsApplied:cart.cart_level_discount_applications.length === 0 ? false : true
		};
		$cartContainer.append(template(data));
		cartCallback(cart);
		
		$('.cart-page .pre_order-cart >span').each(function(){
			var id = $(this).data('handle');
			for (var i in data.items) {
				if(data.items[i].variant_id == id) {
					$('.cart-page .cart-item[data-line="'+data.items[i].line+'"] .pre_order').removeClass('hidden');
				}
			}
		});
		if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
	};

	cartCallback = function(cart) {
		if (window.Shopify && Shopify.StorefrontExpressButtons) {
			Shopify.StorefrontExpressButtons.initialize();
		}
	};

	adjustCart = function() {
		$body.on('click', '#cart-form .ajaxcart__qty-adjust', function() {
			if (isUpdating) {return;}
			var $el = $(this),
				line = $el.data('line'),
				$qtySelector = $el.siblings('.ajaxcart__qty-num'),
				qty = parseInt($qtySelector.val().replace(/\D/g, ''));
			qty = validateQty(qty);
			if ($el.hasClass('ajaxcart__qty--plus')) {
				qty += 1;
			} else {
				qty -= 1;
				if (qty <= 0) qty = 0;
			}
			if (line) {
				updateQuantity(line, qty);
			} else {
				$qtySelector.val(qty);
			}
		});
		$body.on('change', '#cart-form .ajaxcart__qty-num', function() {
			if (isUpdating) {return;}
			var $el = $(this),
				line = $el.data('line'),
				qty = parseInt($el.val().replace(/\D/g, ''));
			qty = validateQty(qty);
			if (line) {
				updateQuantity(line, qty);
			}
		});
		$body.on('submit', '#cart-form ', function(evt) {
			if (isUpdating) {
				evt.preventDefault();
			}
		});
		$body.on('focus', '#cart-form .ajaxcart__qty-adjust', function() {
			var $el = $(this);
			setTimeout(function() {
				$el.select();
			}, 50);
		});
		function updateQuantity(line, qty) {
			isUpdating = true;
			var $row = $('#cart-form .cart-item[data-line="' + line + '"]').addClass('cart--is_loading');
			if (qty === 0) {
				$row.parent().addClass('is-removed');
			}
			setTimeout(function() {
				ShopifyAPI.changeItem(line, qty, adjustCartCallback);
			}, 250);
		}
	};
	adjustCartCallback = function(cart) {
		updateCountPrice(cart);
		ajaxCart.load();
		setTimeout(function() {
			ShopifyAPI.getCart(buildCart);
			isUpdating = false;
			if(cart.item_count > 0) {
				$('.cart-page .cart_page-content').removeClass('hidden');
				$('.cart-page .cart-page__header').removeClass('hidden');
				$('.cart-page .cart-page-empty').addClass('hidden');
			}else{
				$('.cart-page .cart_page-content').addClass('hidden');
				$('.cart-page .cart-page__header').addClass('hidden');
				$('.cart-page .cart-page-empty').removeClass('hidden');
			}
		}, 150);
	};
	validateQty = function(qty) {
		if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
		
		} else {
		qty = 1;
		}
		return qty;
	};
	module = {
		init: init,
		load: loadCart
	};
	return module;
})(ajaxCartPage || {}, jQuery);
leotriplet.ajax_cartpage = function() {
	if ($('body').hasClass('cart--template') ) {
		ajaxCartPage.init();
		ajaxCartPage.load();
	}
};

/*---------------------------------------------------------------------------------*/
/*---------------------------- Checkbox Terms & Condition -------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.checkbox_terms_conditions = function() {
		// if ($(".agree-terms_and_conditions").is(":checked")) {
		//    $('[name="checkout"]').prop('disabled', false);
		// } else {
  //   	   $('[name="checkout"]').prop('disabled', true);
		// }
		
		
		
		
		
		
		
		$("body").on("click",'.agree-terms_and_conditions',function () {
				if ($(this).is(":checked")) {
					$('body').find('.agree-terms_and_conditions').each(function() {
						$(this).attr("checked", "checked");
					});
					 $('[name="checkout"]').prop('disabled', false);
				} else {
					$('body').find('.agree-terms_and_conditions').each(function() {
						$(this).removeAttr('checked');
					});
					$('[name="checkout"]').prop('disabled', true);
				}
		});
};


/*---------------------------------------------------------------------------------*/
/*----------------------------------- Related Products ----------------------------*/
/*---------------------------------------------------------------------------------*/



leotriplet.ProductRelated = (function() {
  function ProductRelated(container) {
    this.$container = $(container);
    var self = this;
    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var productLimit = 100; // Set this to a high value to load all products
    
    var relatedSectionUrl = baseUrl + '?section_id=related-products&product_id=' + productId + '&limit=' + productLimit;
    
    $.get(relatedSectionUrl).then(function(section) {
      var recommendationsMarkup = $(section).html();
      if (recommendationsMarkup.trim() !== '') {
        self.$container.html(recommendationsMarkup);
        var $element = $('.leotriplet-related-products', self.$container);
        initButtons(".leotriplet-related-products");
        leotriplet.click_atribute_image();
        leotriplet.zoom_thumb();
        if ($('.leotriplet_currency').length > 0) {
          Currency.Currency_customer(true);
        }
      }
    });
  }
  return ProductRelated;
})();




/*---------------------------------------------------------------------------------*/
/*---------------------------------- Collection Page ------------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.hideLoading = function() {
	$('.leotriplet-loading').remove();
};

leotriplet.collectionPages = (function() {
  var leotripletFilter = '.js-collection-page',
	leotripletCollectionProduct = '#Collection--Product',
	leotripletFilterContentProduct = '.collection-content--product',
	leotripletFilterSidebar = '.collection-sidebar',
	leotripletFilterTitle = '.leotriplet-breadcrumbs__inner',	
	leotripletFacetsContainer = '.active-facets-desktop',
    pktChangeView = '.js-change-view',
	canbeloaded = true,
    pktSortBy = '.js-sortby';

  var ajaxFilterParams,
    ajaxFilterGetCollectionUrl,
    ajaxFilterCreateUrl,
    ajaxFilterChangeView,
		ajaxFilterCategory,
		ajaxBreadcrumbsCategory,
		ajaxFilterLoadMore,
		ajaxFilterInfinity,
    ajaxFilterPaging;

	var init = function() {
			if ($(leotripletFilter)) {
				var History = window.History;
				History.Adapter.bind(window, 'statechange', function() {
				History.getState();
			});
		 }
		ajaxFilterParams();
		ajaxFilterChangeView();
		ajaxFilterCategory();
		ajaxBreadcrumbsCategory();
		ajaxFilterLoadMore();
		ajaxFilterInfinity();
		ajaxFilterPaging();
		
	};


	ajaxFilterParams = function() {
		Shopify.queryParams = {};
		if (location.search.length) {
		  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
			aKeyValue = aCouples[i].split('=');
			if (aKeyValue.length > 1) {
			  Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
			}
		  }
		}
	};
	ajaxFilterGetCollectionUrl = function(collection, url) {
		var str = url;
		var indexCollection = str.indexOf(collection);
		if(indexCollection < 0)
			return '';
		str = str.slice(indexCollection + collection.length, str.length);
		var indexSlash = str.indexOf('/') > -1 ? str.indexOf('/') : str.length;
		str = str.slice(0, indexSlash).toLowerCase();
		return str.replace('=', '');
	};
	ajaxFilterCreateUrl = function(baseLink) {
		var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
		var collectionHandle = ajaxFilterGetCollectionUrl('/collections/', location.pathname);
		var pathName = '/collections/' + collectionHandle;
		var arrayUrl = location.pathname.split('/');
		if (arrayUrl.length >= 4) {
			var currentTagName = arrayUrl[3].split('?').shift();
			if (currentTagName != '') {
				newQuery = newQuery + '+' + currentTagName;
			}
		}
		if (baseLink) {
			if (newQuery != '')
				return baseLink + '?' + newQuery;
			else
				return baseLink;
		}
		return pathName + '?' + newQuery;
	};
	ajaxFilterChangeView = function() {
		$(leotripletFilter).on('click', pktChangeView, function(e) {
			e.preventDefault();
			if (!$(this).hasClass('active')) {
				$('.product-grid__image-wrapper.slider',leotripletFilterContentProduct).each(function() {
					$('.leotriplet-slick-slider',$(this)).slick('refresh');
				});
				leotriplet.setCookie("leotriplet_view_collection", $(this).data('view'), 1);
				$(pktChangeView).removeClass('active');
				$(this).addClass('active');
				$(leotripletCollectionProduct).removeAttr('class');
				$(leotripletCollectionProduct).addClass($(this).data('view'));
			}
		});
	};
	ajaxFilterPaging = function() {
		$(leotripletFilter).on('click', '.js-collection--pagination a', function(e) {
			e.preventDefault();
			var pageURL = $(this).attr('href').match(/page=\d+/g);
			if (pageURL) {
				Shopify.queryParams.page = parseInt(pageURL[0].match(/\d+/g));
				var searchParams = ( window.history.state && window.history.state.searchParams ) ? window.history.state.searchParams : '';
				var newurl = ajaxFilterCreateUrl();
				history.pushState({ searchParams }, '', `${newurl}${searchParams && '&'.concat(searchParams)}`);
				$.ajax({
					type: 'get',
					url: `${newurl}${searchParams && '&'.concat(searchParams)}`,
					success: function(data) {
						$(leotripletFilterContentProduct).replaceWith($(data).find(leotripletFilterContentProduct));					
						$('.product-grid__image-wrapper.slider',leotripletFilterContentProduct).each(function() {
							leotriplet.elementslickCarousel( $('.leotriplet-slick-slider',$(this)) );
						});
						if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
						leotriplet.click_atribute_image();
						leotriplet.zoom_thumb();
						if(window.SPR){
							SPR.initRatingHandler ();
							SPR.initDomEls ();
							SPR.loadProducts ();
							SPR.loadBadges ();
						}
						if ($('#Collection--Product').hasClass('grid-col-4')) {
								$('.collection-view--btn').removeClass('active');
								$('a[data-view="grid-col-4"]').addClass('active');
						}
						if ($('#Collection--Product').hasClass('grid-col-2')) {
								$('.collection-view--btn').removeClass('active');
								$('a[data-view="grid-col-2"]').addClass('active');
						}
						if ($('#Collection--Product').hasClass('grid-col-3')) {
								$('.collection-view--btn').removeClass('active');
								$('a[data-view="grid-col-3"]').addClass('active');
						}
						if ($('#Collection--Product').hasClass('list')) {
								$('.collection-view--btn').removeClass('active');
								$('a[data-view="list"]').addClass('active');
						}
						initButtons();
						leotriplet.sidebarCollection();
						$('.js-collection-page h4.sidebar-filter-block--title').on( "click", function($element) {
							if($('.js-collection-page').hasClass('dropdown')){
								if( !$(this).hasClass('active') ){
									$('.js-collection-page.dropdown .facets--display').slideUp();
									$('.js-collection-page.dropdown h4.sidebar-filter-block--title').removeClass("active");
								}
							}
							if($element){
								if($('.js-collection-page').hasClass('dropdown')){
									var $parent = $(this).closest('.leotriplet-filter');
								}else{
									var $parent = $(this).closest('.leotriplet-filter:not(.categories-in-sidebar)');
								}
							}else{
								var $parent = $(this).closest('.leotriplet-filter');
							}
							if( $('h4.sidebar-filter-block--title', $parent).hasClass('active') ){
								$('h4.sidebar-filter-block--title', $parent).removeClass("active");
							}else{
								$('h4.sidebar-filter-block--title',$parent).addClass("active");
							}
							$('.facets--display',$parent).slideToggle();
						});
						if($('.js-collection-page').hasClass('viewmore')){
							var number_list = $('.js-collection-page').data('list_number');
							if($('.js-collection-page').hasClass('sidebar') || $('.js-collection-page').hasClass('side_out') ){
								if($element){
									var list = $('.leotriplet-filter:not(.sidebar-categories,.leotriplet-filter-price,.filter-image,.filter-label)');
								}else{
									var list = $('.leotriplet-filter:not(.leotriplet-filter-price,.filter-image,.filter-label)');
								}
							}else if($('.js-collection-page').hasClass('dropdown')){
								var list = $('.leotriplet-filter:not(.filter-image)');
							}
							$(list).each(function(){
								var count_sidebar_1 = $('.facets--display>ul>li',$(this)).length;
								if(!$('.facets--display>ul>li.view',$(this)).length){
									if( count_sidebar_1 > number_list ){
										$('.facets--display>ul',$(this)).append('<li class="view"><span class="animate_link with_bottomline">'+window.strings.view_more+'</span></li>');
									}
								}
								$('.facets--display>ul>li:not(.view)',$(this)).each(function(index){
									if( index + 1 > number_list ){
										$(this).css("display","none");
									}	
								});
							});
							
							$('.facets--display>ul>li.view',list).on( "click", function() {
								var $parent = $(this).closest('ul');
								$('>li:not(.view)', $parent).each(function(index){
									if( index + 1 > number_list ){
										$(this).slideToggle();
									}
								});
								if($(this).hasClass('show')){
									$(this).removeClass('show');
									$('span',$(this)).text(window.strings.view_more);
									return;
								}else{
									$(this).addClass('show');
									$('span',$(this)).text(window.strings.view_less);
									return;
								}
							});
						}
						leotriplet.toggleSidebar();
					},
					error: function(xhr, text) {
						console.log(text);
					}
				});
				$('body,html').animate({
					scrollTop: $('#header').height()
				}, 600);
			}
		});
	};
	ajaxFilterLoadMore = function() {
		$(leotripletFilter).on('click', '.js-collection--loadmore a', function(e) {
			e.preventDefault();
			var pageURL = $(this).attr('href').match(/page=\d+/g);
			$(this).addClass('active');
			if (pageURL) {
				Shopify.queryParams.page = parseInt(pageURL[0].match(/\d+/g));
				var searchParams = ( window.history.state && window.history.state.searchParams ) ? window.history.state.searchParams : '';
				var newurl = ajaxFilterCreateUrl();
				$.ajax({
					type: 'get',
					url: `${newurl}${searchParams && '&'.concat(searchParams)}`,
					success: function(data) {
						$(".products_row",leotripletFilterContentProduct).append($(data).find(".products_row").html());
						$('.js-collection--loadmore').empty();
						$(".js-collection--loadmore",leotripletFilterContentProduct).append($(data).find(".js-collection--loadmore").html());
						$('.product-grid__image-wrapper.slider',leotripletFilterContentProduct).each(function() {
							if(!$('.leotriplet-slick-slider',$(this)).hasClass("slick-initialized")){
								leotriplet.elementslickCarousel( $('.leotriplet-slick-slider',$(this)) );
							}
						});
						if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
						if(window.SPR){
							SPR.registerCallbacks();
							SPR.initRatingHandler();
							SPR.initDomEls();
							SPR.loadProducts();
							SPR.loadBadges();
						}
						leotriplet.click_atribute_image();
						leotriplet.zoom_thumb();
						//leotriplet.popup_product_card();
						initButtons();
						//initButtonsCompare();
						leotriplet.sidebarCollection();
						$(this).removeClass('active');
					},
					error: function(xhr, text) {
						console.log(text);
					}
				});
			}
		});
	};
	ajaxFilterInfinity = function() {
		if( $( ".js-collection--infinite").length > 0 ){
			$(window).scroll(function(){
				if ( $(document).scrollTop() > ( $(document).height() - 2000 ) && canbeloaded==true && $( ".js-collection--infinite").length > 0 ){
					$( ".js-collection--infinite a").addClass("active");
					var pageURL = $("a",".js-collection--infinite").attr('href').match(/page=\d+/g);
					if (pageURL) {
						Shopify.queryParams.page = parseInt(pageURL[0].match(/\d+/g));
						var searchParams = ( window.history.state && window.history.state.searchParams ) ? window.history.state.searchParams : '';
						var newurl = ajaxFilterCreateUrl();
						$.ajax({
							type: 'get',
							url: `${newurl}${searchParams && '&'.concat(searchParams)}`,
							beforeSend: function( xhr ){
								
								canbeloaded = false;
							},
							success: function(data) {
								canbeloaded = true;
								$(".products_row",leotripletFilterContentProduct).append($(data).find(".products_row").html());
								$('.js-collection--infinite').empty();
								$(".js-collection--infinite",leotripletFilterContentProduct).append($(data).find(".js-collection--infinite").html());
								$('.product-grid__image-wrapper.slider',leotripletFilterContentProduct).each(function() {
									if(!$('.leotriplet-slick-slider',$(this)).hasClass("slick-initialized")){
										leotriplet.elementslickCarousel( $('.leotriplet-slick-slider',$(this)) );
									}
								});
								if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
								if(window.SPR){
									SPR.initRatingHandler();
									SPR.initDomEls();
									SPR.loadProducts();
									SPR.loadBadges();
								}
								leotriplet.click_atribute_image();
								leotriplet.zoom_thumb();
								//leotriplet.popup_product_card();
								initButtons();
								leotriplet.sidebarCollection();
							},
							error: function(xhr, text) {
								console.log(text);
							}
						});
					}
				}
			});
		}
	};	
	ajaxFilterCategory = function($element) {
		var leotripletFacetsWrapper = '.FacetsWrapperDesktop ';
		if($element){
			var $categories = $element;
		}else{
			var $categories = $('.categories-in-sidebar');
		}
		if ( $('.leotriplet-breadcrumbs').hasClass('have-collection') ) {
			var $collection = true;
		}
		$($categories).on('click', 'a', function(e){
			e.preventDefault();
			var pageURL = $(this).attr('href');
			var newTitle = $(this).attr('title');
			History.pushState({
			  param: Shopify.queryParams
			}, pageURL, pageURL);	
			delete Shopify.queryParams.page;
			$("#leotriplet-progress-loading").addClass('load-product');
			$('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"40%"});
			$.ajax({
				type: 'get',
				url: pageURL,
				success: function(data) {
					document.title = newTitle;			
					$(leotripletFilterContentProduct).replaceWith($(data).find(leotripletFilterContentProduct));
					$(leotripletFilterSidebar).replaceWith($(data).find(leotripletFilterSidebar));
					$(leotripletFilterTitle).replaceWith($(data).find(leotripletFilterTitle));
					$(leotripletFacetsContainer).replaceWith($(data).find(leotripletFacetsContainer));
					if($('.js-collection-page').hasClass('dropdown')){
						$(leotripletFacetsWrapper).replaceWith($(data).find(leotripletFacetsWrapper));
						leotriplet.countActiveSidebar();
					}
					$('.leotriplet-breadcrumbs__image').replaceWith($(data).find('.leotriplet-breadcrumbs__image'));
					if ( $collection ) {
						leotriplet.elementslickCarousel( $('.leotriplet-breadcrumbs__image .leotriplet-slick-slider') );
					}			
					ajaxFilterCategory();
					leotriplet.click_atribute_image();
					leotriplet.zoom_thumb();
					$('.product-grid__image-wrapper.slider',leotripletFilterContentProduct).each(function() {
						leotriplet.elementslickCarousel( $('.leotriplet-slick-slider',$(this)) );
					});
					if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
					leotriplet.hideLoading();
					if(window.SPR){
						SPR.initRatingHandler ();
						SPR.initDomEls ();
						SPR.loadProducts ();
						SPR.loadBadges ();
					}
					ajaxFilterChangeView();
					leotriplet.sidebarCollection();
					initButtons();
					leotriplet.toggleSidebar();
					$('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"100%"});
					setTimeout(function() { 
						$('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"0"});
						$("#leotriplet-progress-loading").removeClass('load-product');
					}, 500);
				},
				error: function(xhr, text) {
					console.log(text);
				}
			});			
			$('body,html').animate({
				scrollTop: $('#header').height()
			}, 600);
		});
	};	
	ajaxBreadcrumbsCategory = function($element) {
		if($element){
			var $categories = $element;
		}else{
			var $categories = $('.leotriplet-breadcrumbs .pkt_slider-carousel');
		}
		if ( $('.leotriplet-breadcrumbs').hasClass('have-collection') ) {
			var $collection = true;
		}
		$($categories).on('click', 'a', function(e){
			e.preventDefault();
			var pageURL = $(this).attr('href');
			var newTitle = $("h2",$(this)).text();
			History.pushState({
			  param: Shopify.queryParams
			}, pageURL, pageURL);	
			delete Shopify.queryParams.page;
			$("#leotriplet-progress-loading").addClass('load-product');
			$('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"40%"});
			$.ajax({
				type: 'get',
				url: pageURL,
				success: function(data) {
					document.title = newTitle;			
					$(leotripletFilterContentProduct).replaceWith($(data).find(leotripletFilterContentProduct));
					$(leotripletFilterSidebar).replaceWith($(data).find(leotripletFilterSidebar));
					$(leotripletFilterTitle).replaceWith($(data).find(leotripletFilterTitle));
					$(leotripletFacetsContainer).replaceWith($(data).find(leotripletFacetsContainer));
					$('.leotriplet-breadcrumbs__image').replaceWith($(data).find('.leotriplet-breadcrumbs__image'));
					ajaxFilterCategory( $('.categories-in-sidebar') );
					$('.product-grid__image-wrapper.slider',leotripletFilterContentProduct).each(function() {
						leotriplet.elementslickCarousel( $('.leotriplet-slick-slider',$(this)) );
					});
					if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
					ajaxBreadcrumbsCategory();
					leotriplet.click_atribute_image();
					leotriplet.zoom_thumb();
					leotriplet.hideLoading();
					if(window.SPR){
						SPR.initRatingHandler ();
						SPR.initDomEls ();
						SPR.loadProducts ();
						SPR.loadBadges ();
					}
					leotriplet.sidebarCollection();
					initButtonsCompare();
					initButtons();
					leotriplet.countActiveSidebar();
					if(!$('.js-collection-page').hasClass('dropdown')){
						leotriplet.toggleSidebar();
					}
					if ( $collection ) {
						leotriplet.elementslickCarousel( $('.leotriplet-breadcrumbs__image .leotriplet-slick-slider') );
					}
					ajaxFilterChangeView();
					$('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"100%"});
					setTimeout(function() { 
						$('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"0"});
						$("#leotriplet-progress-loading").removeClass('load-product');
					}, 500);
				},
				error: function(xhr, text) {
					console.log(text);
				}
			});			
			$('body,html').animate({
				scrollTop: $('#header').height()
			}, 600);
		});
	};
	return init;
})();



leotriplet.toggleSidebar = function($element) {
	$('.js-collection-page h4.sidebar-filter-block--title').on( "click", function() {
		if($('.js-collection-page').hasClass('dropdown')){
			if( !$(this).hasClass('active') ){
				$('.js-collection-page.dropdown .facets--display').slideUp();
				$('.js-collection-page.dropdown h4.sidebar-filter-block--title').removeClass("active");
			}
		}
		if($element){
			if($('.js-collection-page').hasClass('dropdown')){
				var $parent = $(this).closest('.leotriplet-filter');
			}else{
				var $parent = $(this).closest('.leotriplet-filter:not(.categories-in-sidebar)');
			}
		}else{
			var $parent = $(this).closest('.leotriplet-filter');
		}
		if( $('h4.sidebar-filter-block--title', $parent).hasClass('active') ){
			$('h4.sidebar-filter-block--title', $parent).removeClass("active");
		}else{
			$('h4.sidebar-filter-block--title',$parent).addClass("active");
		}
		$('.facets--display',$parent).slideToggle();
	});

	$('.js-collection-page .collection-sidebar--overlay').on( "click", function(e) {
		if($('body').hasClass('open--Sidebar')){
				$('body').removeClass('open--Sidebar');
		}
	});

	if($('.js-collection-page').hasClass('viewmore')){
		var number_list = $('.js-collection-page').data('list_number');
		if($('.js-collection-page').hasClass('sidebar') || $('.js-collection-page').hasClass('side_out') ){
			if($element){
				var list = $('.leotriplet-filter:not(.sidebar-categories,.leotriplet-filter-price,.filter-image,.filter-label)');
			}else{
				var list = $('.leotriplet-filter:not(.leotriplet-filter-price,.filter-image,.filter-label)');
			}
		}else if($('.js-collection-page').hasClass('dropdown')){
			var list = $('.leotriplet-filter:not(.filter-image)');
		}
		$(list).each(function(){
			var count_sidebar_1 = $('.facets--display>ul>li',$(this)).length;
			if(!$('.facets--display>ul>li.view',$(this)).length){
				if( count_sidebar_1 > number_list ){
					$('.facets--display>ul',$(this)).append('<li class="view"><span class="animate_link with_bottomline">'+window.strings.view_more+'</span></li>');
				}
			}
			$('.facets--display>ul>li:not(.view)',$(this)).each(function(index){
				if( index + 1 > number_list ){
					$(this).css("display","none");
				}	
			});
		});
		
		$('.facets--display>ul>li.view',list).on( "click", function() {
			var $parent = $(this).closest('ul');
			$('>li:not(.view)', $parent).each(function(index){
				if( index + 1 > number_list ){
					$(this).slideToggle();
				}
			});
			if($(this).hasClass('show')){
				$(this).removeClass('show');
				$('span',$(this)).text(window.strings.view_more);
				return;
			}else{
				$(this).addClass('show');
				$('span',$(this)).text(window.strings.view_less);
				return;
			}
		});
	}
};
leotriplet.sidebarCollection = function($element) {
	if($element){
		var $parent = $('.js-collection-page .FacetsWrapperDesktop');
	}else{
		var $parent = $('.js-collection-page');
	}
	$(".categories-in-sidebar ul li a",$parent).on( "click", function() {
		var $parent = $(this).closest('li');
		$(".categories-in-sidebar ul li").removeClass("active");
		if( !$parent.hasClass('active') ){
			$parent.addClass("active");
		}
	});
	$(".categories-in-sidebar .toggle-collection--children",$parent).on( "click", function() {
		var $parent = $(this).closest('li');
		$(this).toggleClass("show");
		$('>.collection--children',$parent).slideToggle();
	});
	$('.categories-in-sidebar .collection--children li',$parent).each(function(){
		if( $(this).hasClass('active') ){
			var $parent = $(this).parents('.collection--children');
			var $parent2 = $(this).parents('li');
			$parent.css({"display": "block"});
			if( !$('>.collection-link >.toggle-collection--children',$parent2).hasClass('show') ){
				$('>.collection-link >.toggle-collection--children',$parent2).addClass("show");
			}
		}
	});
};
leotriplet.countActiveSidebar = function() {
	var count = 0;
	if($('.js-collection-page').hasClass('dropdown') ){
		var $parent_collection = $('.js-collection-page .FacetsWrapperDesktop')
	}else{
		var $parent_collection = $('.js-collection-page .collection-sidebar')
	}
	$('.leotriplet-filter',$parent_collection).each(function(){
		count = $('input:checked',$(this)).length;
		if(count > 0){
			$('.sidebar-filter-block--title .count',$(this)).removeClass('hide');
			$('.facets--display .reset-filter',$(this)).removeClass('hide');
			$('.sidebar-filter-block--title .count',$(this)).text(count);
		}else{
			$('.sidebar-filter-block--title .count',$(this)).addClass('hide');
		}
		if($(this).hasClass('show')){
			if( $('h4.sidebar-filter-block--title',$(this)).hasClass('active') ){
				$('h4.sidebar-filter-block--title',$(this)).removeClass("active");
			}else{
				$('h4.sidebar-filter-block--title',$(this)).addClass("active");
			}
		}
	});
	var count_sidebar = $('.js-collection-page.dropdown .categories-in-sidebar ul li.active').length;
	if(count_sidebar > 0){
		$('.js-collection-page.dropdown .categories-in-sidebar .sidebar-filter-block--title .count').removeClass('hide');
	}else{
		$('.js-collection-page.dropdown .categories-in-sidebar .sidebar-filter-block--title .count').addClass('hide');
	}
	$('.collection-sidebar .leotriplet-filter .facets--display .select-filter label').on( "click", function() {
		$('.collection-sidebar .leotriplet-filter').removeClass('show');
		var $parent = $(this).closest('.leotriplet-filter');
		$parent.addClass('show');
	});
	$('.collection-sidebar .leotriplet-filter .facets--display .facets__price input').change(function(){
		$('.collection-sidebar .leotriplet-filter').removeClass('show');
		var $parent = $(this).closest('.leotriplet-filter');
		$parent.addClass('show');
	});
	$('.js-collection-page.on_top .leotriplet-filter .facets--display li label').on( "click", function() {
		var $parent = $(this).closest('.js-collection-page.on_top ');
		if(!$parent.hasClass('show')){
			$parent.addClass('show');
		}
	});
	$('.js-collection-page.on_top .leotriplet-filter .facets--display .facets__price input').change(function(){
		var $parent = $(this).closest('.js-collection-page.on_top ');
		if(!$parent.hasClass('show')){
			$parent.addClass('show');
		}
	});
};


/*---------------------------------------------------------------------------------*/
/*------------------------------------ Header Section -------------------------------*/
/*---------------------------------------------------------------------------------*/


leotriplet.HeaderSection = (function() {
  var selectors = {
		disclosureLocale: '[data-disclosure-locale]',
    menuMobileToggle : '.js-menu-mobile',
    menuMobileChildToggle: '.js-mobilemenu-nav-item'
  };

  function Header(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();
    var $body = $('body');
		if (this.cache.$localeDisclosure.length) {
			this.localeDisclosure = new leotriplet.Disclosure(
				this.cache.$localeDisclosure
			);
		}

    this.cache.$menuMobileToggle.on('click', function(evt) {
      evt.preventDefault();
      $body.toggleClass('menu-mobile--open');
    });

    this.cache.$menuMobileChildToggle.on('click', function(evt) {
      evt.preventDefault();
      var $this = $(this);
      if ($this.hasClass('mobilemenu-nav_prev')) {
        $this.closest('.active--hidden').removeClass('active--hidden');
      } else {
        $this.parents('.mobilemenu-nav_links').addClass('active--hidden');
      }
      $this.closest('.mobile-menu_nav-item').toggleClass('active');
    });
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    cacheSelectors: function() {
      this.cache = {
				$localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $menuMobileToggle: this.$container.find(selectors.menuMobileToggle),
        $menuMobileChildToggle: this.$container.find(selectors.menuMobileChildToggle)
      };
    },
		onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }
    }
  });

  return Header;
})();

/*---------------------------------------------------------------------------------*/
/*------------------------------------ Sticky Header ------------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.sticky_header = function(){
	if($(".main-header").data("sticky_header")){
		var current_scroll = 0;
		var leotriplet_width = $( window ).width();
		$( window ).scroll(function() {
			var next_scroll = $(this).scrollTop();
			if ( next_scroll > 200) {
				$('.main-header').addClass('sticky');
				$('.leotriplet-header').addClass('sticky');
			} else if ( next_scroll <=200 ) {
				$('.main-header').removeClass('sticky');
				$('.leotriplet-header').removeClass('sticky');
			}
			current_scroll = next_scroll;  
		});
	}
}


/*---------------------------------------------------------------------------------*/
/*------------------------------------ Header Account -------------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.headeraccount = function() {
	$(".sticky_header .header_user_account").hover(function() {
		var isHovered = $(this).is(":hover");
		if (isHovered) {
			$('.sticky_header .account_dropdown').stop().slideDown(300);
		} else {
			$('.sticky_header .account_dropdown').stop().slideUp(300);
		}
	});
	$(".desktop_header .header_user_account").hover(function() {
		var ifHovered = $(this).is(":hover");
		if (ifHovered) {
			$('.desktop_header .account_dropdown').stop().slideDown(300);
		} else {
			$('.desktop_header .account_dropdown').stop().slideUp(300);
		}
	});
};


/*---------------------------------------------------------------------------------*/
/*------------------------------- Login-Register Popup ----------------------------*/
/*---------------------------------------------------------------------------------*/





leotriplet.LoginForm = (function() {
	var selectors = {
		loginForm: '.js-login-form',
		recoverPasswordForm: '.js-recover-password',
		recoverPasswordToggle: '.js-forget-password-login',
		recoverPasswordSuccess: '.js-recover-password-success-info'
	};
	function LoginForm(container) {
		this.$container = $(container);
		this.cache = {};
		this.classes = {
			hidden: 'd-none'
		};
		this.cacheSelectors();
		this.initializeEvents();
		this.resetPasswordSuccess();
	}
	LoginForm.prototype = _.assignIn({}, LoginForm.prototype, {
		cacheSelectors: function() {
			this.cache = {
				$loginForm: this.$container.find(selectors.loginForm),
				$recoverPasswordForm: this.$container.find(selectors.recoverPasswordForm),
				$recoverPasswordToggle: this.$container.find(selectors.recoverPasswordToggle),
				$recoverPasswordSuccess: this.$container.find(selectors.recoverPasswordSuccess)
			};
		},
		initializeEvents: function() {
			if (this.cache.$recoverPasswordToggle.length) {
				this.cache.$recoverPasswordToggle.on('click', function(e) {
					e.preventDefault();
					var isShow = this.cache.$loginForm.hasClass(this.classes.hidden) ? false : true;
					this.displayRecoverPasswordForm(isShow);
				}.bind(this));
			}
			if (window.location.hash === '#recover') {
				this.displayRecoverPasswordForm(true);
			}
		},
		displayRecoverPasswordForm: function(isShow) {
			if (isShow) {
				this.cache.$loginForm.addClass(this.classes.hidden);
				this.cache.$recoverPasswordForm.removeClass(this.classes.hidden);
			} else {
				this.cache.$loginForm.removeClass(this.classes.hidden);
				this.cache.$recoverPasswordForm.addClass(this.classes.hidden);
			}
		},
		resetPasswordSuccess: function() {
			if (typeof(window.resetPassword) != 'undefined' && window.resetPassword) {
				this.cache.$recoverPasswordSuccess.removeClass(this.classes.hidden);
			}
		}
	});
	return LoginForm;
})();

leotriplet.loginpopupopen = function(){
	$(".desktop_header .header_user_account [data-login-account]").on( "click", function(e) {
		e.preventDefault();
		$('.desktop_header .account_dropdown').css('display','none');
		var $loginelement = $('.desktop_header [data-login_popup]');
		var $registerelement = $('.desktop_header [data-register_popup]');
		if($loginelement.hasClass('active')){
			$loginelement.removeClass('active');
			$('body').removeClass('active_login_register');
			$('body').css('overflow', 'unset');
		}else{
			$loginelement.addClass('active');
			$('body').css('overflow', 'hidden');
			$('body').addClass('active_login_register');
			$registerelement.removeClass('active');
		}
	});
	$(".desktop_header [data-close_login_popup]").on( "click", function(e) {
		e.preventDefault();
		var $element = $('.desktop_header [data-login_popup]');
		if($element.hasClass('active')){
			$element.removeClass('active');
			$('body').removeClass('active_login_register');
			$('body').css('overflow', 'unset');
		}
	});
	$(".desktop_header .header_user_account [data-register-account]").on( "click", function(e) {
		e.preventDefault();
		$('.desktop_header .account_dropdown').css('display','none');
		var $registerelement = $('.desktop_header [data-register_popup]');
		var $loginelement = $('.desktop_header [data-login_popup]');
		if($registerelement.hasClass('active')){
			$registerelement.removeClass('active');
			$('body').removeClass('active_login_register');
			$('body').css('overflow', 'unset');
		}else{
			$registerelement.addClass('active');
			$('body').css('overflow', 'hidden');
			$loginelement.removeClass('active');
			$('body').addClass('active_login_register');
		}
	});
	$(".desktop_header [data-close_login_popup]").on( "click", function(e) {
		e.preventDefault();
		var $element = $('.desktop_header [data-register_popup]');
		if($element.hasClass('active')){
			$element.removeClass('active');
			$('body').removeClass('active_login_register');
			$('body').css('overflow', 'unset');
		}
	});
	$(".sticky_header .header_user_account [data-login-account]").on( "click", function(e) {
		e.preventDefault();
		$('.sticky_header .account_dropdown').css('display','none');
		var $loginelement = $('.sticky_header [data-login_popup]');
		var $registerelement = $('.sticky_header [data-register_popup]');
		if($loginelement.hasClass('active')){
			$loginelement.removeClass('active');
			$('body').removeClass('active_login_register');
			$('body').css('overflow', 'unset');
		}else{
			$loginelement.addClass('active');
			$('body').css('overflow', 'hidden');
			$('body').addClass('active_login_register');
			$registerelement.removeClass('active');
		}
	});
	$(".sticky_header [data-close_login_popup]").on( "click", function(e) {
		e.preventDefault();
		var $element = $('.sticky_header [data-login_popup]');
		if($element.hasClass('active')){
			$element.removeClass('active');
			$('body').removeClass('active_login_register');
			$('body').css('overflow', 'unset');
		}
	});
	$(".sticky_header .header_user_account [data-register-account]").on( "click", function(e) {
		e.preventDefault();
		$('.sticky_header .account_dropdown').css('display','none');
		var $registerelement = $('.sticky_header [data-register_popup]');
		var $loginelement = $('.sticky_header [data-login_popup]');
		if($registerelement.hasClass('active')){
			$registerelement.removeClass('active');
			$('body').removeClass('active_login_register');
			$('body').css('overflow', 'unset');
		}else{
			$registerelement.addClass('active');
			$('body').addClass('active_login_register');
			$('body').css('overflow', 'hidden');
			$loginelement.removeClass('active');
		}
	});
	$(".sticky_header [data-close_login_popup]").on( "click", function(e) {
		e.preventDefault();
		var $element = $('.sticky_header [data-register_popup]');
		if($element.hasClass('active')){
			$element.removeClass('active');
			$('body').removeClass('active_login_register');
			$('body').css('overflow', 'unset');
		}
	});
}

leotriplet.registerpopuppasswordvalidation = function() {
	$('.sticky_header #registerpassword, .sticky_header #registerconfirm-password').keyup(validateloginpopup); 
	function validateloginpopup() {
		var reg_password = $(".sticky_header #registerpassword").val();
		var regcon_password = $(".sticky_header #registerconfirm-password").val();
		if(reg_password === regcon_password) {
				 $('.sticky_header #validate-status-inpopup').css({'color' : 'green'});
				 $('.sticky_header #validate-status-inpopup').text('Passwords Match');
				 $('.sticky_header #register-submit-button').css({'display' : 'block'});
		}
		else {
				 $('.sticky_header #validate-status-inpopup').css({'color' : 'red'});
				 $('.sticky_header #validate-status-inpopup').text('Passwords do NOT match - Please fix');
				 $('.sticky_header #register-submit-button').css({'display' : 'none'}); 
		}
	}
	$('.desktop_header #registerpassword, .desktop_header #registerconfirm-password').keyup(validateloginpopup1); 
	function validateloginpopup1() {
		var reg_password1 = $(".desktop_header #registerpassword").val();
		var regcon_password1 = $(".desktop_header #registerconfirm-password").val();
		if(reg_password1 === regcon_password1) {
				 $('.desktop_header #validate-status-inpopup').css({'color' : 'green'});
					$('.desktop_header #validate-status-inpopup').text('Passwords Match');
				 $('.desktop_header #register-submit-button').css({'display' : 'block'});
		}
		else {
				 $('.desktop_header #validate-status-inpopup').css({'color' : 'red'});
				 $('.desktop_header #validate-status-inpopup').text('Passwords do NOT match - Please fix');
				 $('.desktop_header #register-submit-button').css({'display' : 'none'}); 
		}
	}
}

leotriplet.registerpasswordvalidation = function() {
	$('#password, #confirm-password').keyup(validate); 
	function validate() {
		var password1 = $("#password").val();
		var password2 = $("#confirm-password").val();
		if(password1 === password2) {
					$('#validate-status').css({'color' : 'green'});
					$('#validate-status').text('Passwords Match');
					$('#submit-button').css({'display' : 'block'});
		}
		else {
					$('#validate-status').css({'color' : 'red'});
					$('#validate-status').text('Passwords do NOT match - Please fix');
					$('#submit-button').css({'display' : 'none'}); 
		}
	}
}






/*---------------------------------------------------------------------------------*/
/*----------------------------- Password & Sidebar Toggles ------------------------*/
/*---------------------------------------------------------------------------------*/


leotriplet.initializeEvents = function() {
	var $body = $('body'),
	passwordToggle = '.leotriplet-password-toggle',
	scrollToTop = '.leotriplet-ScrollToTop',
	collectionSidebarToggle = '.leotriplet-sidebartoggle';
	var classes = {
	passwordShow: 'password-toggle--show'
	};
	$body.on('click', passwordToggle, function(e) {
	e.preventDefault();
	var $this = $(this);
	var $passwordField = $this.siblings('.form-control');
	var isShow = $this.hasClass(classes.passwordShow) ? true : false;
	if (isShow) {
		$this.removeClass(classes.passwordShow);
		$passwordField.attr('type', 'password');
	} else {
		$this.addClass(classes.passwordShow);
		$passwordField.attr('type', 'text');
	}
	});
	$body.on('click', collectionSidebarToggle,function(evt) {
		evt.preventDefault();
		$body.toggleClass('open--Sidebar');
	});
	$body.on('click', scrollToTop, function(e) {
		e.preventDefault();
		$('body, html').stop().animate({ scrollTop: 0 }, '500');
	});
	$(window).scroll(function() {
		if ($(window).scrollTop() >= 200) {
			$(scrollToTop).fadeIn();
		} else {
			$(scrollToTop).fadeOut();
		}
	});
	var ScrollToTopProgress = document.querySelector('.leotriplet-ScrollToTop path');
	var pathLength = ScrollToTopProgress.getTotalLength();
	ScrollToTopProgress.style.transition = ScrollToTopProgress.style.WebkitTransition = 'none';
	ScrollToTopProgress.style.strokeDasharray = pathLength + ' ' + pathLength;
	ScrollToTopProgress.style.strokeDashoffset = pathLength;
	ScrollToTopProgress.getBoundingClientRect();
	ScrollToTopProgress.style.transition = ScrollToTopProgress.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
	var updateProgress = function () {
		var scroll = $(window).scrollTop();
		var height = $(document).height() - $(window).height();
		var progress = pathLength - (scroll * pathLength / height);
		ScrollToTopProgress.style.strokeDashoffset = progress;
	}
	updateProgress();
	$(window).scroll(updateProgress);
};

leotriplet.setBreakpoints = function() {
	enquire.register(leotriplet.variables.mediaTablet, {
		match: function() {
			leotriplet.variables.isTablet = true;
		},
		unmatch: function() {
			leotriplet.variables.isTablet = false;
		}
	});
	enquire.register(leotriplet.variables.mediaMobile, {
		match: function() {
			leotriplet.variables.isMobile = true;
		},
		unmatch: function() {
			leotriplet.variables.isMobile = false;
		}
	});
};



/*---------------------------------------------------------------------------------*/
/*----------------------------------- Counter Section -----------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.counter = function() {
$('.counter_number').each(function () {
	$(this).prop('Counter',0).animate({
		Counter: $(this).text()
	}, 
	{
		duration: 4000,
		easing: 'swing',
		step: function (now) {
				$(this).text(Math.ceil(now));
		}
	});
});
}


/*---------------------------------------------------------------------------------*/
/*----------------------------------- Blog Page Ajax ------------------------------*/
/*---------------------------------------------------------------------------------*/


leotriplet.ajax_blogpage = (function() {
	var ajaxBreadcrumbs,
	 ajaxPaging,
	 ajaxLoadMore,
	 ajaxSidebar;
 var init = function() {
	 ajaxPaging();
	 ajaxLoadMore();
	 ajaxSidebar();
 };
 ajaxLoadMore = function() {
	 if ( $('.blog-page .pagination-ajax-blog-loadmore').length ) {
		 $('.blog-page .pagination-ajax-blog-loadmore').on('click', 'a', function(e) {
			 e.preventDefault();
			 var pageURL 	= $(this).attr('href');
			 var newTitle 	= $(this).attr('title');
			 var URL_array 	= $(this).attr('href').match(/page=\d+/g);
			 var curret		= parseInt(URL_array[0].match(/\d+/g));
			 $(this).addClass('active');
			 $("#leotriplet-progress-loading").addClass('load-product');
			 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"40%"});
			 var offset = $(this).offset().top;
			 if (pageURL) {
				 $.ajax({
					 type: 'get',
					 url: pageURL,
					 success: function(data) {	
						 document.title = newTitle;
						 $(".blog-page .all-articles").append($(data).find(".blog-page .all-articles").html());
						 $('.blog-page .pagination-ajax-blog-loadmore').replaceWith($(data).find('.blog-page .pagination-ajax-blog-loadmore'));
						 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"100%"});
						 $('body,html').animate({
							 scrollTop: offset
						 }, 600);
						 setTimeout(function() { 
							 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"0"});
							 $("#leotriplet-progress-loading").removeClass('load-product');
						 }, 500);
						 ajaxBreadcrumbs();
						 ajaxSidebar();
						 ajaxLoadMore();
						 leotriplet.christmas_snow();
						 $(this).removeClass('active');
					 },
					 error: function(xhr, text) {
						 console.log(text);
					 }
				 });
			 }
		 });
	 }
 };
 ajaxPaging = function() {
	 if ( $('.blog-page .pagination-ajax-blog').length ) {
		 $('.blog-page .pagination-ajax-blog').on('click', 'a', function(e) {
			 e.preventDefault();
			 var pageURL = $(this).attr('href');
			 var newTitle = $(this).closest('.pagination-ajax-blog').attr('title');
			 History.pushState({
				 param: Shopify.queryParams
			 }, pageURL, pageURL);
			 $("#leotriplet-progress-loading").addClass('load-product');
			 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"40%"});		
			 if (pageURL) {
				 $.ajax({
					 type: 'get',
					 url: pageURL,
					 success: function(data) {	
						 document.title = newTitle;
						 $('.blog-page').replaceWith($(data).find('.blog-page'));
						 $('body,html').animate({
							 scrollTop: $('.header').height() + $('.leotriplet-breadcrumbs').height()
						 }, 600);							
						 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"100%"});
						 setTimeout(function() { 
							 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"0"});
							 $("#leotriplet-progress-loading").removeClass('load-product');
						 }, 500);
						 ajaxSidebar();
						 ajaxPaging();
					 },
					 error: function(xhr, text) {
						 console.log(text);
					 }
				 });
			 }
		 });
	 };
 };
 ajaxSidebar = function() {
	 if ( $('.blog-page .blog_sidebar .blog_categories--list').length ) {
		 var $categories_blog = $('.blog_sidebar .blog_categories--list');
		 $($categories_blog).on('click', 'a', function(e){
			 e.preventDefault();
			 var pageURL = $(this).attr('href');
			 var newTitle = $(this).attr('title');
			 $(this).closest('li').addClass('active');
			 History.pushState({
				 param: Shopify.queryParams
			 }, pageURL, pageURL);	
			 delete Shopify.queryParams.page;
			 $("#leotriplet-progress-loading").addClass('load-product');
			 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"40%"});
			 $.ajax({
				 type: 'get',
				 url: pageURL,
				 success: function(data) {
					 document.title = newTitle;			
					 $('.blog-page').replaceWith($(data).find('.blog-page'));		
					 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"100%"});
					 setTimeout(function() { 
						 $('#leotriplet-progress-loading .leotriplet-progressbar').css({"width":"0"});
						 $("#leotriplet-progress-loading").removeClass('load-product');
					 }, 500);					 
					 ajaxSidebar();
					 ajaxPaging();
					 ajaxLoadMore();
				 },
				 error: function(xhr, text) {
					 console.log(text);
				 }
			 });			
			 $('body,html').animate({
				 scrollTop: $('.header').height()
			 }, 600);
		 });
	 }
 }
 return init;
})();

/*---------------------------------------------------------------------------------*/
/*----------------------------------- Delete Address ------------------------------*/
/*---------------------------------------------------------------------------------*/


Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};


leotriplet.address_delete = function() {
	$('.address-delete').on('click', function() {
	  var $el = $(this);
	  var target = $el.data('target');
	  var confirmMessage = $el.data('confirm-message');
	  if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
		Shopify.postLink(target, {
		  parameters: { _method: 'delete' }
		});
	  }
	});
}

leotriplet.Search = (function() {
  var selectors = {
    search: '[data-search]',
    searchPagination: '.search-pagination a'
  };

  function Search(container) {
    var ajaxCartSearch = function() {
      if (typeof ajaxCart != 'undefined') {
        ajaxCart.init({
          formSelector: '[data-product-form]'
        });
      }
    };
    var searchResultData = function(container, url) {
      $.get(url, function(data) {
        container.html(data);
        ajaxCartSearch();
      });
    }
    var getSearchResult = function(searchs) {
      searchs.each(function() {
        var $this = $(this);
        $.get($this.data('url'), function(data) {
          $this.html(data);
          ajaxCartSearch();
        });
      });
    };

    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$search.length) {
      getSearchResult(this.cache.$search);
    }

    this.$container.on('click', selectors.searchPagination, function(e) {
      e.preventDefault();
      var $searchContainer = $(this).parents(selectors.search);
      var searchURL = $(this).attr('href');
      searchResultData($searchContainer, searchURL);
    });
  }

  Search.prototype = _.assignIn({}, Search.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $search: this.$container.find(selectors.search)
      };
    }
  });

  return Search;
})();







/*---------------------------------------------------------------------------------*/
/*-----------------------------Cookies Consent------------------------------------*/
/*---------------------------------------------------------------------------------*/


leotriplet.setCookie = function(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = 'expires=' + d.toGMTString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};
leotriplet.getCookie = function(cname) {
	var name = cname + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookieArray = decodedCookie.split(';');
	for(var i = 0; i < cookieArray.length; i++) {
		var cookieItem = cookieArray[i];
		while (cookieItem.charAt(0) === ' ') {
			cookieItem = cookieItem.substring(1);
		}
		if (cookieItem.indexOf(name) === 0) {
			return cookieItem.substring(name.length, cookieItem.length);
		}
	}
	return '';
};
leotriplet.cookieConsent = function() {
	var cConsent = leotriplet.getCookie('cookie_consent'),
		cConsentSelector = $('.leotriplet-cookie-consent'),
		cConsentDismiss = '.leotriplet-cookie-consent-dismiss';
		cConsentAgree = '.leotriplet-cookie-consent-agree';
	if (cConsent == 'true' || cConsent == 'false') {
		cConsentSelector.remove();
	} else {
		setTimeout(function() {
			cConsentSelector.addClass('active');
		}, 1500);
		if (cConsent == '') leotriplet.setCookie('cookie_consent', '', 10);
	}
	$('body').on('click', cConsentDismiss, function(e) {
		e.preventDefault();
		cConsentSelector.remove();
		leotriplet.setCookie('cookie_consent', false, 10);
	});
	$('body').on('click', cConsentAgree, function(e) {
		e.preventDefault();
		cConsentSelector.remove();
		leotriplet.setCookie('cookie_consent', true, 10);
	});
};


/*---------------------------------------------------------------------------------*/
/*-----------------------------Newsletter Popup------------------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.newsletter = function() {
	var alertNewsletter;
	$('.pkt-newsletter').each(function() {
		var $form = $(this);
		$form.on('submit', function(event) {
			event.preventDefault();
			$('.js-alert-newsletter').remove();
			$.ajax({
				type: $form.attr('method'),
				url: $form.attr('action'),
				data: $form.serialize(),
				cache: false,
				dataType: 'json',
				contentType: 'application/json; charset=utf-8',
				success: function(data) {
					if (data.result === 'success') {
						$form.prepend(alertNewsletter(leotriplet.strings.newsletterSuccess ,'success'));
						$('.js-input-newsletter').val('');
					} else {
						$form.prepend(alertNewsletter(data.msg.replace('0 - ', '') ,'danger'));
					}
				},
				error: function(err) {
					$form.prepend(alertNewsletter(err ,'danger'));
				}
			});
		});
	});
	alertNewsletter = function(message, type) {
		var alert = '<div class="js-alert-newsletter alert alert--mailchimp alert-' + type + '">' + message + '</div>';
		return alert;
	};
	var newsletterPopup = '.leotriplet-newsletter-modal',
		newsletterPopupClose = '.leotriplet-newsletter-modal-close',
		newsletterPopupSubmit = '.leotriplet-newsletter-modal-submit',
		cNewsletter = '',
		classNameNewsletterActive = 'leotriplet-subscribe-popup--active';
	if ($(newsletterPopup).find('.leotriplet-newsletter-modal-success').length > 0) {
		leotriplet.setCookie('leotriplet_newsletter_popup', 1, 30);
	}
	cNewsletter = leotriplet.getCookie('leotriplet_newsletter_popup');
	if (cNewsletter == 1) $(newsletterPopup).remove();
	if (cNewsletter != 1 && !($('.shopify-challenge__container').length > 0)) {
		$(newsletterPopup).addClass('show');
		setTimeout(function() {
			$(newsletterPopup).addClass(classNameNewsletterActive);
		}, 200);
	}
	$(newsletterPopupClose).on('click', function() {
		if ($(newsletterPopup).find('.alert--mailchimp').length > 0) {
			leotriplet.setCookie('leotriplet_newsletter_popup', 1, 30);
		} else {
			leotriplet.setCookie('leotriplet_newsletter_popup', 1, 1);
		}
		$(newsletterPopup).removeClass(classNameNewsletterActive);
		setTimeout(function() {
			$(newsletterPopup).removeClass('show');
		}, 1000);
	});
	$(newsletterPopupSubmit).on('click', function() {
		leotriplet.setCookie('leotriplet_newsletter_popup', 1, 30);
	});
	var width = $('.leotriplet-newsletter-modal .image').width();
	var height = $('.leotriplet-newsletter-modal .image').height();
	$(newsletterPopup).css('--width-image',width+'px');
	$(newsletterPopup).css('--height-image',height+'px');
	var live_url = window.location.href;
	var result = live_url.includes('form_type=customer');
	var input_val = document.querySelector('#NewsletterForm--footer').value.length;
	if(result && input_val != 0){
		const add_ele = document.createElement("p");
		add_ele.innerText = "You have already subscribed!";
		document.querySelector('.newsletter-form__field-wrapper').appendChild(add_ele);
		add_ele.classList.add('toast','newsletter-form__message','form__message');
	}
};



/*---------------------------------------------------------------------------------*/
/*-----------------------------Langague Translator---------------------------------*/
/*---------------------------------------------------------------------------------*/

leotriplet.Disclosure = (function() {
	var selectors = {
		disclosureInput: '[data-disclosure-input]',
		disclosureOptions: '[data-disclosure-option]'
	};
	function Disclosure($disclosure) {
		this.$container = $disclosure;
		this.cache = {};
		this._cacheSelectors();
		this._connectOptions();
	}
	Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
		_cacheSelectors: function() {
			this.cache = {
				$disclosureInput: this.$container.find(selectors.disclosureInput),
				$disclosureOptions: this.$container.find(selectors.disclosureOptions)
			};
		},
		_connectOptions: function() {
			this.cache.$disclosureOptions.on('click',function(evt) {
				evt.preventDefault();
				this._submitForm($(evt.currentTarget).data('value'));
			}.bind(this));
		},
		_submitForm: function(value) {
			this.cache.$disclosureInput.val(value);
			this.$container.parents('form').submit();
		},
		unload: function() {
			this.cache.$disclosureOptions.off();
			this.$container.off();
		}
	});
	return Disclosure;
})();


/*---------------------------------------------------------------------------------*/
/*-----------------------------Gift Wrap---------------------------------*/
/*---------------------------------------------------------------------------------*/


leotriplet.gift_wrap = (function() {
	var selectors = {
		body: 'body',
		leotripletGiftWrap: '[data-gift_wrap]',
		leotripletGiftTemplate: '#leotriplet_gift_wrap-template',
		leotripletGiftBtn: '.gift-wrapper [data-gift_card]',
		leotripletGiftContainer: '[data-gift_wrap_container]',
		leotripletGiftClose: '[data-gift_wrap-close]',
		leotripletGiftImages: '[data-gift_wrap_images]',
		leotripletGiftVariant: '.js-giftcard-option-selector',
		originalSelectorId: '[data-edit_variant-variant]',
		leotripletGiftProductPrice: '.js-gift-product-price',
		leotripletGiftProductPriceCompare: '.js-gift-product-price-compare',
		leotripletGiftQty: '[data-gift_wrap_quantity]',
		leotripletGiftAvaiable: '.product-avaiable',
		leotripletGiftAvaiableInStock: '.product-avaiable--instock',
		leotripletGiftAvaiableOutStock: '.product-avaiable--outstock',
		leotripletGiftProductDetailsURL: '.js-qv-product-details'
	};
	function GiftCard(container) {
		this.$container = $(container);
		this.cache = {};
		this.productVariants = [];
		this.currentVariant = {};
		this.cacheSelectors();
		this.initializeEvents();
	}
	GiftCard.prototype = _.assignIn({}, GiftCard.prototype, {
		cacheSelectors: function() {
			this.cache = {
				$body: $('body'),
				$leotripletGiftContainer: this.$container.find(selectors.leotripletGiftContainer)
			};
		},

		initializeEvents: function() {
			var $this = this;
			$(selectors.body).on('click', selectors.leotripletGiftBtn, function(e) {
				e.preventDefault();
				var productHandle = $(this).data('gift_card');
				$(this).addClass('load-giftcard');
				$.getJSON('/products/' + productHandle + '.js', function(product) {
					if (product.available) {
					$this.firstAvailableVariant(product.variants, $this);
					} else {
						$this.currentVariant = product.variants[0];
					}
					$(selectors.leotripletGiftBtn).removeClass('load-giftcard');
					$this.buildGiftCard(product);
					$this.show();
					$this.createImageCarousel(product);
				});
			});
			$(selectors.body).on('click', selectors.leotripletGiftClose, function(e) {
				e.preventDefault();
				$this.hide();
			});
			$(selectors.leotripletGiftContainer).on('change', selectors.leotripletGiftVariant, function(e) {
				$this.onVariantChange();
			});
		},

		firstAvailableVariant: function(variants, global) {
			global.productVariants = variants;
			for (var i = 0; i < variants.length; i++) {
				var variant = variants[i];
				if (variant.available) {
					global.currentVariant = variant;
					break;
				}
			}
		},
		buildGiftCard: function(product) {
			var moneyFormat = leotriplet.strings.moneyFormat;
			var currentVariant = this.currentVariant;
			var source = $(selectors.leotripletGiftTemplate).html();
			var template = Handlebars.compile(source);
			var images = '';
			var price = '';
			var external='';
			var qvObject = {
				id: product.id
			};
			if (typeof product.media !== 'undefined') {
				images += '<div class="gift_card-images__list slick-carousel" data-gift_wrap_images>'
				for (var i = 0; i < product.media.length; i++) {
					var media = product.media[i];
					if (media.media_type === 'image') {
						images += '<div class="slick-carousel__item"><div class="giftcard-images__item" data-media-id=' +
							media.id + '><img class="img-fluid" alt="' +
							product.title + '" src="' +
							media.src + '" /></div></div>';
					}
				}
				images += '</div>'
			}			
			qvObject.variantID = currentVariant.id;
			qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== '' ? currentVariant.sku : 'N/A';
			qvObject.images = images;
			qvObject.title = product.title;
			qvObject.url = product.url;
			price += '<div class="price-container">';
			var productCompareClass = product.compare_at_price !== null ? '' : 'd-none';
			price += '<div class="js-gift-product-price-compare product-single__price--compare-at ' + productCompareClass + '">' + leotriplet.Currency.formatMoney(product.compare_at_price, moneyFormat) + '</div>';
			price += '<div class="js-gift-product-price product-single__price">' + leotriplet.Currency.formatMoney(product.price, moneyFormat) + '</div>';
			price += '</div>';
			qvObject.price = price;
			qvObject.variants = this.buildVariant(product);
			$(selectors.leotripletGiftContainer).html(template(qvObject));
			
			this.updateMedia(currentVariant);
			this.updateDetailsLink(currentVariant);
			$('#form-gift-card-addtocart .btn--add-to-cart').on('click',function(e){
				e.preventDefault();
				$(this).removeClass('added');
				$(this).addClass('active');
				let addToCartForm = document.querySelector('#form-gift-card-addtocart');
				let formData = new FormData(addToCartForm);
				var params = {
					type: 'POST',
					url: '/cart/add.js',
					data: formData,
					processData: false,
					contentType: false,
					dataType: 'json',
					success: function(line_item) {
						$('#form-gift-card-addtocart .btn--add-to-cart').removeClass('active');
						$('#form-gift-card-addtocart .btn--add-to-cart').addClass('added');
						$(selectors.body).removeClass('giftcard-active');
						$('.leotriplet_gift_wrap-container .leotriplet_gift_wrap-content').removeClass('show');
						setTimeout(function(){
							$(selectors.leotripletGiftWrap).removeClass('show');
						}, 400);
						setTimeout(function() {
							$('#form-gift-card-addtocart .btn--add-to-cart').removeClass('added');
						}, 3000);
						ajaxCart.load();
						ajaxCartPage.load();
					},
					error: function(XMLHttpRequest, textStatus) {
						if (typeof errorCallback === 'function') {
							errorCallback(XMLHttpRequest, textStatus);
						} else {
							ShopifyAPI.onError(XMLHttpRequest, textStatus);
						}
					}
				};
				jQuery.ajax(params);
			});
			if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
		},
		convertToSlug: function(str) {
			return str.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
		},
		buildVariant: function(product) {
			var result = '';
			var currentVariant = this.currentVariant;
			if (product.options[0].name !== 'Title') {
				var options = product.options;
				for (var i = 0; i < options.length; i ++) {
					var option = options[i];
					var optionIndex = i + 1;
					result += '<div class="variants-wrapper product-form__item" data-giftcard-variant-option="' + optionIndex + '">';
					result += '<label class="variants__label">' + option.name + '</label>';
					result += '<div class="variants__options">';
					for (var j = 0; j < option.values.length; j ++) {
						var value = option.values[j];
						var isDisable = true;
						var colorAttribute = '';
						
						for (var k = 0; k < this.productVariants.length; k ++) {
							var variantCondition = this.productVariants[k];
							if (variantCondition.available) {
								if (i == 0 && variantCondition.option1 === value) {
									isDisable = false;
									break;
								} else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
									isDisable = false;
									break;
								} else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
									isDisable = false;
									break;
								}
							}
						}
						
						result += '<div class="single-option-selector">';
						result += '<input type="radio" data-single-option-button';
						result += currentVariant.options[i] === value ? ' checked ' : ' ';
						if (isDisable) {
							result += 'disabled="disabled"';
						}
						result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
						result += 'class="js-giftcard-option-selector';
						if (isDisable) {
							result += ' disabled';
						}
						result += '" id="giftcard-product-option-' + i + '-' + value.toLowerCase() + '">';
						result += '<label class="' + value + '" data-toggle="tooltip" title="' + value + '" for="giftcard-product-option-' + i + '-' + value.toLowerCase() + '" ' + colorAttribute;
						if (isDisable) {
							result += ' class="disabled"';
						}
						result += '>' + value + '<span class="d-none"></span></label>';
						result += '</div>';
					}
					result += '</div>';
					result += '</div>';
				}
			}
			return result;
		},
		createImageCarousel: function(product) {
			if(product.media.length > 1){
				$(selectors.leotripletGiftWrap).find(selectors.leotripletGiftImages).slick({
					infinite: false,
					rows: 0,
					arrows: false,
				});
			}
		},
		getCurrentOptions: function() {
			var currentOptions = _.map(
				$(selectors.leotripletGiftVariant, selectors.leotripletGiftContainer), function(element) {
					var $element = $(element);
					var type = $element.attr('type');
					var currentOption = {};
					if (type === 'radio' || type === 'checkbox') {
						if ($element[0].checked) {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');
							return currentOption;
						} else {
							return false;
						}
					} else {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');
						return currentOption;
					}
				}
			);
			currentOptions = _.compact(currentOptions);
			return currentOptions;
		},
		getVariantFromOptions: function() {
			var selectedValues = this.getCurrentOptions();
			var variants = this.productVariants;
			var found = _.find(variants, function(variant) {
				return selectedValues.every(function(values) {
					return _.isEqual(variant[values.index], values.value);
				});
			});
			return found;
		},
		updateVariantsButton: function () {
			var selectedValues = this.getCurrentOptions();
			var variants = this.productVariants;
			for (var i = 2; i <= 3; i++) {
				if ($('[data-giftcard-variant-option="' + i + '"]', selectors.leotripletGiftContainer).length) {
					$('[data-giftcard-variant-option="' + i + '"] ' + selectors.leotripletGiftVariant, selectors.leotripletGiftContainer).each(function() {
						var $self = $(this);
						var optionValue = $self.val();
						var foundIndex;
						if (i === 2) {
							foundIndex = _.findIndex(variants, function(variant) {
								return variant.option1 === selectedValues[0].value &&
								variant.option2 === optionValue &&
								variant.available === true;
							});
						} else if (i === 3) {
							foundIndex = _.findIndex(variants, function(variant) {
								return variant.option1 === selectedValues[0].value &&
								variant.option2 === selectedValues[1].value &&
								variant.option3 === optionValue &&
								variant.available === true;
							});
						}
						if (foundIndex !== -1) {
							$self.removeAttr('disabled', 'disabled').removeClass('disabled');
							$self.next('label').removeClass('disabled');
						} else {
							$self.attr('disabled', 'disabled').addClass('disabled');
							$self.next('label').addClass('disabled');
						}
					});
				}
			}
		},
		updateVariantsButtonDisabed: function() {
			for (var i = 2; i <= 3; i++) {
				if ($('[data-giftcard-variant-option="' + i + '"]', selectors.leotripletGiftContainer).length) {
					var isUpdate = false;
					$('[data-giftcard-variant-option="' + i + '"] ' + selectors.leotripletGiftVariant, selectors.leotripletGiftContainer).each(function() {
						var $element = $(this);
						var type = $element.attr('type');
						if (type === 'radio' || type === 'checkbox') {
							if (this.checked && $element.hasClass('disabled')) {
								$element.prop('checked', false);
								isUpdate = true;
								return false;
							}
						}
					});
					$('[data-giftcard-variant-option="' + i + '"] ' + selectors.leotripletGiftVariant, selectors.leotripletGiftContainer).each(function() {
						var $element = $(this);
						var type = $element.attr('type');
						if (isUpdate && (type === 'radio' || type === 'checkbox') && !$element.hasClass('disabled')) {
							$element.prop('checked', true);
							isUpdate = false;
							$element.trigger('change');
							return false;
						}
					});
				}
			}
		},
		updateMasterSelect: function(variant) {
			if (variant) {
				$(selectors.originalSelectorId, selectors.leotripletGiftContainer).val(variant.id);
			}
		},
		updateMedia: function(variant) {
			if (variant && variant.featured_media && variant.featured_media.id) {
				$(selectors.leotripletGiftImages, selectors.leotripletGiftContainer).find('.giftcard-images__item').each(function() {
					var imageID = $(this).data('media-id');
					if (variant.featured_media.id == imageID) {
						var slickIndex = $(this).closest('.slick-carousel__item').data('slick-index');
						if (slickIndex !== undefined && slickIndex !== null) {
							$(selectors.leotripletGiftImages, selectors.leotripletGiftContainer).slick('slickGoTo', slickIndex);
						}
					}
				});
			}
		},

		updatePrice: function(variant) {
			var moneyFormat = leotriplet.strings.moneyFormat;
			if (!variant) {
				$(selectors.leotripletGiftProductPrice, selectors.leotripletGiftContainer).addClass('d-none');
				$(selectors.leotripletGiftProductPriceCompare, selectors.leotripletGiftContainer).addClass('d-none');
			} else {
				$(selectors.leotripletGiftProductPrice, selectors.leotripletGiftContainer).removeClass('d-none');
				$(selectors.leotripletGiftProductPriceCompare, selectors.leotripletGiftContainer).removeClass('d-none');
				$(selectors.leotripletGiftProductPrice, selectors.leotripletGiftContainer).html(
					leotriplet.Currency.formatMoney(variant.price, moneyFormat)
				);
				if (variant.compare_at_price > variant.price) {
					$(selectors.leotripletGiftProductPriceCompare, selectors.leotripletGiftContainer).html(
						leotriplet.Currency.formatMoney(variant.compare_at_price, moneyFormat)
					).removeClass('d-none');
					$(selectors.leotripletGiftProductPrice, selectors.leotripletGiftContainer).addClass('on-sale');
				} else {
					$(selectors.leotripletGiftProductPriceCompare, selectors.leotripletGiftContainer).addClass('d-none');
					$(selectors.leotripletGiftProductPrice, selectors.leotripletGiftContainer).removeClass('on-sale');
				}
			}
			if( $('.leotriplet_currency').length > 0){ Currency.Currency_customer(true); }
		},

		updateProductAvaiable: function(variant) {
			var classActive = 'product-available--active';
			var translations = leotriplet.strings;
			$(selectors.leotripletGiftAvaiable, selectors.leotripletGiftContainer).removeClass(classActive);
			if (variant) {
				if (variant.available) {
					$(selectors.leotripletGiftQty, selectors.leotripletGiftContainer).removeClass('d-none');
					$(selectors.leotripletGiftAvaiableInStock, selectors.leotripletGiftContainer).addClass(classActive);
				} else {
					$(selectors.leotripletGiftQty, selectors.leotripletGiftContainer).addClass('d-none');
					$(selectors.leotripletGiftAvaiableOutStock, selectors.leotripletGiftContainer).addClass(classActive);
				}
				
				if (variant.available) {
					$(selectors.leotripletGiftContainer).find('.btn--add-to-cart')
						.removeClass('disabled')
						.prop('disabled', false);
					$(selectors.leotripletGiftContainer).find('.btn--add-to-cart .btn__text').html(translations.addToCart);
				} else {
					$(selectors.leotripletGiftContainer).find('.btn--add-to-cart')
						.addClass('disabled')
						.prop('disabled', true);
					$(selectors.leotripletGiftContainer).find('.btn--add-to-cart .btn__text').html(translations.soldOut);
				}
			} else {
				$(selectors.leotripletGiftQty, selectors.leotripletGiftContainer).addClass('d-none');
				$(selectors.leotripletGiftContainer).find('.btn--add-to-cart')
					.addClass('disabled')
					.prop('disabled', true);
				$(selectors.leotripletGiftContainer).find('.btn--add-to-cart .btn__text').html(translations.unavailable);
			}
		},

		updateDetailsLink: function(variant) {
			if (variant) {
				var productURL = $(selectors.leotripletGiftProductDetailsURL, selectors.leotripletGiftContainer).data('url') + '?variant=' + variant.id;
				$(selectors.leotripletGiftProductDetailsURL, selectors.leotripletGiftContainer).removeClass('d-none').attr('href', productURL);
			} else {
				$(selectors.leotripletGiftProductDetailsURL, selectors.leotripletGiftContainer).addClass('d-none');
			}
		},

		onVariantChange: function() {
			var variant = this.getVariantFromOptions();
			if ($('[data-single-option-button]', selectors.leotripletGiftContainer).length) {
				this.updateVariantsButton();
				if (!variant || !variant.available) {
					this.updateVariantsButtonDisabed();
					return;
				}
			}
			this.updateMasterSelect(variant);
			this.updateMedia(variant);
			this.updatePrice(variant);
			this.updateProductAvaiable(variant);
			this.updateDetailsLink(variant);
			this.currentVariant = variant;
		},
		show: function() {
			$(selectors.body).addClass('giftcard-active');
			$(selectors.leotripletGiftWrap).addClass('show');
			setTimeout(function(){
				$('.leotriplet_gift_wrap-container .leotriplet_gift_wrap-content').addClass('show');
			}, 400);
		},
		hide: function() {
			$(selectors.leotripletGiftContainer).html();
			$(selectors.body).removeClass('giftcard-active');
			$('.leotriplet_gift_wrap-container .leotriplet_gift_wrap-content').removeClass('show');
			setTimeout(function(){
				$(selectors.leotripletGiftWrap).removeClass('show');
			}, 400);
		}
	});
	return GiftCard;
})();


leotriplet.animation = function() {
	function isScrolledIntoView(elem) {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();
		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height();
		return ((elemBottom > docViewTop) && (elemTop < docViewBottom));
	}
	$(window).on('load scroll', function() {
    function checkAnimation(className, animation) {
        $(className).each(function() {
            if (isScrolledIntoView(this) === true) {
                $(this).addClass(animation);
            }
        });
    }
    checkAnimation('.leotriplet_fadeIn', 'animate__fadeIn');
    checkAnimation('.leotriplet_zoomIn', 'animate__zoomIn');
    checkAnimation('.leotriplet_fadeInUp', 'animate__fadeInUp');
    checkAnimation('.leotriplet_fadeInDown', 'animate__fadeInDown');
	});
}

leotriplet.init = function() {
	leotriplet.animation();
	leotriplet.initializeEvents();
	leotriplet.setBreakpoints();
	leotriplet.headeraccount();
	leotriplet.newsletter();
	leotriplet.cookieConsent();
	leotriplet.sticky_header();
	leotriplet.zoom_thumb();
	leotriplet.click_atribute_image();
	leotriplet.customNumberInput();
	leotriplet.slick_mobile();
	leotriplet.cartInit();
	leotriplet.collectionPages();
	leotriplet.sidebarCollection();
	leotriplet.toggleSidebar();
	leotriplet.countActiveSidebar();
	leotriplet.checkbox_terms_conditions();
	leotriplet.ajax_cartpage();
	leotriplet.loginpopupopen();
	leotriplet.ajax_blogpage();
  leotriplet.registerpasswordvalidation();
	leotriplet.registerpopuppasswordvalidation();
	leotriplet.counter();
	leotriplet.address_delete();
	if (leotriplet.settings.enableQuickView) {
		new leotriplet.QuickView('.js-quickview');
	}
	if (leotriplet.settings.enableGiftCard) {
		new leotriplet.gift_wrap('.js-giftcard');
	}
	new leotriplet.update_variant_cartpage('.js-edit_variants');
};



$(document).ready(function() {
	leotriplet.init();
	var sections = new leotriplet.Sections();
	sections.register('product-template', leotriplet.Product);
	sections.register('header-section', leotriplet.HeaderSection);
	sections.register('login-register', leotriplet.LoginForm);
	sections.register('related-products', leotriplet.ProductRelated);
	sections.register('search', leotriplet.Search);
	if ($('body').hasClass('product--template') ) {
		var $element = $(".single-product");
		var _data = $element.data();
		if(_data.thumbnail_layout != "slider"){
			$('.img-wrapper-video iframe').css("width",$(".single-product-images #slick-slide11 .mfp-image").width());
			$('.img-wrapper-video iframe').css("height",$(".single-product-images #slick-slide11 .mfp-image").height());
			$('.leotriplet-product-gallery-item model-viewer').css("width",$(".leotriplet-product-image").width());
			$('.leotriplet-product-gallery-item model-viewer').css("height",$(".mfp-image").height());
		}
	}
	if (leotriplet.settings.enablePreLoading) {
		$('#leotriplet-progress-loading').addClass('loading-done');
	}
	setTimeout(function() {
		$('#leotriplet-progress-loading').removeClass('loading-done');
		$('#leotriplet-progress-loading').removeClass('loading-page');
	}, 1300);
	if (window.Shopify.designMode) {
		$('.main-content').addClass('designMode_active');
		let data=window.performance.getEntriesByType("navigation")[0].type;
		console.log(data);
	}
});





var phoneNumber = "7096119782"; // Replace with your WhatsApp number
var currentPageUrl = encodeURIComponent(window.location.href);
var message = encodeURIComponent("Hi, I am interested! Here is the page link: " + currentPageUrl);
var whatsappUrl = "https://wa.me/" + phoneNumber + "?text=" + message;

document.getElementById("whatsappLink").href = whatsappUrl;

    

document.addEventListener('DOMContentLoaded', () => {
  const togglers = document.querySelectorAll('[data-toggle]');

  togglers.forEach((btn) => {
    const selector = btn.dataset.toggle;
    const block = document.querySelector(selector);

    // Set the first accordion item open by default
    if (btn.classList.contains('active')) {
      block.style.maxHeight = block.scrollHeight + 'px';
    }

    btn.addEventListener('click', (e) => {
      const selector = e.currentTarget.dataset.toggle;
      const block = document.querySelector(selector);

      if (e.currentTarget.classList.contains('active')) {
        block.style.maxHeight = '';
      } else {
        block.style.maxHeight = block.scrollHeight + 'px';
      }

      e.currentTarget.classList.toggle('active');
    });
  });
});





 $(document).ready(function() {
    if ($('.variants-wrapper').hasClass('productsize')) {
        $(".productsize .variants__label .vl_block").append('<p class="extra-charge"> | Stitching Extra Charge Rs.500</p>');
    } else {
        $(".productsize .variants__label .vl_block").append('<p class="extra-charge"></p>');
    }
});
$(document).ready(function() {

  $(".productsize").append('<p class="day-info">Dispatch in : 2 Working Days</p>');
  $(".productsize").append('<p class="extra-day-info">Dispatch in : 10 Working Days</p>');
  
   // Function to check the radio button status and toggle the visibility of .extra-charge
  function toggleExtraCharge() {
    if ($('input[value="Unstich"]:checked').length > 0) {
      $('.extra-charge').hide();
       $('.day-info').show();
      $('.extra-day-info').hide();
    } else {
      $('.extra-charge').show();
      $('.day-info').hide();
      $('.extra-day-info').show();
    }
  }

  // Call the function on page load to set the initial state
  toggleExtraCharge();

  // Attach the function to the change event of the radio buttons
  $('input[type="radio"]').on('change', function() {
    toggleExtraCharge();
  });

});


document.querySelectorAll('.tabs-list .tab a').forEach(function(tab) {
    tab.addEventListener('click', function(event) {
      event.preventDefault();
      var targetId = this.getAttribute('href').substring(1);

      // Hide all tab content
      document.querySelectorAll('.tab-content').forEach(function(content) {
        content.classList.remove('active');
      });

      // Show the clicked tab content
      document.getElementById(targetId).classList.add('active');

      // Highlight the active tab
      document.querySelectorAll('.tabs-list .tab').forEach(function(tabItem) {
        tabItem.classList.remove('active');
      });

      this.parentElement.classList.add('active');
    });
  });


$(document).ready(function () {
    var $variantOptionsDiv = $(".productsize");

    if ($(".variant-option input[value='Unstich']").length > 0) {
        $variantOptionsDiv.addClass("has-unstich");
    }

    $(".mobile-menu_overlay").on("click", function () {
        $("body").removeClass("menu-mobile--open");
    });

});


